export const de = {
  admin: {
    title: "IRES Admin",
    noAvailableSections: "Für dich sind hier keine Funktionen freigegeben.",
    // A refresh failed while a cached answer was shown (AdminReadCache.ts).
    refreshFailed: "Konnte nicht aktualisiert werden: angezeigt wird der zuletzt geladene Stand.",
    // Authoring screens on a phone (PhoneEditingHint.vue).
    phoneEditingHint: "Zum Bearbeiten nimm bitte ein Tablet oder einen Laptop.",
      renoReview: {
        title: "RENO Schnellprüfung",
        filters: "Filter",
        deviceTypes: "Gerätetypen",
        startAtSerial: "Ab Gerät",
        allDeviceTypes: "Alle",
        anyDevice: "Alle",
        anyClient: "Alle",
        noClients: "Keine Mandanten gefunden",
        monthsSuffix: "Monate",
        ageOrActive: "Zeitraum / Status",
        maxAgeMonths: "Nur Trocknungen der letzten",
        fromDate: "Ab Datum",
        activeOnly: "Nur laufende Trocknungen",
        noAgeLimit: "Ohne Begrenzung",
        matchingDryings: "Passende Trocknungen",
        countCapped: "über {0}",
        countApprox: "ca. {0}",
        countNone: "keine",
        countLoading: "wird geladen …",
        alreadyReviewed: "Schon durchgesehen",
        ratingModeAll: "Alle",
        ratingModeUnrated: "Nur noch nicht bewertete",
        ratingModeOnly: "Nur von mir bewertete",
        hideSeen: "Von mir angesehene ausblenden",
        startReview: "Prüfung starten",
        noMatches: "Keine Trocknungen für diese Filter.",
        loading: "Wird geladen …",
        device: "Gerät",
        drying: "Trocknung",
        client: "Mandant",
        program: "Programm",
        dryingPosition: "Trocknung {0} von {1} an diesem Gerät",
        chainStart: "Start",
        chainEnd: "Ende",
        previous: "Zurück",
        next: "Weiter",
        atFirst: "Du bist bei der ersten Trocknung.",
        atLast: "Du hast alle Trocknungen durchgesehen.",
        backToFilters: "Filter ändern",
        startAtSerialHint: "Ab Gerät „{0}“ gibt es keine Treffer. Prüfe die Seriennummer.",
        loadFailed: "Die Trocknung konnte nicht geladen werden.",
        hidden: {
          title: "Ausgeblendete Trocknungen",
          none: "Du hast keine Trocknungen ausgeblendet.",
          hiddenAt: "Ausgeblendet am",
          restore: "Wieder anzeigen",
          restored: "Die Trocknung erscheint wieder in deiner Prüfung.",
          restoreFailed: "Die Trocknung konnte nicht wieder eingeblendet werden.",
          loadMore: "Weitere laden",
        },
        rating: {
          suppress: "Nicht mehr zeigen",
          previously: "Zuletzt von dir bewertet mit {0}.",
          suppressFailed: "Die Trocknung konnte nicht ausgeblendet werden.",
          saveFailed: "Deine Bewertung konnte nicht gespeichert werden.",
        },
        note: {
          commentPlaceholder: "Kommentar (optional)",
          chainSuspect: "Kette prüfen",
          onlyChainSuspect: "Kette prüfen",
          onlyWithComment: "Kommentar",
          saveFailed: "Dein Kommentar konnte nicht gespeichert werden.",
        },
        marks: {
          filterLabel: "Eigene Markierungen",
          onlySuppressed: "Ausgeblendet",
        },
      },
    categories: {
      clients: "Mandanten",
      production: "Produktion",
      mira: "Mira",
    },
    sections: {
      clients: {
        title: "Mandanten",
        description: "Alle Mandanten durchsuchen und nach Typ, Vertrag und Status filtern.",
      },
      externalSystems: {
        title: "Externe Systeme",
        description: "Alle ERP- und Partnersysteme mit Eigentümer, verknüpften Mandanten und Status.",
      },
      userSearch: {
        title: "Benutzer suchen",
        description: "Einen Benutzer in allen Mandanten finden: nach E-Mail-Adresse, Name, Kurzname oder Personalnummer.",
      },
      sharedUsers: {
        title: "Geteilte Benutzer",
        description: "Geteilte E-Mail-Adressen und die geteilten Benutzer der Gruppen, mit Bereinigen für veraltete Einträge.",
      },
      deviceReports: {
        title: "Testberichte",
        description: "Testberichte der Produktion zu einem Gerät ansehen.",
      },
      pdfTemplates: {
        title: "PDF-Vorlagen",
        description: "Geteilte PDF-Vorlagen, die Mandanten übernehmen können. Die Vorlagen eines Mandanten findest du in seiner Detailansicht.",
      },
      infoConfig: {
        title: "Beschreibungen",
        description: "Alle Versionen der Projektformulare, ihre Ziele und das geprüfte Veröffentlichen neuer Versionen.",
      },
      miraInsurers: {
        title: "Versicherer",
        description: "Die Versicherer, denen Mira die Projekte zuordnet, mit ihren Schreibweisen.",
      },
      miraInsurerReview: {
        title: "Nicht identifizierte Versicherer",
        description: "Versicherernamen, die Mira nicht zuordnen konnte, gruppiert zum Zuordnen.",
      },
      miraCompanies: {
        title: "Firmen",
        description: "Welche Mandanten im Marktvergleich von Mira als eine Firma zählen.",
      },
      miraExceptions: {
        title: "Mira-Ausnahmen",
        description: "Spät erfasste Abschlüsse und Freigaben, die Mira aus den Dauern herausnimmt.",
      },
    },
    externalSystems: {
      search: "Externe Systeme suchen",
      none: "Keine externen Systeme.",
      moreClients: "{0} und {1} weitere",
      filters: {
        ALL: "Alle",
      },
    },
    miraCompanies: {
      title: "Firmen",
      search: "Firma oder Mandant suchen",
      create: "Neue Firma",
      hint: "Eine Firma mit mehreren Mandanten zählt im Marktvergleich von Mira einmal, mit einem Wert über alle ihre Mandanten. Eine Gruppe (Master-Mandant) zählt schon von selbst einmal; ein Mandant in keiner Firma zählt für sich.",
      loadFailed: "Die Firmen konnten nicht geladen werden.",
      none: "Keine Firmen",
      saved: "Firma gespeichert",
      retiredChip: "Ausgemustert",
      effectNote: "Gilt für den Marktvergleich aller Mandanten ab dem nächsten nächtlichen Lauf von Mira.",
      lastChange: "zuletzt geändert am {0} von {1}",
      clientCount: "{0} Mandanten",
      moreClients: "{0} und {1} weitere",
      takenBy: "gehört schon zur Firma {0}",
      masterNote: "Master-Mandant: bringt die Mandanten seiner Gruppe mit",
      inGroup: "kommt mit dem Master-Mandanten",
      isViewingClient: "zeigt die Firma in Mira",
      viewerTakenBy: "zeigt schon die Firma {0}",
      viewingClientLine: "Ansicht in Mira: {0}",
      groupChip: "Gruppe",
      groupMembers: "Über den Master-Mandanten dabei: {0} Mandanten",
      filters: {
        ACTIVE: "Aktiv",
        RETIRED: "Ausgemustert",
        ALL: "Alle",
      },
      fields: {
        name: "Name",
        clients: "Mandanten",
        retired: "Ausgemustert",
        viewingClient: "Ansicht in Mira",
        memberGroupView: "Mandanten vergleichen sich mit der Firma",
      },
      hints: {
        clients: "Mindestens zwei, oder ein Master-Mandant allein. Ein Master-Mandant bringt die Mandanten seiner Gruppe mit; jede Gruppe ist schon von selbst eine Firma.",
        retired: "Eine ausgemusterte Firma zählt nicht mehr; ihre Mandanten zählen dann wieder für sich.",
        viewingClient: "Ein Mandant, der die Firma in Mira wie eine Gruppe zeigt. Er zählt nicht zu ihren Mandanten.",
        memberGroupView: "Jeder Mandant der Firma sieht in Mira unter \"Gruppe\" seinen Wert neben dem der ganzen Firma, wie die Mandanten einer Gruppe. Für eine Gruppe ist das von selbst an.",
      },
      fieldErrors: {
        required: "Pflichtfeld",
        clients: "Mindestens zwei Mandanten oder ein Master-Mandant",
      },
      dialog: {
        viewTitle: "Firma",
        editTitle: "Firma bearbeiten",
        createTitle: "Neue Firma",
      },
      errors: {
        NO_COMPANY: "Diese Firma gibt es nicht mehr.",
        NO_CLIENT: "Einen der Mandanten gibt es nicht mehr.",
        CHANGED_MEANWHILE: "Die Firma wurde inzwischen geändert. Die Liste wird neu geladen.",
        INVALID_NAME: "Der Name ist ein Pflichtfeld.",
        INVALID_ACCOUNTS: "Wähle mindestens zwei Mandanten oder einen Master-Mandanten.",
        CONFLICT: "{0} gehört schon zu einer anderen Firma.",
        INVALID_VIEWER: "Den Mandanten für die Ansicht gibt es nicht mehr.",
        VIEWER_IS_ACCOUNT: "Der Mandant für die Ansicht darf nicht zu den Mandanten der Firma gehören.",
        VIEWER_IS_GROUP: "Ein Master-Mandant mit eigener Gruppe kann keine Firma zeigen.",
        VIEWER_TAKEN: "Dieser Mandant zeigt schon die Firma {0}.",
        FAILED: "Speichern fehlgeschlagen.",
      },
    },
    miraExceptions: {
      title: "Mira-Ausnahmen",
      search: "Mandant oder Grund suchen",
      create: "Neue Ausnahme",
      hint: "Hat ein Mandant ein Ereignis nachträglich erfasst (zum Beispiel Freigaben gesammelt nachgetragen oder alte Projekte auf einmal abgeschlossen), nimmt Mira diese Projekte aus den Dauern, die auf dem Ereignis beruhen, und nennt ihre Zahl auf der Kachel. Zählungen bleiben unverändert.",
      loadFailed: "Die Ausnahmen konnten nicht geladen werden.",
      none: "Keine Ausnahmen",
      saved: "Ausnahme gespeichert",
      retiredChip: "Ausgemustert",
      effectNote: "Gilt für die Kennzahlen dieses Mandanten (und seiner Gruppe oder Firma) ab dem nächsten nächtlichen Lauf von Mira.",
      lastChange: "zuletzt geändert am {0} von {1}",
      filters: {
        ACTIVE: "Aktiv",
        RETIRED: "Ausgemustert",
        ALL: "Alle",
      },
      columns: {
        range: "Zeitraum",
      },
      fields: {
        client: "Mandant",
        event: "Nachträglich erfasst",
        from: "Von",
        to: "Bis",
        reason: "Grund",
        retired: "Ausgemustert",
      },
      events: {
        PROJECT_END: "Projektabschluss",
        OFFER_ANSWER: "Freigabe (Antwort der Versicherung)",
      },
      eventFigures: {
        PROJECT_END: "Nimmt die Projekte, die im Zeitraum nach mindestens 30 Tagen ohne erfasste Arbeit abgeschlossen wurden, aus Ø Projektdauer und Bis Projektabschluss, samt einer beim Abschluss erfassten Freigabe.",
        OFFER_ANSWER: "Nimmt Freigaben, die im Zeitraum beim Projektabschluss erfasst wurden (bei getrockneten oder länger ruhenden Projekten), aus Freigabedauer, Schadenaufnahme bis Freigabe und Freigabe bis Trocknungs- / Wiederherstellungsbeginn.",
      },
      hints: {
        reason: "Nur im IRES Admin Client sichtbar.",
        retired: "Eine ausgemusterte Ausnahme gilt nicht mehr; die Projekte zählen dann wieder mit.",
      },
      fieldErrors: {
        required: "Pflichtfeld",
        range: "Das Ende liegt vor dem Anfang.",
      },
      dialog: {
        viewTitle: "Mira-Ausnahme",
        editTitle: "Mira-Ausnahme bearbeiten",
        createTitle: "Neue Mira-Ausnahme",
      },
      suggestions: {
        title: "Vorschläge von Mira",
        hint: "Tage, an denen ein Mandant viele Abschlüsse oder Freigaben nachträglich erfasst hat, gefunden in Miras nächtlichem Lauf. Übernehmen legt daraus eine Ausnahme an, Verwerfen blendet den Vorschlag aus.",
        entriesTitle: "Ausnahmen",
        takeOver: "Übernehmen",
        dismissAction: "Verwerfen",
        dismissed: "Vorschlag verworfen",
        groupCount: "{0} Vorschlag | {0} Vorschläge",
        columns: {
          late: "Nachträglich / gesamt",
          mean: "Ø mit → ohne",
          median: "Median mit → ohne",
        },
        eventsShort: {
          PROJECT_END: "Projektabschluss",
          OFFER_ANSWER: "Freigabe",
        },
        change: "{0} → {1} Tage",
        figure: {
          PROJECT_END: "Projektdauer {0}: Ø {1} Tage, ohne diese Abschlüsse {2} Tage (Median {3} → {4})",
          OFFER_ANSWER: "Freigabedauer {0}: Ø {1} Tage, ohne diese Freigaben {2} Tage (Median {3} → {4})",
        },
        dismiss: {
          title: "Vorschlag verwerfen",
          action: "Verwerfen",
          reason: "Grund",
        },
        errors: {
          NO_SUGGESTION: "Diesen Vorschlag gibt es nicht mehr. Die Liste wird neu geladen.",
          CHANGED_MEANWHILE: "Der Vorschlag wurde inzwischen geändert. Die Liste wird neu geladen.",
          INVALID_REASON: "Gib einen Grund an.",
          FAILED: "Verwerfen fehlgeschlagen.",
        },
      },
      errors: {
        NO_EXCEPTION: "Diese Ausnahme gibt es nicht mehr.",
        NO_CLIENT: "Diesen Mandanten gibt es nicht.",
        CHANGED_MEANWHILE: "Die Ausnahme wurde inzwischen geändert. Die Liste wird neu geladen.",
        INVALID_EVENT: "Wähle, was nachträglich erfasst wurde.",
        INVALID_RANGE: "Der Zeitraum ist ungültig.",
        INVALID_REASON: "Gib einen Grund an.",
        FAILED: "Speichern fehlgeschlagen.",
      },
    },
    miraInsurers: {
      title: "Versicherer",
      search: "Versicherer suchen",
      create: "Neuer Versicherer",
      loadFailed: "Die Versicherer konnten nicht geladen werden.",
      none: "Keine Versicherer",
      saved: "Versicherer gespeichert",
      retiredChip: "Ausgemustert",
      effectNote: "Gilt für die Versicherer-Kennzahlen aller Mandanten ab dem nächsten nächtlichen Lauf von Mira.",
      mdisKey: "MDIS-Schlüssel: {0}",
      lastChange: "zuletzt geändert am {0} von {1}",
      filters: {
        ACTIVE: "Aktiv",
        RETIRED: "Ausgemustert",
        ALL: "Alle",
      },
      columns: {
        origin: "Herkunft",
        spellings: "Schreibweisen",
      },
      origins: {
        MDIS: "Aus der Versichererliste von MDIS",
        IRES: "Von IRES angelegt",
      },
      originsShort: {
        MDIS: "MDIS",
        IRES: "IRES",
      },
      fields: {
        key: "Schlüssel",
        shortName: "Kurzname",
        name: "Name",
        spellings: "Weitere Schreibweisen",
        words: "Erkennungswörter",
        retired: "Ausgemustert",
      },
      hints: {
        key: "2 bis 12 Großbuchstaben oder Ziffern. Du kannst ihn jederzeit ändern, Miras Zahlen bleiben gleich.",
        spellings: "Eine je Zeile. Groß- / Kleinschreibung, Umlaute und Satzzeichen spielen keine Rolle.",
        words: "Eines je Zeile, ab drei Zeichen: erkennt den Versicherer überall, wo das Wort im Namen steht.",
        retired: "Ein ausgemusterter Versicherer erkennt nichts mehr; seine Projekte gelten dann als nicht identifiziert.",
      },
      fieldErrors: {
        key: "2 bis 12 Großbuchstaben oder Ziffern",
        required: "Pflichtfeld",
      },
      dialog: {
        viewTitle: "Versicherer",
        editTitle: "Versicherer bearbeiten",
        createTitle: "Neuer Versicherer",
      },
      errors: {
        KEY_TAKEN: "Diesen Schlüssel gibt es schon.",
        NO_INSURER: "Diesen Versicherer gibt es nicht oder er ist ausgemustert.",
        CHANGED_MEANWHILE: "Der Versicherer wurde inzwischen geändert. Die Liste wird neu geladen.",
        INVALID_KEY: "Der Schlüssel ist ungültig.",
        INVALID_NAME: "Kurzname und Name sind Pflichtfelder.",
        INVALID_SPELLINGS: "Die Schreibweisen sind ungültig.",
        INVALID_TEXTS: "Wähle mindestens eine Schreibweise.",
        INVALID_MERGE: "Ein Versicherer kann nicht in sich selbst aufgehen.",
        CONFLICT: "„{0}“ würde zu mehreren Versicherern gehören ({1}).",
        CONFLICT_NOT_INSURER: "„{0}“ kann nicht zugleich zu {1} gehören und als „Kein Versicherer“ gelten.",
        FAILED: "Speichern fehlgeschlagen.",
      },
      rowActions: "Aktionen",
      mergedInto: "Zusammengeführt in {0}",
      move: {
        menu: "Schreibweisen verschieben",
        title: "Schreibweisen von {0} verschieben",
        spellings: "Schreibweisen",
        words: "Erkennungswörter",
        toInsurer: "Zu einem anderen Versicherer",
        toNewInsurer: "Zu einem neuen Versicherer",
        notInsurer: "Kein Versicherer",
        release: "Wieder offen (nicht identifiziert)",
        insurer: "Versicherer",
        action: "Verschieben",
        done: "Verschoben",
        effectInsurer: "Gilt für alle Mandanten: ab dem nächsten nächtlichen Lauf zählen die Projekte mit diesen Schreibweisen nicht mehr zu {0}, sondern zu {1}.",
        effectNotInsurer: "Gilt für alle Mandanten: ab dem nächsten nächtlichen Lauf zählen die Projekte mit diesen Schreibweisen nicht mehr zu {0}, sondern als „Kein Versicherer“.",
        effectRelease: "Gilt für alle Mandanten: ab dem nächsten nächtlichen Lauf zählen die Projekte mit diesen Schreibweisen nicht mehr zu {0}, sondern als nicht identifiziert. Unter Nicht identifizierte Versicherer erscheinen sie erst nach diesem Lauf.",
      },
      merge: {
        menu: "Zusammenführen",
        title: "Versicherer zusammenführen",
        intro: "{0} ({1}) geht in einem anderen Versicherer auf.",
        into: "Zusammenführen mit",
        action: "Zusammenführen",
        done: "Zusammengeführt",
        effect: "Gilt für alle Mandanten: {0} wird ausgemustert. Seine Namen, Schlüssel, Schreibweisen und Erkennungswörter gehören dann zu {1}, und seine Projekte zählen ab dem nächsten nächtlichen Lauf für {1}.",
      },
    },
    miraInsurerReview: {
      title: "Nicht identifizierte Versicherer",
      search: "Schreibweise suchen",
      loadedAt: "Stand: {0}",
      suggestionsAt: "Vorschläge vom {0}",
      loadFailed: "Die Liste konnte nicht geladen werden.",
      views: {
        OPEN: "Offen",
        SUGGESTED: "Mit Vorschlag",
        NOT_INSURER: "Kein Versicherer",
      },
      headings: {
        OPEN: "Gruppen",
        SUGGESTED: "Gruppen mit Vorschlag",
        NOT_INSURER: "Kein Versicherer",
      },
      hints: {
        OPEN: "Die Namen, die Mira beim letzten nächtlichen Lauf keinem Versicherer zuordnen konnte, gruppiert, die größten zuerst. Eine Entscheidung gilt in Mira ab dem nächsten Lauf.",
        SUGGESTED: "Gruppen, für die Mira einen Vorschlag hat. Mit dem Haken öffnest du den Dialog schon ausgefüllt, gespeichert wird erst mit seinem Button. Mit dem Kreuz verwirfst du den Vorschlag.",
        NOT_INSURER: "Schreibweisen, die als „Kein Versicherer“ entschieden sind. Sie zählen in Mira weder als erkannt noch als nicht identifiziert.",
      },
      none: {
        OPEN: "Keine offenen Gruppen",
        SUGGESTED: "Keine offenen Vorschläge",
        NOT_INSURER: "Noch keine Schreibweise als „Kein Versicherer“ entschieden",
      },
      columns: {
        spellings: "Schreibweisen",
        projects: "Projekte",
        clients: "Mandanten",
      },
      moreSpellings: "{0} und {1} weitere",
      droppedTexts: "{0} selten genutzte Schreibweisen passten nicht in die Liste und fehlen hier.",
      release: "Zurücknehmen",
      releaseConfirm: {
        title: "Entscheidung zurücknehmen",
        message: "„{0}“ gilt dann ab dem nächsten Lauf von Mira wieder als nicht identifiziert.",
      },
      released: "Entscheidung zurückgenommen",
      decided: "Entschieden",
      decision: {
        title: "Gruppe zuordnen",
        spellings: "Schreibweisen",
        spellingWithCount: "{0} (ein Projekt) | {0} ({1} Projekte)",
        toInsurer: "Einem Versicherer zuordnen",
        toNewInsurer: "Einem neuen Versicherer zuordnen",
        notInsurer: "Kein Versicherer (unbekannt, Makler, Bank, Test …)",
        insurer: "Versicherer",
        apply: "Zuordnen",
        next: "Weiter",
        nextNewInsurer: "Im nächsten Schritt legst du den Versicherer an. Die Schreibweisen sind dort schon eingetragen.",
        effectInsurer: "Gilt für alle Mandanten: ab dem nächsten nächtlichen Lauf zählen die Projekte mit diesen Schreibweisen zu {0}.",
        effectNotInsurer: "Gilt für alle Mandanten: ab dem nächsten nächtlichen Lauf zählen die Projekte mit diesen Schreibweisen als „Kein Versicherer“ und nicht mehr zur Zuordnungsquote.",
      },
      suggestion: {
        insurer: "Vorschlag: {0} ({1})",
        newInsurer: "Vorschlag: neuer Versicherer {0} ({1})",
        notInsurer: "Vorschlag: Kein Versicherer",
        unsure: "unsicher",
        takeOver: "Übernehmen",
        dismissAction: "Verwerfen",
        dismissed: "Vorschlag verworfen",
        dismiss: {
          title: "Vorschlag verwerfen",
          action: "Verwerfen",
          reason: "Grund",
        },
        errors: {
          NO_SUGGESTION: "Diesen Vorschlag gibt es nicht mehr. Die Liste wird neu geladen.",
          CHANGED_MEANWHILE: "Die Vorschläge wurden inzwischen neu eingelesen. Die Liste wird neu geladen.",
          INVALID_REASON: "Gib einen Grund an.",
          FAILED: "Verwerfen fehlgeschlagen.",
        },
      },
    },
    clients: {
      title: "Mandanten",
      counts: {
        all: "Mandanten",
      },
      search: "Name, Kürzel oder Mandantennummer",
      masterClient: "Master",
      helperFunctions: {
        recalculateAllDryings: {
          button: "Alle Trocknungen neu berechnen",
          description: "Berechnet für alle Trocknungen dieses Mandanten die ASSIST-Vorhersagen mit dem neuesten Modell neu.",
          confirmTitle: "Alle Trocknungen neu berechnen?",
          confirmMessage: "Für alle Trocknungen dieses Mandanten werden die ASSIST-Vorhersagen mit dem neuesten Modell neu berechnet. Das kann eine Weile dauern.",
          confirmAccept: "Neu berechnen",
          started: "Die Neuberechnung wurde gestartet.",
          alreadyRunning: "Eine Neuberechnung läuft bereits.",
          noOp: "Es wurde keine Neuberechnung gestartet (die Funktion ist für diesen Mandanten möglicherweise nicht aktiviert).",
          error: "Fehler beim Starten der Neuberechnung: {0}",
          failed: "Die Neuberechnung konnte nicht gestartet werden.",
          statusStarted: "Gestartet",
          statusAlreadyRunning: "Läuft bereits",
          statusNoOp: "Nichts zu tun",
          refusals: {
            INVALID: "Die Neuberechnung konnte nicht gestartet werden.",
            NO_CLIENT: "Diesen Mandanten gibt es nicht mehr.",
            DELETED_CLIENT: "Für einen gelöschten Mandanten kann nichts neu berechnet werden.",
            SHARED_LOGIN: "Mit dem gemeinsamen IRES-Admin-Login kann nichts geändert werden. Melde dich mit deinem eigenen Benutzer an.",
            PERMISSION_DENIED: "Dir fehlt die Berechtigung dafür.",
          },
        },
      },
      changes: {
        title: "Verlauf",
        loadFailed: "Der Verlauf konnte nicht geladen werden.",
        none: "Im IRES Admin Client wurde an diesem Mandanten noch nichts geändert.",
        showMore: "Weitere anzeigen",
        followsGlobalTarget: "Globale Version",
        everyProjectType: "Alle Projekttypen der Produkte",
        filters: {
          CLIENT_LOGIN: "Anmeldungen als Mandant",
        },
        groups: {
          INFO_CONFIG_TARGET: "Beschreibung",
          CLIENT_LOGIN: "Als Mandant angemeldet",
          CREATED: "Angelegt",
          SHARED_EMAIL_ADDRESS: "E-Mail-Adresse teilen bereinigt",
        },
        fields: {
          membersAdded: "Mitglieder hinzugefügt",
          membersRemoved: "Mitglieder entfernt",
          serviceContractSince: "Servicevertrag FW / Config seit",
          warrantyExtensionSince: "Garantieverlängerung Panels seit",
          allowedProjectTypeIds: "Projekttypen (IRES)",
          activeProjectTypeIds: "Aktiv beim Mandanten",
          enabledFunctions: "Funktionen eingeschaltet",
          sharedEmailAddress: "E-Mail-Adresse",
          sharedEmailAddressUsersRemoved: "Entfernte Benutzer",
          sharedEmailAddressDeleted: "Eintrag gelöscht",
        },
      },
      contracts: {
        editTitle: "Verträge bearbeiten",
        since: "Seit",
        saved: "Verträge gespeichert.",
        saveFailed: "Die Verträge konnten nicht gespeichert werden.",
      },
      testSettings: {
        editTitle: "Test bearbeiten",
        saved: "Test gespeichert.",
        saveFailed: "Der Test konnte nicht gespeichert werden.",
        usersLoadFailed: "Die Benutzer konnten nicht geladen werden.",
        errors: {
          UNKNOWN_TEST_USER: "Ein gewählter Testbenutzer ist kein aktiver Benutzer dieses Mandanten.",
        },
      },
      masterData: {
        clientName: "Name",
        houseNumber: "Hausnummer",
        editTitle: "Stammdaten bearbeiten",
        projectNumberPrefixKept: "Das Kürzel ist nur eine Bezeichnung: Die IRES-Projektnummern dieses Mandanten beginnen weiter mit {0}.",
        iresTypeWarning: "Ein Mandant vom Kundentyp IRES hat Zugriff auf die Daten aller Mandanten. Ändere den Kundentyp nur, wenn das gewollt ist.",
        saved: "Stammdaten gespeichert.",
        fieldErrors: {
          required: "Pflichtfeld",
          tooLong: "Höchstens 100 Zeichen",
          prefixLength: "Genau 4 Zeichen",
        },
        errors: {
          CHANGED_MEANWHILE: "Der Mandant wurde inzwischen geändert. Die aktuellen Daten sind neu geladen, bitte ändere sie erneut.",
          PREFIX_TAKEN: "Dieses Mandantenkürzel hat schon ein anderer Mandant.",
          INVALID_VALUE: "Ein Feld ist ungültig.",
          NO_CLIENT: "Diesen Mandanten gibt es nicht mehr.",
          FAILED: "Die Stammdaten konnten nicht gespeichert werden.",
        },
      },
      group: {
        editTitle: "Gruppe bearbeiten",
        hasMembersHint: "Ein MASTER-Mandant mit Mitgliedern bleibt einer, bis du alle Mitglieder entfernt hast.",
        clientsLoadFailed: "Die Mandanten konnten nicht geladen werden.",
        inactive: "(inaktiv)",
        deleted: "(gelöscht)",
        thisClient: "dieser Mandant",
        overwriteTitle: "Einstellungen überschreiben?",
        overwriteMessage: "Die Einstellungen von {0} ersetzen alle Einstellungen dieses MASTER-Mandanten.",
        overwriteAccept: "Überschreiben",
        saved: "Gruppe gespeichert.",
        saveFailed: "Die Gruppe konnte nicht gespeichert werden.",
        migrateSharedUsers: "Geteilte Benutzer migrieren",
        migrateSharedUsersMessage: "Die geteilten E-Mail-Adressen der Gruppe werden zu geteilten Benutzern der Gruppe. Das kann nicht rückgängig gemacht werden.",
        migrateSharedUsersAccept: "Migrieren",
        migratedSharedUsers: "{0} geteilte Benutzer migriert.",
        noSharedUsersToMigrate: "Alle geteilten Benutzer sind bereits migriert, oder es gibt keine.",
        migrateSharedUsersFailed: "Die geteilten Benutzer konnten nicht migriert werden.",
        refusals: {
          INVALID: "Die Gruppe konnte nicht gespeichert werden.",
          NO_CLIENT: "Diesen Mandanten gibt es nicht mehr.",
          DELETED_CLIENT: "Die Gruppe eines gelöschten Mandanten kann nicht geändert werden.",
          CHANGED_MEANWHILE: "Die Gruppe wurde inzwischen geändert. Die Ansicht wurde neu geladen.",
          IS_MEMBER: "Ein Mitglied einer Gruppe kann kein MASTER-Mandant werden.",
          HAS_MEMBERS: "Entferne zuerst alle Mitglieder.",
          NOT_A_CANDIDATE: "Diese Mandanten können nicht Mitglied werden: {0}",
          NOT_A_MEMBER: "Einstellungen können nur von einem Mitglied übernommen werden.",
          DUPLICATE_BRANCH_NUMBERS: "Die Niederlassungsnummer {0} kommt bei {1} und bei {2} vor.",
          SHARED_LOGIN: "Mit dem gemeinsamen IRES-Admin-Login kann nichts geändert werden. Melde dich mit deinem eigenen Benutzer an.",
        },
      },
      products: {
        editTitle: "Produkte bearbeiten",
        saved: "Produkte gespeichert.",
        saveFailed: "Die Produkte konnten nicht gespeichert werden.",
        saveWarning: "Beim Speichern wird die Produktwahl (alt) aktualisiert, die IRES Project, IRES Work und IRES Office lesen, und die Lizenzen werden neu berechnet.",
        derivedCaption: "Noch aus der Produktwahl abgeleitet und noch nicht gespeichert.",
        choices: {
          DEVICES_ONLY_WEBSITE: "Geräteportal",
          WEBSITE: "Projektportal",
          DEFAULT: "Projektmanager",
          PROJECT_OPTION: "Projektoption",
        },
        explanations: {
          officeDeviceAssignment: "GZ- und GL-Projekte in IRES Office. IRES Office selbst ist immer verfügbar.",
          project: "Projektverwaltung mit IRES Project.",
          work: "Gerätemanagement in der IRES Work App. Ohne IRES Work kann sich niemand des Mandanten in IRES Work anmelden.",
          interface: "REST-Schnittstelle zu einem Fremdsystem.",
        },
        errors: {
          CHANGED_MEANWHILE: "Die Produkte wurden inzwischen geändert. Die Ansicht wurde neu geladen.",
          INVALID_CLIENT: "Dieser Mandant kann keine Produkte haben.",
          INVALID: "Ungültige Produktauswahl.",
          NO_CLIENT: "Diesen Mandanten gibt es nicht mehr.",
          DELETED_CLIENT: "Die Produkte eines gelöschten Mandanten können nicht geändert werden.",
          SHARED_LOGIN: "Mit dem gemeinsamen IRES-Admin-Login kann nichts geändert werden. Melde dich mit deinem eigenen Benutzer an.",
          FAILED: "Die Produkte konnten nicht gespeichert werden.",
        },
      },
      projectTypes: {
        editTitle: "Projekttypen bearbeiten",
        explanation: "Welche Projekttypen seiner Produkte der Mandant bekommt. Abgewählte Typen bieten IRES Office, IRES Project, IRES Work und die Schnittstellen nicht mehr an.",
        notRestricted: "Nicht eingeschränkt: Der Mandant bekommt jeden Projekttyp seiner Produkte.",
        followsMaster: "Festgelegt beim MASTER-Mandanten",
        activeInClientTable: "beim Mandanten aktiv",
        inactiveInClientTable: "beim Mandanten nicht aktiv",
        atLeastOne: "Wähle mindestens einen Projekttyp.",
        withdrawWarning: "Beim Speichern wird jeder abgewählte Projekttyp in den möglichen Projekttypen des Mandanten ausgeschaltet, damit ihn keine App mehr anbietet. Bestehende Projekte bleiben, wie sie sind.",
        withdrawWarningMaster: "Das gilt auch für die Mitglieder, die die Projekteinstellungen dieses MASTER-Mandanten nutzen.",
        allowNote: "Der Mandant kann einen neuen Projekttyp danach unter Einstellungen Projektbearbeitung einschalten.",
        saved: "Projekttypen gespeichert.",
        errors: {
          CHANGED_MEANWHILE: "Die Projekttypen wurden inzwischen geändert. Die Ansicht wurde neu geladen.",
          INVALID_CLIENT: "Dieser Mandant kann keine Projekttypen haben.",
          INVALID: "Ungültige Auswahl der Projekttypen.",
          EMPTY: "Wähle mindestens einen Projekttyp.",
          NO_CLIENT: "Diesen Mandanten gibt es nicht mehr.",
          DELETED_CLIENT: "Die Projekttypen eines gelöschten Mandanten können nicht geändert werden.",
          FOLLOWS_MASTER: "Dieser Mandant nutzt die Projekteinstellungen seines MASTER-Mandanten. Ändere die Projekttypen dort.",
          SHARED_LOGIN: "Mit dem gemeinsamen IRES-Admin-Login kann nichts geändert werden. Melde dich mit deinem eigenen Benutzer an.",
          FAILED: "Die Projekttypen konnten nicht gespeichert werden.",
        },
      },
      projectOrganisation: {
        editTitle: "Projektorganisation bearbeiten",
        followsMaster: "Festgelegt beim MASTER-Mandanten",
        notStored: "Nicht gespeichert: Die Apps nutzen ihre Voreinstellung, wie sie hier steht.",
        reachNote: "Gilt nach dem Sichern in IRES Office, IRES Project, IRES Work und der Schnittstelle.",
        reachNoteMaster: "Das gilt auch für die Mitglieder, die die Projekteinstellungen dieses MASTER-Mandanten nutzen.",
        saved: "Projektorganisation gespeichert.",
        errors: {
          CHANGED_MEANWHILE: "Die Projektorganisation wurde inzwischen geändert. Die Ansicht wurde neu geladen.",
          INVALID_CLIENT: "Dieser Mandant kann keine Projektorganisation haben.",
          INVALID: "Ungültige Auswahl. Termine und Projektabschluss brauchen mindestens eine App.",
          NO_CLIENT: "Diesen Mandanten gibt es nicht mehr.",
          DELETED_CLIENT: "Die Projektorganisation eines gelöschten Mandanten kann nicht geändert werden.",
          FOLLOWS_MASTER: "Dieser Mandant nutzt die Projekteinstellungen seines MASTER-Mandanten. Ändere die Projektorganisation dort.",
          NO_PROJECTS: "Die Produkte dieses Mandanten enthalten keine Projekte.",
          SHARED_LOGIN: "Mit dem gemeinsamen IRES-Admin-Login kann nichts geändert werden. Melde dich mit deinem eigenen Benutzer an.",
          FAILED: "Die Projektorganisation konnte nicht gespeichert werden.",
        },
      },
      systemConfiguration: {
        editTitle: "Systemkonfiguration bearbeiten",
        followsMaster: "Festgelegt beim MASTER-Mandanten",
        notStored: "Nicht gespeichert: IRES Office nutzt die älteren Einstellungen des Mandanten, wie sie hier stehen.",
        reachNote: "Gilt nach dem Sichern für alle Benutzer dieses Mandanten.",
        reachNoteMaster: "Das gilt auch für die Mitglieder, die die Systemkonfiguration dieses MASTER-Mandanten nutzen.",
        saved: "Systemkonfiguration gespeichert.",
        assistScope: "ASSIST-Umfang",
        effectsFailed: "Gespeichert, aber was die Änderung auslöst (Fahrzeuge, Adressen geocodieren, ASSIST), ist fehlgeschlagen. Bitte melde das.",
        errors: {
          CHANGED_MEANWHILE: "Die Systemkonfiguration wurde inzwischen geändert. Die Ansicht wurde neu geladen.",
          INVALID_CLIENT: "Dieser Mandant kann keine Systemkonfiguration haben.",
          INVALID: "Ungültige Auswahl. „Tracking“ braucht „Karte“, „Geräteverwaltung im Cockpit anzeigen“ braucht „Alle Geräte verwalten“.",
          NO_CLIENT: "Diesen Mandanten gibt es nicht mehr.",
          DELETED_CLIENT: "Die Systemkonfiguration eines gelöschten Mandanten kann nicht geändert werden.",
          FOLLOWS_MASTER: "Dieser Mandant nutzt die Systemkonfiguration seines MASTER-Mandanten. Ändere sie dort.",
          SHARED_LOGIN: "Mit dem gemeinsamen IRES-Admin-Login kann nichts geändert werden. Melde dich mit deinem eigenen Benutzer an.",
          FAILED: "Die Systemkonfiguration konnte nicht gespeichert werden.",
        },
      },
      setup: {
        title: "Neuer Mandant",
        loadFailed: "Die Einrichtung konnte nicht geladen werden.",
        externalSystems: {
          explanation: "Mit API kann der Mandant gleich ein externes System bekommen, etwa sein ERP. Es bekommt nichts, bis IRES es freischaltet, und startet in Einrichtung. Sein Passwort wird nach dem Anlegen einmal angezeigt. Kontaktpersonen und weitere Systeme kommen später auf der Seite des Systems dazu.",
          create: "Externes System anlegen",
          memberExplanation: "Ein Mitglied nutzt die externen Systeme seines MASTER-Mandanten. Ein angehaktes System erreicht danach die Projekte dieses Mandanten.",
          masterHasNone: "Der MASTER-Mandant hat keine externen Systeme.",
          system: "Externes System",
          linked: "Verknüpfte Systeme",
          none: "Keins",
          sameAsClient: "Das System braucht eine eigene Adresse, nicht die des Mandanten.",
        },
        steps: {
          masterData: "Mandant",
          products: "Produkte",
          projectTypes: "Projekttypen",
          projectOrganisation: "Projektorganisation",
          functions: "Funktionen",
          licences: "Lizenzen",
          contracts: "Verträge und Geräte",
          users: "Benutzer",
          externalSystems: "Externe Systeme",
          summary: "Zusammenfassung",
        },
        next: "Weiter",
        create: "Anlegen",
        change: "Ändern",
        created: "Mandant angelegt.",
        createWarning: "ANLEGEN legt den Mandanten mit allem hier Gezeigten an. Er kann sich danach sofort anmelden.",
        signInEmail: "E-Mail-Adresse (Anmeldung)",
        signInPassword: "Passwort (Anmeldung)",
        passwordTooShort: "Mindestens {0} Zeichen",
        address: "Adresse",
        followsMaster: "wie beim MASTER-Mandanten",
        followsMasterExplanation: "Als Mitglied nutzt der Mandant die Einstellungen seines MASTER-Mandanten {0}.",
        noProjects: "Ohne IRES Project, IRES Work oder IRES Office (GZ / GL) gibt es hier nichts festzulegen.",
        organisationRequired: "Wähle mindestens eine App.",
        group: {
          kinds: {
            STANDALONE: "Eigenständig",
            MEMBER: "Mitglied eines MASTER-Mandanten",
            MASTER: "Neuer MASTER-Mandant",
          },
          master: "MASTER-Mandant",
          masterRequired: "Wähle den MASTER-Mandanten.",
          memberHint: "Ein Mitglied übernimmt Projekttypen, Projektorganisation, Funktionen, Verträge und Geräte seines MASTER-Mandanten. Seine Lizenzen sind seine eigenen.",
          memberOf: "Mitglied von {0}",
        },
        products: {
          officeAlways: "IRES Office mit dem HyDry-Gerätemanagement ist immer dabei.",
          officeOnly: "Nur IRES Office (HyDry-Geräte)",
        },
        functions: {
          enabled: "Eingeschaltet",
          personalChat: "Persönlicher Chat",
          projectChat: "Projekt-Chat",
        },
        licences: {
          explanation: "Die gekauften Lizenzen für die gewählten Produkte. Später änderst du sie in IRES Admin.",
          noneNeeded: "Die gewählten Produkte brauchen keine Lizenzen.",
          invalid: "Eine ganze Zahl von 0 bis {0}",
        },
        contracts: {
          devices: "Geräte",
          updateFirmwareViaIot: "Firmwareupdate IPU E-G via IOT",
          updateConfigViaIot: "Konfigupdate via IOT",
          conditions: {
            ALWAYS: "Immer",
            NEVER: "Nie",
            WHEN_IDLE_OR_AFTER_POWER_ON: "Panel Idle / Hochgefahren",
          },
          yesSince: "Ja, seit {0}",
          followsFleet: "wie die Flotte",
          followsFleetExplanation: "Der Mandant folgt den Zielversionen der Flotte. Eigene Zielversionen legst du später in IRES Admin fest.",
        },
        users: {
          iresAdminExplanation: "Der IRES-Admin-Benutzer wird immer angelegt: Mit ihm öffnet „Als Mandant anmelden“ den Mandanten.",
          createFirstUser: "Ersten Benutzer des Mandanten anlegen",
          role: "Rolle: {0}",
          iresAdmin: "IRES-Admin-Benutzer",
          iresAdminAlways: "Wird angelegt",
          firstUser: "Erster Benutzer",
          noFirstUser: "Keiner, später unter Benutzer",
        },
        errors: {
          INVALID: "Eine Angabe ist ungültig. Prüfe die Schritte.",
          NOT_A_MASTER: "Der gewählte Mandant ist kein MASTER-Mandant (mehr).",
          PROJECT_TYPES_EMPTY: "Wähle mindestens einen Projekttyp.",
          TRACKING_WITHOUT_MAP: "Tracking braucht Karte.",
          TILE_WITHOUT_ALL_DEVICES: "Geräteverwaltung im Cockpit braucht Alle Geräte verwalten.",
          NICKNAME_TAKEN: "Diesen Kurznamen gibt es schon.",
          STAFF_NUMBER_TAKEN: "Diese Personalnummer gibt es schon.",
          PREFIX_TAKEN: "Dieses Mandantenkürzel hat schon ein anderer Mandant.",
          EMAIL_TAKEN: "Mit dieser E-Mail-Adresse meldet sich schon ein anderer Mandant an.",
          USER_EMAIL_TAKEN: "Diese E-Mail-Adresse hat schon ein anderer Benutzer.",
          IRES_ADMIN_EMAIL_TAKEN: "Für dieses Mandantenkürzel ist keine Adresse für den IRES-Admin-Benutzer frei. Wähle ein anderes Kürzel.",
          EXTERNAL_SYSTEM_EMAIL_TAKEN: "Mit dieser Adresse gibt es schon ein Konto. Wähle für das externe System eine andere.",
          NOT_THE_MASTERS_SYSTEM: "Ein gewähltes System gehört nicht mehr zum MASTER-Mandanten. Wähle die Systeme neu.",
          SHARED_LOGIN: "Mit dem gemeinsamen IRES-Admin-Login kann nichts geändert werden. Melde dich mit deinem eigenen Benutzer an.",
          FAILED: "Der Mandant konnte nicht angelegt werden.",
        },
      },
      partners: {
        title: "Externe Systeme",
        loadFailed: "Die externen Systeme konnten nicht geladen werden.",
        none: "Kein externes System verbunden.",
        viaMaster: "über den MASTER-Mandanten",
        editOnOwner: "Dieses externe System gehört zum MASTER-Mandanten und wird dort geändert.",
        partner: "Externes System",
        saved: "Gespeichert.",
        noAddress: "Keine (IRES sendet nichts)",
        defaultEndpoint: "Standard: {0}",
        endpointLabel: "{0} (leer: {1})",
        byRoute: "Nur bei Aufrufen über EasyTec",
        statuses: {
          SETUP: "Einrichtung",
          TEST: "Test",
          LIVE: "Live",
          PAUSED: "Pausiert",
        },
        statusDescriptions: {
          SETUP: "Die Verbindung wird eingerichtet.",
          TEST: "Die Verbindung wird mit dem System getestet.",
          LIVE: "Projekte werden mit dem System ausgetauscht.",
          PAUSED: "IRES sendet dem System nichts; was anfällt, geht beim Fortsetzen raus. Das System kann IRES weiter aufrufen.",
        },
        systems: {
          EASY_TEC: "Komplette Schrittliste (EasyTec)",
          EXTERNAL: "Ein Schritt nach dem anderen (IRES-API)",
          NONE: "Keine (nur eingehend)",
        },
        signIn: {
          API_KEY: "API-Schlüssel",
          SIGN_IN: "E-Mail-Adresse und Passwort",
          EASY_TEC: "EasyTec-Anmeldung (Mandant und Passwort)",
          NONE: "Keine (IRES sendet nichts)",
        },
        fields: {
          integrationStatus: "Status",
          baseUrl: "Basis-URL",
          signIn: "IRES meldet sich an mit",
          system: "Schrittübertragung",
        },
        endpoints: {
          createProject: "Neues Projekt",
          projectData: "Projektdaten",
          projectStatus: "Status",
          noteUpdate: "Notizen",
        },
        accepts: {
          acceptsNewProjects: "Neue Projekte",
          acceptsProjectDataUpdates: "Projektdaten",
          acceptsProjectStatusUpdates: "Status",
          acceptsNotes: "Notizen",
          includeProjectOwnersInfo: "Projektverantwortliche",
          sendsExtraPhaseData: "Zusatzdaten der Phasen",
        },
        behaviour: {
          appointmentFieldSwap: "Zuordnung Termin / Begonnen anwenden",
          incomingContactPerson0: "Ansprechpartner 0 erzwingen",
          sendsLatestProjectStatus: "Neuesten Projektstatus mitsenden",
          isTestSystem: "Testsystem (Projektnummern getauscht)",
        },
        cards: {
          status: "Status",
          connection: "Verbindung",
          accepts: "Was {0} bekommt",
          behaviour: "Verhalten",
        },
        changeGroups: {
          created: "Externes System angelegt",
          password: "Neues Passwort",
          accepts: "Was das System bekommt",
          credentials: "Anmeldedaten",
        },
        contacts: {
          title: "Kontaktpersonen",
          none: "Noch keine Kontaktperson eingetragen.",
          name: "Name",
          role: "Rolle",
          email: "E-Mail-Adresse",
          phone: "Telefon",
          add: "Kontaktperson hinzufügen",
          remove: "Kontaktperson entfernen",
          roles: {
            TECHNICAL: "Technik",
            BUSINESS: "Fachlich",
          },
          invalid: {
            email: "Keine gültige E-Mail-Adresse.",
            phone: "Nur Ziffern, Leerzeichen und + ( ) / - .",
          },
        },
        goLive: {
          title: "Inbetriebnahme",
          description: "Wird beim Öffnen automatisch geprüft. Nichts davon hält Live auf.",
          checks: {
            CONTACT: "Kontaktperson eingetragen",
            SIGNED_IN: "Bei IRES angemeldet",
            CONNECTION: "Verbindung vollständig (Basis-URL und Anmeldedaten)",
            PROJECT: "Erstes Projekt ausgetauscht",
          },
          lastSignIn: "{0}, zuletzt am {1}",
          openWarning: "Noch offen für die Inbetriebnahme: {0}. Live kann trotzdem gesetzt werden.",
        },
        packages: {
          title: "Pakete",
          description: "Was du dem Partner für die Anbindung gibst: die Beschreibung der IRES REST API, zugeschnitten auf seine Endpunkte, als YAML und als Seite für den Browser, und einen Überblick über den Austausch als PDF. Jedes Paket wird mit Datum, Ersteller, Version und Empfänger festgehalten.",
          none: "Noch kein Paket erstellt.",
          notAvailable: "Für EasyTec-Systeme gibt es noch keine Pakete: sie nutzen eine eigene Schnittstelle.",
          loadFailed: "Die Pakete konnten nicht geladen werden.",
          create: "Neues Paket",
          createTitle: "Neues Paket für {0}",
          createButton: "Erstellen",
          created: "Paket erstellt.",
          changeGroup: "Paket erstellt",
          version: "API {0}",
          by: "von {0}",
          for: "für {0}",
          apiVersion: "API-Version",
          groups: "Endpunkte",
          recipient: "Empfänger",
          otherRecipient: "Andere Person",
          recipientName: "Name",
          recipientEmail: "E-Mail-Adresse (optional)",
          noCredentials: "Es enthält nie Zugangsdaten: das Passwort des Systems gibst du getrennt weiter.",
          describes: "Das Paket beschreibt die IRES REST API {0}.",
          groupNames: {
            SIGN_IN: "Anmeldung",
            PROJECTS: "Projekte",
            STATUS: "Status und Schritte",
            NOTES: "Notizen",
            REPORTS: "Berichte",
            DEVICES: "Geräte und Zuordnungen",
            DEVICE_CATEGORIES: "Gerätekategorien und -typen",
            USERS: "Benutzer und Rollen",
          },
          states: {
            CURRENT: "Aktuell",
            OUTDATED: "Veraltet",
            SUPERSEDED: "Ersetzt",
            UNCHECKED: "Nicht prüfbar",
          },
          unchecked: "Die Beschreibung im Paket konnte nicht gelesen werden, daher ist nicht geprüft, ob sich die API geändert hat.",
          operations: {
            added: "Neue Endpunkte: {0}",
            removed: "Entfernte Endpunkte: {0}",
            changed: "Geänderte Endpunkte: {0}",
          },
          general: "Geändert: {0}",
          generalParts: {
            SERVERS: "Basis-URL der API",
            SECURITY: "Anmeldung an der API",
          },
          settingsNotChecked: "Die Einstellungen sind nicht geprüft: das Paket ist älter als diese Prüfung.",
          changelogLine: "API {0}: {1}",
          notSent: "nicht gesendet",
          settingNames: {
            name: "Name",
            accessEmail: "Anmeldeadresse des Systems",
            ownerIsGroup: "Mandantengruppe (regionId)",
            sends: "IRES sendet an das System",
          },
          files: {
            yaml: "Beschreibung (YAML) herunterladen",
            html: "Beschreibung (HTML) herunterladen",
            overview: "Überblick (PDF) herunterladen",
          },
        },
        editTitles: {
          PARTNER_STATUS: "Status bearbeiten",
          PARTNER_CONNECTION: "Verbindung bearbeiten",
          PARTNER_ACCEPTS: "Was {0} bekommt bearbeiten",
          PARTNER_BEHAVIOUR: "Verhalten bearbeiten",
          PARTNER_CREDENTIALS: "Anmeldedaten bearbeiten",
          PARTNER_CONTACTS: "Kontaktpersonen bearbeiten",
        },
        warnings: {
          pause: "IRES sendet diesem System nichts mehr, bis du es fortsetzt. Es kann IRES weiter aufrufen.",
          resume: "Beim Fortsetzen sendet IRES alles, was in der Pause liegen geblieben ist.",
          swapOff: "Ohne die Zuordnung gehen Termin und Begonnen getrennt an das System. Jeder Terminschritt eines offenen Projekts wird bei dessen nächster Änderung neu gesendet. Stimme das vorher mit dem Betreiber ab.",
          noStatus: "Das System bekommt dann keine Statusänderungen mehr.",
        },
        fieldErrors: {
          baseUrl: "Eine URL mit https:// oder http://",
          endpoint: "Nur Buchstaben, Ziffern und _ - . ~ /",
        },
        credentials: {
          button: "Anmeldedaten ändern",
          apiKey: "API-Schlüssel",
          password: "Passwort",
          email: "E-Mail-Adresse",
          clientId: "Mandant (EasyTec)",
          authUrl: "Anmelde-Adresse",
          tokenUrl: "Token-Adresse",
          set: "gesetzt",
          missing: "fehlt",
          secretSetLabel: "{0} (gesetzt; leer lassen = unverändert)",
          secretMissingLabel: "{0} (fehlt)",
          saved: "Anmeldedaten gespeichert.",
          replaced: "ersetzt",
        },
        errors: {
          NOT_AVAILABLE: "Für EasyTec-Systeme gibt es noch keine Pakete.",
          NO_PACKAGE: "Dieses Paket gibt es nicht.",
          NOT_A_MEMBER: "Nur Mitglieder der Gruppe des Eigentümers können verknüpft werden.",
          NO_CHANGES: "Daran hat sich nichts geändert.",
          EMAIL_TAKEN: "Mit dieser Adresse meldet sich schon jemand an.",
          MEMBER_CLIENT: "Ein Mitglied nutzt die externen Systeme seines MASTER-Mandanten.",
          CHANGED_MEANWHILE: "Jemand hat das inzwischen geändert. Die Seite wurde neu geladen.",
          NOT_EDITABLE_HERE: "Dieses externe System wird beim MASTER-Mandanten geändert.",
          NEEDS_ERP_SIMULATOR: "Testsystem nur bei einem Mandanten mit ERP-Simulator.",
          NO_PARTNER: "Dieses externe System gibt es für diesen Mandanten nicht.",
          INVALID: "Eine Angabe ist ungültig.",
          SHARED_LOGIN: "Mit dem gemeinsamen IRES-Admin-Login kann nichts geändert werden. Melde dich mit deinem eigenen Benutzer an.",
          FAILED: "Das externe System konnte nicht gespeichert werden.",
        },
        access: {
          title: "Zugang",
          description: "Mit dieser Adresse und ihrem Passwort meldet sich das System bei IRES an. Das Passwort wird nur beim Anlegen und bei Neues Passwort einmal angezeigt.",
          email: "Anmeldung des Systems bei IRES",
          password: "Passwort",
          newPassword: "Neues Passwort",
          newPasswordTitle: "Neues Passwort erzeugen",
          newPasswordMessage: "Das bisherige Passwort von {0} gilt sofort nicht mehr. Das System kann sich erst wieder anmelden, wenn es das neue bekommen hat.",
          passwordTitle: "Passwort für {0}",
          onceWarning: "Das Passwort wird nur jetzt angezeigt und nirgends gespeichert. Kopiere es und gib es an den Betreiber des Systems weiter.",
          copy: "Kopieren",
          copied: "Passwort kopiert.",
          copyFailed: "Kopieren ging nicht. Markiere das Passwort und kopiere es von Hand.",
          done: "Fertig",
        },
        create: {
          open: "Neu",
          title: "Neues externes System",
          name: "Name",
          baseUrlOptional: "Basis-URL (optional, auch später)",
          button: "Anlegen",
          created: "Externes System angelegt.",
          emailInvalid: "Eine E-Mail-Adresse, z. B. kuerzel-system@ires.de",
        },
        links: {
          title: "Verknüpfte Mandanten",
          description: "Diese Mandanten erreicht das System: Es kann ihre Projekte anlegen und bearbeiten, und ihre neuen Projekte werden mit ihm ausgetauscht. Mitglieder der Gruppe verknüpfst du hier.",
          none: "Kein Mandant verknüpft.",
          owner: "Eigentümer",
          link: "Verknüpfen",
          linkTitle: "Mandanten mit {0} verknüpfen",
          member: "Mandant",
          linkWarning: "Danach kann {0} Projekte dieses Mandanten anlegen und bearbeiten, und neue Projekte des Mandanten werden mit {0} ausgetauscht.",
          linked: "Verknüpft.",
          unlink: "Verknüpfung entfernen",
          unlinkTitle: "Verknüpfung entfernen",
          unlinkMessage: "{1} kann {0} danach nicht mehr erreichen: Seine Aufrufe für diesen Mandanten werden abgelehnt.",
          unlinked: "Verknüpfung entfernt.",
          linkedClient: "Verknüpfter Mandant",
        },
      },
      clientLogin: {
        button: "Als Mandant anmelden",
        noTab: "Der neue Tab hat sich nicht gemeldet. Erlaube Pop-ups für IRES Office und versuche es erneut.",
        failed: "Der Mandant konnte nicht geöffnet werden.",
        refusals: {
          SHARED_LOGIN: "Mit dem gemeinsamen IRES-Admin-Login kann kein Mandant geöffnet werden. Melde dich mit deinem eigenen Benutzer an.",
          NO_CLIENT: "Diesen Mandanten gibt es nicht mehr.",
          PORTAL_CLIENT: "Der eigene Mandant des IRES Admin Client kann so nicht geöffnet werden.",
          ADMIN_APP_CLIENT: "Konten der IRES Admin App können so nicht geöffnet werden.",
          NO_IRES_ADMIN_USER: "Dieser Mandant hat keinen IRES-Admin-Benutzer.",
        },
      },
      status: {
        blocked: {
          title: "Sperre bearbeiten",
          no: "Nicht gesperrt",
          yes: "Gesperrt",
          consequence: "Niemand kann sich mehr bei diesem Mandanten anmelden, außer dem IRES-Admin-Konto. Geräte und ERP-Anbindungen laufen weiter.",
          saved: "Sperre gespeichert.",
        },
        active: {
          title: "Aktiv / Inaktiv bearbeiten",
          yes: "Aktiv",
          no: "Inaktiv",
          consequence: "Benutzer können sich nicht mehr mit ihrer Mailadresse anmelden, und der Mandant verschwindet aus den Listen seiner Gruppe.",
          unmet: "Der Mandant kann noch nicht inaktiv gesetzt werden:",
          saved: "Gespeichert.",
        },
        delete: {
          title: "Mandant löschen",
          consequence: "Der Mandant verschwindet aus allen Listen, und niemand kann sich mehr anmelden. Alle Daten bleiben erhalten; Wiederherstellen macht das Löschen rückgängig.",
          unmet: "Der Mandant kann noch nicht gelöscht werden:",
          saved: "Mandant gelöscht.",
        },
        restore: {
          title: "Mandant wiederherstellen",
          message: "Der Mandant erscheint wieder in den Listen, und man kann sich wieder anmelden, sofern er nicht gesperrt ist.",
          button: "Wiederherstellen",
          saved: "Mandant wiederhergestellt.",
        },
        deleteReason: "Grund",
        deleteReasons: {
          CUSTOMER_LEFT: "Kunde ausgeschieden",
          DUPLICATE: "Duplikat",
          TEST_ACCOUNT: "Testkonto",
          OTHER: "Sonstiges",
        },
        note: "Bemerkung (optional)",
        noteRequired: "Bemerkung",
        noteTooLong: "Höchstens 200 Zeichen",
        conditions: {
          DEVICES_ASSIGNED: "Es sind noch Geräte zugeordnet.",
          RUNNING_PROJECTS: "Es laufen noch Projekte.",
          SHARED_USERS_AT_HOME: "Gemeinsame Benutzer der Gruppe haben hier ihren Heimatmandanten.",
          MASTER_WITH_MEMBERS: "Der Mandant ist Master einer Gruppe mit Mitgliedern.",
          ERP_CONNECTED: "Eine ERP-Anbindung ist aktiv.",
        },
        changedMeanwhile: "Der Status wurde inzwischen geändert. Die Ansicht wurde neu geladen.",
        saveFailed: "Der Status konnte nicht gespeichert werden.",
      },
      liveOperation: {
        live: "Echtbetrieb",
        notLive: "Kein Echtbetrieb",
        notLiveWithReason: "Kein Echtbetrieb ({0})",
        reasons: {
          TEST: "Test",
          DEMO: "Demo",
          WAREHOUSE: "Lager",
        },
        reason: "Grund",
        change: "ändern",
        changedAt: "geändert am {0}",
        changedAtBy: "geändert am {0} von {1}",
        editTitle: "Betrieb bearbeiten",
        consequence: "Ab der nächsten Nacht lässt Mira Mandanten ohne Echtbetrieb aus allen Zahlen und Vergleichen weg. Wieder auf Echtbetrieb gesetzt, zählen sie ab dann wieder mit.",
        saved: "Betrieb gespeichert.",
        saveFailed: "Der Betrieb konnte nicht gespeichert werden.",
      },
      miraAllClients: {
        on: "Ja: Mira zeigt alle Mandanten zusammengerechnet",
        off: "Nein",
        editTitle: "Mira: Alle Mandanten bearbeiten",
        consequence: "Mira zeigt dann ab der nächsten Nacht die Zahlen aller Mandanten zusammengerechnet. Jeder Benutzer dieses Mandanten sieht sie.",
        savedOn: "Mira zeigt ab der nächsten Nacht alle Mandanten.",
        savedOff: "Mira zeigt die Zahlen aller Mandanten nicht mehr.",
        saveFailed: "Die Einstellung konnte nicht gespeichert werden.",
        notIresAccount: "Nur ein IRES-Mandant kann alle Mandanten zeigen.",
      },
      columns: {
        name: "Name",
        currentProjects: "Aktuell",
        oldProjects: "Alt",
        deletedProjects: "Gelöscht",
        reports: "Berichte",
        panels: "Panels",
        comBoxes: "Boxen",
        minis: "Minis",
        number: "Nummer",
        shorthand: "Kürzel",
        users: "Benutzer",
      },
      // The Mandanten list's sort (2026-11-02): the name, or a figure, either way round.
      sorts: {
        NAME: "Name",
        numProjects: "Aktuelle Projekte",
        numOldProjects: "Alte Projekte",
        numDeletedProjects: "Gelöschte Projekte",
        numReports: "Berichte",
        numCurrentPanels: "Panels",
        numCurrentComBoxes: "Boxen",
        numCurrentMinis: "Minis",
        numUsers: "Benutzer",
      },
      sortedBy: {
        mostFirst: "Sortierung: {0}, meiste zuerst",
        fewestFirst: "Sortierung: {0}, wenigste zuerst",
        nameDescending: "Sortierung: Name, Z bis A",
      },
      columnGroups: {
        projects: "Projekte",
        devices: "Geräte",
      },
      filters: {
        ALL: "Alle",
        IRES: "IRES",
        CLIENT: "Kunden",
        SERVICE_CONTRACT: "Servicevertrag",
        CONTRACT_PURCHASE: "Kauf",
        CONTRACT_PERMANENT_RENT: "Dauermiete",
        CONTRACT_TESTING: "Testphase",
        HAS_APP: "Hat App",
        MASTER: "Master",
        LIVE: "Echtbetrieb",
        NOT_LIVE: "Kein Echtbetrieb",
        BLOCKED: "Gesperrt",
        DELETED: "Gelöscht",
        ACTIVE: "Aktiv",
        INACTIVE: "Inaktiv",
      },
      filterGroups: {
        TYPE: "Typ",
        CONTRACT: "Vertrag",
        APP: "App",
        GROUP: "Gruppe",
        OPERATION: "Betrieb",
        ACCESS: "Zugang",
        STATUS: "Status",
      },
      serviceContractSince: "ab {0}",
      noneMatching: "Keine Mandanten passen zu Suche und Filter.",
      loadFailed: "Die Mandanten konnten nicht geladen werden.",
      figuresUpdatedAt: "Stand {0}",
      detail: {
        loadFailed: "Der Mandant konnte nicht geladen werden.",
        notFound: "Diesen Mandanten gibt es nicht (mehr).",
        licences: {
          title: "Lizenzen",
          modelV2: "Lizenzmodell 2 · Grenzen",
          modelV3: "Lizenzmodell 3 · genutzt von gekauft",
          exceeded: "Es sind mehr Lizenzen genutzt als gekauft.",
        },
        devices: {
          title: "Geräte",
          loadFailed: "Die Gerätezahlen konnten nicht geladen werden.",
          hint: "Panels ohne offene Zuordnung zählen als ehemalig. Die Panel-Summen enthalten nur HyDry Panel, HyDry Slim und HyDry Edge.",
          columns: {
            type: "Zuordnung",
            panels: "Panels",
            comBoxes: "Boxen",
            minis: "Minis",
          },
          assignmentTypes: {
            SOLD: "Kauf",
            PERMANENT_RENT: "Dauermiete",
            DAILY_RENT: "Tagesmiete",
            CONSIGNMENT_STOCK: "Konsilager",
            TESTING: "Test",
            OTHER: "Sonstige",
            AVAILABLE: "Verfügbar",
          },
          former: "Ehemalige Panels",
          total: "Gesamt",
        },
        sections: {
          masterData: "Stammdaten",
          products: "Produkte",
          projectTypes: "Projekttypen",
          projectOrganisation: "Projektorganisation",
          systemConfiguration: "Systemkonfiguration",
          group: "Gruppe",
          contracts: "Verträge",
          targetVersions: "Zielversionen",
          testSettings: "Test",
          status: "Status",
          helperFunctions: "Hilfsfunktionen",
        },
        fields: {
          isMaster: "MASTER-Mandant",
          groupMembers: "Mitglieder",
          settingsSource: "Einstellungen übernommen von",
          masterClient: "Mitglied von",
          clientNumber: "Kundennummer",
          companyName: "Unternehmen",
          zip: "PLZ",
          city: "Ort",
          street: "Straße",
          clientType: "Kundentyp",
          email: "E-Mail-Adresse",
          clientShorthand: "Mandantenkürzel",
          officeDeviceAssignment: "IRES Office (GZ / GL)",
          project: "IRES Project",
          work: "IRES Work",
          interface: "API",
          productChoice: "Produktwahl (alt)",
          contracts: "Verträge",
          warrantyExtensionForPanels: "Garantieverlängerung Panels",
          serviceContract: "Servicevertrag FW / Config",
          hasApp: "Hat App",
          blocked: "Gesperrt",
          isActive: "Aktiv",
          deleted: "Gelöscht",
          liveOperation: "Betrieb",
          miraAllClients: "Mira: Alle Mandanten",
          isTestSystem: "ERP-Simulator",
          testAppVersion: "Testziel Appversion",
          testRoomInfoConfigVersion: "Testziel Beschreibung Version",
          testUsers: "Testbenutzer",
          numUsers: "Benutzer",
          numProjects: "Projekte",
          numArchivedProjects: "Alte Projekte",
          numDeletedProjects: "Gelöschte Projekte",
          figuresUpdatedAt: "Stand der Zahlen",
          numReports: "Berichte",
        },
        clientTypes: {
          IRES: "IRES",
          CLIENT: "Kunde",
          OTHER: "Sonstige",
        },
        contractTypes: {
          PURCHASE: "Kauf",
          PERMANENT_RENT: "Dauermiete",
          TESTING: "Testphase",
        },
        testSettings: {
          unknownUser: "Unbekannter Benutzer",
          inactiveUser: "(gelöscht)",
          reachesNobody: "Der Test erreicht niemanden, solange kein Testbenutzer gewählt ist.",
        },
        targetVersions: {
          targetFirmwareName: "Zielfirmware A, B, C",
          targetIotFirmwareName: "Zielfirmware D+",
          targetConfigName: "Zielkonfiguration",
          targetAppApk: "App-Version",
          targetLeakDetectionInfoConfigVersion: "Leckortung",
          targetRoomInfoConfigVersion: "Trocknung",
          targetHtmlTipsAndTricksFile: "Tipps und Tricks",
          targetHtmlHistoryFile: "Versionshistorie",
        },
      },
    },
    cockpit: {
      contractsAndApp: "Verträge und App",
      tasks: "Aufgaben",
      totalsTitle: "Gesamt",
      totalsScope: "Kunden in Echtbetrieb",
      totals: {
        projects: "Projekte",
        oldProjects: "Alte Projekte",
      },
      exceptionSuggestions: "Vorschläge für Mira-Ausnahmen",
      externalSystemsInStatus: "Externe Systeme: {0}",
      waitingDeviceReports: "Testberichte nicht zugeordnet",
      ownTargets: "Mandanten mit eigenem Ziel",
      testTargets: "Mandanten mit Testziel",
      loadFailed: "Nicht alle Zahlen konnten geladen werden.",
    },
    clientSensorDataExport: {
      title: "Sensordaten-Export",
      description: "Die aufgezeichneten Sensordaten der ausgewählten HyDry Boxen und Panels als Excel-Datei, ein Arbeitsblatt pro Gerät. Ein Gerät liefert nur die Läufe, in denen es diesem Mandanten zugeordnet war.",
      startDate: "Startdatum",
      endDate: "Enddatum",
      selected: "{0} ausgewählt",
      selectAll: "Alle auswählen",
      selectNone: "Auswahl aufheben",
      none: "Dieser Mandant hat keine HyDry Boxen oder Panels.",
      progress: "{0} von {1} Geräten verarbeitet",
      exportSuccess: "Export erfolgreich erstellt.",
      exportError: "Beim Export ist ein Fehler aufgetreten.",
      noData: "Für die ausgewählten Geräte liegen im gewählten Zeitraum keine Messwerte vor.",
    },
    clientDevices: {
      title: "Geräte",
      allDevices: "Alle Geräte",
      search: "Seriennummer",
      count: "Geräte",
      kinds: {
        PANELS: "HyDry Panels",
        BOXES: "HyDry Boxen",
        MINIS: "HyDry Minis",
      },
      scopes: {
        CURRENT: "Aktuell zugeordnet",
        FORMER: "Ehemalig",
      },
      filterGroups: {
        KIND: "Gerätetyp",
        PANEL_TYPE: "Paneltyp",
        PERIOD: "Zeitraum",
        ASSIGNMENT: "Zuordnung",
      },
      sorts: {
        SERIAL_NUMBER: "Seriennummer",
        ASSIGNMENT_TYPE: "Zuordnung",
        ASSIGNMENT_DATE: "Datum der Zuordnung",
      },
      columns: {
        serialNumber: "Seriennummer",
        type: "Gerätetyp",
        assignment: "Zuordnung",
        firmware: "Firmware",
        lastContact: "Letzter Kontakt",
      },
      since: "seit {0}",
      open: "offen",
      history: "Alle Zuordnungen",
      noHistory: "Keine Zuordnungen",
      build: "Build {0}",
      config: "Config {0}",
      ipu: "IPU {0}",
      display: "Display {0}",
      noneMatching: "Keine Geräte passen zu diesen Filtern.",
      loadFailed: "Die Geräte konnten nicht geladen werden.",
    },
    clientProjects: {
      title: "Projekte",
      search: "Name / Nummer",
      count: "Projekte",
      filterGroups: {
        STATUS: "Status",
        KIND: "Projektart",
      },
      columns: {
        period: "Zeitraum",
        devices: "Geräte",
        steps: "Schritte",
      },
      since: "seit {0}",
      officeNumber: "Office: {0}",
      erpNumber: "Sammelnummer: {0}",
      showMore: "Weitere anzeigen ({0} von {1})",
      noneMatching: "Keine Projekte passen zu diesen Filtern.",
      loadFailed: "Die Projekte konnten nicht geladen werden.",
      archiveLoading: "{0} % geladen",
      archiveLoadFailed: "Die alten Projekte konnten nicht geladen werden.",
    },
    clientReports: {
      title: "Berichte",
      count: "Berichte",
      columns: {
        report: "Bericht",
        project: "Projekt",
        date: "Datum",
        size: "Größe",
      },
      outdated: "veraltet",
      sizeMb: "{0} MB",
      showMore: "Weitere anzeigen ({0} von {1})",
      none: "Keine Berichte vorhanden.",
      loadFailed: "Die Berichte konnten nicht geladen werden.",
      loadMoreFailed: "Weitere Berichte konnten nicht geladen werden.",
      openFailed: "Der Bericht konnte nicht geöffnet werden.",
      fileMissing: "Die Datei dieses Berichts fehlt.",
      noFile: "Dieser Bericht hat keine Datei.",
      popupBlocked: "Dein Browser hat das neue Fenster blockiert. Erlaube Pop-ups für IRES Office.",
    },
    clientUsers: {
      title: "Benutzer",
      search: "Kurzname / Name",
      count: "Benutzer",
      status: "Status",
      filterGroups: {
        STATUS: "Status",
        ROLE: "Rolle",
      },
      statuses: {
        ACTIVE: "Aktiv",
        BLOCKED: "Gesperrt",
        DELETED: "Gelöscht",
      },
      noneMatching: "Keine Benutzer passen zu diesen Filtern.",
      loadFailed: "Die Benutzer konnten nicht geladen werden.",
    },
    userSearch: {
      title: "Benutzer suchen",
      search: "E-Mail / Name / Kurzname / Personalnummer",
      count: "Benutzer",
      capped: "die ersten {0} von {1}",
      client: "Mandant",
      hint: "Gib mindestens drei Zeichen ein: E-Mail-Adresse, Name, Kurzname oder Personalnummer.",
      none: "Kein Benutzer passt zu dieser Suche.",
      loadFailed: "Die Suche ist fehlgeschlagen.",
      nickname: "Kurzname {0}",
      staffNumber: "Personalnummer {0}",
      sharedEmailAddress: "E-Mail geteilt",
      groupUser: "Gruppe",
    },
    sharedUsers: {
      title: "Geteilte Benutzer",
      search: "E-Mail / Name / Mandant",
      tabs: {
        emailAddresses: "E-Mail-Adresse teilen",
        emailAddressesShort: "E-Mail",
        group: "Gruppe",
      },
      emailAddressCount: "Geteilte E-Mail-Adressen",
      groupUserCount: "Geteilte Benutzer",
      homeClient: "Heimat-Mandant",
      group: "Gruppe",
      userCount: "1 Benutzer | {count} Benutzer",
      clientCount: "1 Mandant | {count} Mandanten",
      migrated: "Migriert",
      cleanUp: "Bereinigen",
      cleanUpAll: "Alle bereinigen ({0})",
      cleaningUp: "Bereinige {0} von {1} …",
      filters: {
        ALL: "Alle",
        CLEAN_UP: "Zu bereinigen",
        OK: "In Ordnung",
        MIGRATED: "Migriert",
      },
      states: {
        OK: "In Ordnung",
        STALE: "{0} nicht mehr vorhanden",
        EMPTY: "Niemand mehr",
      },
      userStates: {
        LIVE: "Aktiv",
        DELETED: "Gelöscht",
        MISSING: "Nicht mehr vorhanden",
        ADDRESS_CHANGED: "Andere E-Mail-Adresse",
      },
      confirm: {
        title: "Bereinigen?",
        message: "Diese Benutzer haben {0} nicht mehr und werden aus der geteilten E-Mail-Adresse entfernt:",
        entryDeleted: "Danach ist niemand mehr übrig: Der Eintrag wird gelöscht, und die Adresse ist wieder frei.",
        othersStay: "Die übrigen Benutzer behalten die geteilte Anmeldung.",
        allMessage: "{0} geteilte E-Mail-Adressen haben Benutzer, die es nicht mehr gibt. Willst du alle bereinigen?",
      },
      cleanedUp: "{0} bereinigt.",
      cleanedUpAll: "{0} geteilte E-Mail-Adressen bereinigt.",
      cleanUpFailed: "Bereinigen ist fehlgeschlagen.",
      refusals: {
        SHARED_LOGIN: "Mit dem gemeinsamen IRES-Admin-Login kann nichts geändert werden. Melde dich mit deinem eigenen Benutzer an.",
        NO_ENTRY: "Diesen Eintrag gibt es nicht mehr.",
      },
      loadFailed: "Die geteilten Benutzer konnten nicht geladen werden.",
      none: "Keine Einträge passen zu diesen Filtern.",
    },
    pdfTemplates: {
      loading: "Vorlage wird geladen …",
      title: "PDF-Vorlagen",
      sharedTitle: "Geteilte PDF-Vorlagen",
      search: "Name oder Datei",
      count: "PDF-Vorlagen",
      sharedCount: "Geteilte PDF-Vorlagen",
      openShared: "Geteilte Vorlagen",
      sharedHint: "Geteilte Vorlagen stehen allen Mandanten zur Übernahme bereit. Das HyDry-Zertifikat verwendet nur die eigenen Vorlagen eines Mandanten.",
      columns: {
        name: "Vorlage",
        fields: "Felder",
        problems: "Probleme",
        lastSaved: "Zuletzt gespeichert",
      },
      hyDryCertificate: "HyDry-Zertifikat",
      ignoredCertificate: "-HyDry, nicht verwendet",
      problemValues: "1 Wert bleibt leer | {count} Werte bleiben leer",
      noProblems: "Alle Werte werden gefüllt",
      none: "Keine PDF-Vorlagen vorhanden.",
      noFields: "Diese Vorlage hat keine Felder.",
      loadFailed: "Die PDF-Vorlagen konnten nicht geladen werden.",
      notFound: "Diese PDF-Vorlage gibt es nicht.",
      download: "Herunterladen",
      downloadFailed: "Die Vorlage konnte nicht heruntergeladen werden.",
      fileMissing: "Die Datei dieser Vorlage fehlt.",
      detail: {
        field: "Feld",
        category: "Kategorie",
        values: "Werte",
        texts: "Text davor / danach",
        prefix: "davor: „{0}“ ({1})",
        suffix: "danach: „{0}“ ({1})",
      },
      statuses: {
        UNKNOWN_TO_CLOUD: "bleibt leer: IRES Cloud kennt diesen Wert nicht",
        NOT_IMPLEMENTED: "bleibt leer: in IRES Cloud nicht umgesetzt",
        CHECKBOX_ALWAYS_OFF: "Kästchen bleibt immer leer",
      },
      fieldTypes: {
        TEXT: "Textfeld",
        CHECK_BOX: "Ankreuzfeld",
        SIGNATURE: "Unterschriftsfeld",
        DROPDOWN: "Auswahlliste",
      },
      edit: {
        dialogTitle: "{0} bearbeiten",
        filters: {
          ALL: "Alle Felder",
          LINKED: "Verknüpft",
          UNLINKED: "Nicht verknüpft",
        },
        linkedCount: "{0} von {1} Feldern verknüpft",
        notLinked: "nicht verknüpft",
        notInPdf: "Nicht mehr in der PDF",
        childFields: "Gruppe aus {count} Feld | Gruppe aus {count} Feldern",
        noneMatching: "Keine Felder passen zu diesem Filter.",
        unavailable: {
          NO_FILE: "Diese Vorlage hat keine Datei.",
          FILE_MISSING: "Die Datei dieser Vorlage fehlt.",
          ENCRYPTED: "Die PDF ist verschlüsselt, ihre Felder lassen sich nicht lesen.",
          UNREADABLE: "Die PDF lässt sich nicht lesen.",
        },
        onlyLinkedShown: "Es werden nur die verknüpften Felder angezeigt.",
        selection: "Auswahl",
        noValue: "Noch kein Wert verknüpft.",
        addValue: "Wert hinzufügen",
        replaceValue: "Wert ersetzen",
        prefix: "Text davor",
        suffix: "Text danach",
        preview: "Vorschau",
        unlink: "Verknüpfung entfernen",
        changedMeanwhile: "Die Vorlage wurde inzwischen gespeichert, zum Beispiel in IRES Admin. Lade die Seite neu und nimm deine Änderungen erneut vor.",
        saveRefused: "Nicht gespeichert: Die Verknüpfung von „{0}“ passt nicht zur PDF oder zu den Werten ihrer Kategorie.",
        saveFailed: "Die Verknüpfungen konnten nicht gespeichert werden.",
        scopeClient: "Vorlage von {0}: Gespeicherte Änderungen gelten für alle neuen PDFs, die IRES Project für diesen Mandanten erstellt.",
        scopeCertificate: "Diese Vorlage füllt auch das HyDry-Zertifikat dieses Mandanten.",
        scopeShared: "Geteilte Vorlage: Gespeicherte Änderungen gelten nur für künftige Übernahmen. Mandanten, die sie schon übernommen haben, behalten ihre Kopie unverändert.",
        confirmTitle: "Verknüpfungen speichern?",
        confirmClient: "Du speicherst die Vorlage „{0}“ von {1}. Neue PDFs, die IRES Project für diesen Mandanten erstellt, verwenden dann die geänderten Verknüpfungen.",
        confirmShared: "Du speicherst die geteilte Vorlage „{0}“. Das betrifft nur künftige Übernahmen; bestehende Kopien bei Mandanten bleiben unverändert.",
        changesAdded: "Neu verknüpft: {0}",
        changesChanged: "Geändert: {0}",
        changesRemoved: "Verknüpfung entfernt: {0}",
      },
      files: {
        upload: "Neue Vorlage",
        uploadTitle: "Neue PDF-Vorlage",
        replace: "PDF ersetzen",
        rename: "Umbenennen",
        copyToShared: "In geteilte Vorlagen kopieren",
        copyFromShared: "Aus geteilten übernehmen",
        delete: "Löschen",
        deleteTitle: "Vorlage löschen?",
        preview: "Vorschau",
        previewFailed: "Die Vorschau konnte nicht erstellt werden.",
        popupBlocked: "Der Browser hat das neue Fenster blockiert. Erlaube Pop-ups für diese Seite.",
        importMappings: "Verknüpfungen übernehmen",
        fileLabel: "PDF-Datei",
        nameLabel: "Dateiname",
        sourceLabel: "Geteilte Vorlage",
        actions: {
          upload: "Hochladen",
          replace: "Ersetzen",
          rename: "Umbenennen",
          copy: "Kopieren",
        },
        problems: {
          EMPTY: "Gib einen Namen ein.",
          TOO_LONG: "Der Name ist zu lang.",
          INVALID_CHARACTERS: "Der Name darf kein / oder \\ und kein .. enthalten.",
          TAKEN: "Diesen Namen hat hier schon eine Vorlage. Tablets halten eine Vorlage unter ihrem Namen fest, darum braucht jede PDF einen neuen.",
        },
        switches: {
          title: "So liest IRES Project den Namen:",
          hidden: "im Auswahldialog ausgeblendet; IRES Cloud kann sie für das HyDry-Zertifikat verwenden",
          always: "in jeder Phase und für jeden Versicherer angeboten",
          phase: "Phase {0}",
          noPhase: "ohne Phase",
          insurer: "nur bei Versicherer „{0}“",
          images: "mit Bildern (+Bild)",
          phases: {
            LEAK_DETECTION: "Leckortung",
            DAMAGE_ASSESSMENT: "Schadenaufnahme",
            DRYING_CONCLUSION: "Trocknungsabschluss",
            REPAIR: "Wiederherstellung",
          },
        },
        consequences: {
          uploadClient: "Die Vorlage steht in IRES Project für {0} zur Auswahl.",
          uploadShared: "Die Vorlage steht allen Mandanten zur Übernahme bereit. In IRES Project erscheint sie erst nach einer Übernahme.",
          replaceClient: "Neue PDFs, die IRES Project für {0} erstellt, verwenden die neue Datei.",
          replaceShared: "Das betrifft nur künftige Übernahmen; Mandanten, die die Vorlage schon übernommen haben, behalten ihre Kopie.",
          replaceFile: "Die neue Datei braucht einen neuen Namen, weil Tablets eine Vorlage unter ihrem Namen festhalten. Die alte Datei bleibt erhalten, die Verknüpfungen bleiben; Felder, die die neue PDF nicht hat, sind danach markiert.",
          renameClient: "Neue PDFs, die IRES Project für {0} erstellt, tragen den neuen Namen, und seine Schalter (Phase, Versicherer, +Bild) gelten ab dann. Bestehende Dokumente bleiben unverändert.",
          renameShared: "Das betrifft nur künftige Übernahmen; bestehende Kopien bei Mandanten behalten ihren Namen.",
          copyToShared: "Die Kopie steht allen Mandanten zur Übernahme bereit. Sie ist unabhängig von der Vorlage von {0}: Änderungen an der einen erreichen die andere nicht.",
          copyFromShared: "Die Kopie gehört {0} und steht dort in IRES Project zur Auswahl. Sie ist unabhängig von der geteilten Vorlage: Änderungen an der einen erreichen die andere nicht.",
          deleteClient: "„{0}“ von {1} wird gelöscht. IRES Project bietet sie danach nicht mehr an; bestehende Dokumente bleiben unverändert.",
          deleteShared: "Die geteilte Vorlage „{0}“ wird gelöscht. Mandanten, die sie übernommen haben, behalten ihre Kopie.",
          deleteKeepsFile: "Die Datei bleibt bei IRES gespeichert und kann wiederhergestellt werden.",
          certificateReplace: "Diese Vorlage füllt das HyDry-Zertifikat dieses Mandanten. Behalte -HyDry am Anfang des Namens, sonst verwendet IRES Cloud sie nicht mehr dafür.",
          certificateRename: "Diese Vorlage füllt das HyDry-Zertifikat dieses Mandanten. Ohne -HyDry am Anfang des Namens verwendet IRES Cloud sie nicht mehr dafür.",
          certificateLOST: "Danach hat dieser Mandant keine Vorlage mehr für das HyDry-Zertifikat; IRES Cloud erstellt dann keine Zertifikate.",
          certificateCHANGED: "Danach verwendet das HyDry-Zertifikat dieses Mandanten eine andere Vorlage.",
        },
        success: {
          created: "Vorlage angelegt. Verknüpfe jetzt ihre Felder.",
          replaced: "PDF ersetzt.",
          renamed: "Vorlage umbenannt.",
          copied: "Vorlage in die geteilten Vorlagen kopiert.",
          deleted: "Vorlage gelöscht.",
        },
        errors: {
          FILE_NAME_TAKEN: "Diesen Dateinamen gibt es hier schon, auch bei einer gelöschten oder ersetzten Vorlage. Wähle einen anderen.",
          FILE_TOO_LARGE: "Die PDF ist größer als 6 MB.",
          NOT_A_PDF: "Die Datei ist keine lesbare PDF.",
          ENCRYPTED: "Die PDF ist verschlüsselt; ihre Felder lassen sich nicht lesen.",
          NO_FILE: "Die Datei dieser Vorlage fehlt.",
          FILE_NAME_EMPTY: "Gib einen Namen ein.",
          FILE_NAME_TOO_LONG: "Der Name ist zu lang.",
          FILE_NAME_INVALID_CHARACTERS: "Der Name darf kein / oder \\ und kein .. enthalten.",
          FAILED: "Das hat nicht geklappt. Versuch es noch einmal.",
        },
        import: {
          title: "Verknüpfungen übernehmen",
          sourceLabel: "Aus Vorlage",
          groups: {
            own: "Vorlagen dieses Bereichs",
            shared: "Geteilte Vorlagen",
          },
          fresh: "{count} Feld ohne Verknüpfung bekommt die Verknüpfung der Vorlage: | {count} Felder ohne Verknüpfung bekommen die Verknüpfung der Vorlage:",
          conflicting: "Diese Felder sind hier anders verknüpft. Hake an, was überschrieben werden soll:",
          nothing: "Diese Vorlage hat keine Verknüpfungen für Felder dieser PDF, die sich übernehmen ließen.",
          missing: "{count} Feld der Vorlage gibt es in dieser PDF nicht; es wird übergangen. | {count} Felder der Vorlage gibt es in dieser PDF nicht; sie werden übergangen.",
          savedLater: "Übernommen wird in deine Änderungen; gespeichert erst mit SICHERN.",
        },
      },
    },
    infoConfig: {
      title: "Beschreibungen",
      globalTarget: "Globales Ziel: {0}",
      newVersion: "Neue Version",
      columns: {
        version: "Version",
        state: "Status",
        uploaded: "Hochgeladen",
      },
      filters: {
        CURRENT: "Aktuelle Versionen",
        TARGETS: "Ziele",
        RETIRED: "Zurückgezogen",
        LEGACY: "Leckortung (Altversionen)",
      },
      legacyHint: "Diese Dateien gehören zu den eigenständigen Leckortungsprojekten, die seit 2021 nicht mehr angelegt werden. Sie sind nur lesbar.",
      retiredHint: "Zurückgezogene Versionen werden nicht mehr als Ziel angeboten. Projekte, die sie verwenden, bleiben unverändert.",
      loadFailed: "Die Beschreibungen konnten nicht geladen werden.",
      none: "Keine Versionen.",
      badges: {
        globalTarget: "Globales Ziel",
        clientTargets: "Ziel von {count} Mandant | Ziel von {count} Mandanten",
        testTargets: "Testziel bei {count} Mandant | Testziel bei {count} Mandanten",
        retired: "Zurückgezogen",
        unlisted: "Nicht in der Liste",
        noFile: "Datei fehlt",
      },
      publish: {
        title: "Neue Beschreibungsversion",
        file: "CSV-Datei",
        version: "Versionsnummer",
        permanent: "Eine veröffentlichte Version kann nicht mehr geändert oder gelöscht werden. Prüfe sie deshalb vorher.",
        facts: "Kodierung {0} · Trennzeichen {1} · Kopfzeile {2} · {3} Zeilen",
        noProblems: "Keine Probleme gefunden.",
        acknowledge: "Ich habe die Hinweise gelesen und will trotzdem veröffentlichen.",
        differences: "Unterschiede zu Version {0}",
        noBase: "Kein globales Ziel zum Vergleichen.",
        check: "Prüfen",
        publish: "Veröffentlichen",
        published: "Version {0} veröffentlicht.",
        versionProblems: {
          FORMAT: "Ziffern, Punkt und zwei Nachkommastellen, z. B. 5.58.",
          TAKEN: "Diese Version gibt es schon.",
          NOT_NEWER: "Die Version muss höher sein als die neueste.",
        },
      },
      problems: {
        line: "Zeile {0}:",
        NOT_UTF8: "Die Datei ist nicht UTF-8. Speichere sie als „CSV UTF-8“; sonst gehen auf den Tablets die Umlaute verloren.",
        EMPTY_FILE: "Die Datei ist leer.",
        FIRST_LINE_WITHOUT_SEPARATOR: "Die erste Zeile endet nicht mit dem Trennzeichen; IRES Project erkennt daran das Trennzeichen.",
        VERSION_HEADER_MISSING: "Die erste Zeile muss mit #Version beginnen.",
        VERSION_HEADER_MISMATCH: "Die Kopfzeile nennt Version {0}, die Datei soll aber unter einer anderen Nummer erscheinen.",
        VERSION_FORMAT: "„{0}“ ist keine gültige Versionsnummer (Ziffern, Punkt, zwei Nachkommastellen).",
        ROW_TOO_SHORT: "Die Zeile {0} hat zu wenige Spalten; IRES Project könnte die ganze Datei nicht lesen.",
        ROW_BEFORE_SECTION: "Die Zeile {0} steht vor dem ersten Abschnitt und wird übergangen.",
        COMMA_SEPARATOR: "Die Datei ist mit Kommas getrennt statt mit Semikolons.",
        VERSION_TAKEN: "Version {0} gibt es schon.",
        VERSION_NOT_NEWER: "Die Version ist nicht höher als die neueste ({0}).",
      },
      differences: {
        none: "Keine Unterschiede.",
        optionChangesHint: "{count} Auswahlwert steht jetzt an einer Stelle, die vorher etwas anderes bedeutete. | {count} Auswahlwerte stehen jetzt an Stellen, die vorher etwas anderes bedeuteten.",
        SECTION_ADDED: "Abschnitt neu",
        SECTION_REMOVED: "Abschnitt entfernt",
        ROW_ADDED: "{0}: neu",
        ROW_REMOVED: "{0}: entfernt",
        ROW_CHANGED: "{0}: Beschriftung „{2}“ → „{3}“",
        TYPE_CHANGED: "{0}: Typ {2} → {3}",
        OPTION_ADDED: "{0}, Wert {1}: neu „{3}“",
        OPTION_REMOVED: "{0}, Wert {1}: „{2}“ entfernt",
        OPTION_CHANGED: "{0}, Wert {1}: „{2}“ → „{3}“",
      },
      detail: {
        loading: "Version {0} wird geladen …",
        newFromThis: "Neue Version aus dieser",
        legacy: "Leckortung (Altversion)",
        rowCount: "{count} Zeile | {count} Zeilen",
        notFound: "Diese Version gibt es nicht.",
        setGlobalTarget: "Als globales Ziel setzen",
        setGlobalTargetTitle: "Globales Ziel ändern?",
        setGlobalTargetMessage: "Neue Projekte aller Mandanten ohne eigenes Ziel verwenden dann Version {0}. Bestehende Projekte behalten ihre Version.",
        globalTargetSet: "Version {0} ist jetzt das globale Ziel.",
        retire: "Zurückziehen",
        retireTitle: "Version zurückziehen?",
        retireMessage: "Version {0} wird nicht mehr in den Listen und als Ziel angeboten. Projekte, die sie verwenden, bleiben unverändert, und die Datei bleibt erhalten.",
        retired: "Version {0} ist zurückgezogen.",
      },
      target: {
        editTitle: "Beschreibung des Mandanten bearbeiten",
        version: "Version",
        consequence: "Neue Projekte dieses Mandanten verwenden dann diese Version. Bestehende Projekte behalten ihre.",
        followGlobal: "Globales Ziel verwenden ({0})",
        saved: "Ziel gespeichert.",
        change: "ändern",
      },
      errors: {
        CHECK_FAILED: "Die Datei hat Fehler; prüfe sie erneut.",
        WARNINGS_NOT_ACKNOWLEDGED: "Bestätige zuerst die Hinweise.",
        VERSION_TAKEN: "Diese Version gibt es inzwischen schon.",
        VERSION_RETIRED: "Diese Version ist zurückgezogen.",
        VERSION_IS_TARGET: "Diese Version ist noch ein Ziel und kann nicht zurückgezogen werden.",
        NEEDS_SYSADMIN: "Das darf nur ein SysAdmin des Portals.",
        NO_FILE: "Die Datei dieser Version fehlt.",
        FILE_TOO_LARGE: "Die Datei ist größer als 2 MB.",
        FAILED: "Das hat nicht geklappt. Versuch es noch einmal.",
      },
      sections: {
        search: "Schlüssel oder Text",
        noneMatching: "Keine Zeile passt zur Suche.",
        columns: {
          key: "Schlüssel",
          category: "Kategorie",
          group: "Gruppe",
          entry: "Eintrag",
          trade: "Gewerk",
          type: "Typ",
          values: "Werte",
        },
      },
      draft: {
        rowDialogTitle: "{0} bearbeiten",
        title: "Entwurf {0} (aus {1})",
        savedHere: "Wird in diesem Browser gespeichert",
        none: "Kein Entwurf vorhanden. Öffne eine Version und wähle „Neue Version aus dieser“.",
        notSaved: "Der Browser speichert den Entwurf nicht (privates Fenster oder voller Speicher). Ein Neuladen verwirft ihn.",
        discard: "Verwerfen",
        discardTitle: "Entwurf verwerfen?",
        discardMessage: "Alle Änderungen dieses Entwurfs gehen verloren. Veröffentlichte Versionen bleiben unverändert.",
        checkAndPublish: "Prüfen und veröffentlichen",
        changeVersion: "Versionsnummer ändern",
        insertRow: "Zeile danach einfügen",
        insertRowMessage: "Neue Zeile nach {0}, gleicher Abschnitt.",
        removeRow: "Zeile entfernen",
        removeRowMessage: "Zeile {0} aus dem Entwurf entfernen?",
        keyRequired: "Gib einen Schlüssel ein.",
        keyTaken: "Diesen Schlüssel gibt es schon.",
        rowHint: "Änderungen gelten nur für diesen Entwurf.",
        valuesHint: "Die Zahl links ist die Nummer, unter der die Beschreibung auf den Wert verweist (Boden0010-3 ist der dritte Wert von Boden0010). In einer Zeile mit Typ zählen ein / und leere Werte nicht mit, in einer Zeile ohne Typ (Def…) zählt jede Zelle.",
        addValue: "Wert hinzufügen",
        referencesShifted: "Diese Verweise zeigen danach auf einen anderen Wert und werden nicht angepasst:",
        referenceShift: "{0}: „{1}“ → „{2}“, verwendet in {3}",
        referenceGone: "{0}: „{1}“ → kein Wert, verwendet in {2}",
        referencedByMore: "{0} und {1} weiteren",
        replaceTitle: "Offenen Entwurf ersetzen?",
        replaceMessage: "In diesem Browser gibt es schon den Entwurf {0} (aus {1}). Ein neuer Entwurf ersetzt ihn.",
        replace: "Ersetzen",
        openExisting: "Offenen öffnen",
        open: "Offener Entwurf {0} (aus {1})",
        continue: "Weiterbearbeiten",
      },
    },
    deviceReports: {
      resultsTitle: "Ergebnisse",
      matchingReports: "Passende Testberichte",
      filters: "Filter",
      device: "Gerät",
      anyDevice: "Alle Geräte",
      deviceCategory: "Gerätetyp",
      allCategories: "Alle",
      categoryComBox: "ComBox",
      categorySensor: "Sensor",
      categoryPanel: "Panel",
      allReportTypes: "Alle",
      period: "Zeitraum",
      noPeriodLimit: "Ohne Begrenzung",
      maxAgeMonths: "Letzte",
      fromDate: "Ab Datum",
      monthsSuffix: "Monate",
      outcomeAll: "Alle",
      outcomePassed: "Bestanden",
      outcomeFailed: "Fehlgeschlagen",
      assignment: "Zuordnung",
      assignmentAll: "Alle",
      assignmentAssigned: "Zugeordnet",
      assignmentUnassigned: "Nicht zugeordnet",
      categoryExcludesUnassigned: "Nicht zugeordnete Berichte haben noch kein Gerät und damit keinen Gerätetyp. Sie werden ausgeblendet, solange du nach Gerätetyp filterst.",
      showReports: "Berichte anzeigen",
      noneMatching: "Keine Testberichte passen zu diesen Filtern.",
      countNone: "keine",
      countApprox: "ca. {0}",
      pageLimited: "Es werden die neuesten {0} zugeordneten Berichte gezeigt. Grenze den Zeitraum ein, um ältere zu sehen.",
      waitingBySerialNumber: "Gerät noch nicht angelegt",
      waitingByMacAddress: "Noch ohne Seriennummer",
      title: "Testberichte",
      serialNumber: "Seriennummer",
      searchHint: "Gib eine Seriennummer ein, um die Testberichte des Geräts zu sehen.",
      noneForDevice: "Für dieses Gerät gibt es keine Testberichte.",
      loadFailed: "Die Testberichte konnten nicht geladen werden.",
      capturedAt: "Geprüft am",
      reportType: "Art",
      result: "Ergebnis",
      uploadedBy: "Hochgeladen von",
      initial: "Erstprüfung",
      viewer: {
        title: "Testbericht",
        loadFailed: "Der Testbericht konnte nicht geladen werden.",
        unknownDevice: "Unbekanntes Gerät",
        steps: "Prüfschritte",
        step: "Schritt",
        comment: "Beschreibung",
        status: "Status",
        detail: "Detail",
        duration: "Dauer",
        rawData: "Vollständiger Bericht",
        formatPdf: "PDF",
        formatJson: "JSON",
        downloadFailed: "Der Testbericht konnte nicht heruntergeladen werden.",
      },
    },
  },
  administratorClient: {
    clientOptionsDialog: {
      message:
        "Mehrfachanmeldung für HyDry Portal. Bitte wählen Sie den gewünschten Mandanten aus.",
      title: "Mehrfachanmeldung für HyDry Portal",
      titleForSwitchingClient: "Mandant auswählen",
    },
  },
  allDevices: {
    acquisitionDate: "Anschaffungsdatum",
    addNewCategory: "Neue Kategorie anlegen",
    addNewCategoryDesc: "Bitte Namen der neuen Kategorie angeben",
    allDevicesOverview: "Geräte Übersicht",
    availability: "Verfügbarkeit",
    available: "Verfügbar",
    categoryNotSaved: "Kategorie nicht gespeichert",
    categorySaved: "Kategorie erfolgreich gespeichert",
    createDeviceDialogTitle: "Neues Gerät vom Typ {0} anlegen",
    currentProject: "Aktuelles Projekt",
    currentProjectStartedAt: "Projekt {0}, seit {1}",
    deleteCategoryConfirmMessage:
      "Sind Sie sicher, dass die Kategorie {0} gelöscht werden soll?",
    deleteCategoryConfirmTitle: "Gerätekategorie löschen",
    deleteTemplateConfirmMessage:
      "Sind Sie sicher, dass der Gerätetyp {0} gelöscht werden soll?",
    deleteTemplateConfirmTitle: "Gerätetyp löschen",
    deleted: "Gelöscht",
    deletionConfirmationDialog: {
      errorMessage: "Fehler beim Löschen von Geräten",
      message:
        "Sind Sie sicher, dass Sie alle ausgewählten Geräte löschen möchten?",
      successMessage: "Geräte erfolgreich gelöscht",
      title: "Geräte löschen",
    },
    description:
      "Verwaltung Alle Geräte: 1 Gerät | Verwaltung Alle Geräte: {count} Geräte",
    descriptionAlt:
      "Auswahl Alle Geräte: 1 Gerät | Auswahl Alle Geräte: {count} Geräte",
    deviceCategoryDeleted: "Kategorie erfolgreich gelöscht",
    deviceCode: "Code",
    deviceCreated:
      "Erfolgreich erstellt! Das Gerät wurde erfolgreich hinzugefügt.",
    deviceNotCreated:
      "Erstellung fehlgeschlagen! Das Gerät konnte nicht hinzugefügt werden.",
    deviceTemplateDeleted: "Gerätetyp erfolgreich gelöscht",
    deviceTemplateNotSaved: "Gerätetyp nicht  gespeichert",
    deviceTemplateSaved: "Gerätetyp erfolgreich gespeichert",
    editCategory: "Gerätekategorie umbenennen",
    editCategoryDesc: "Bitte neuen Namen für Kategorie {0} angeben",
    editDeviceType: "Gerätetyp bearbeiten",
    electricityMeter: "Strom",
    electricityMeterForOtherDevices: "Strom fremd",
    electricityMeterManufacturer: "Zählerhersteller",
    electricityMeterManufacturerFull: "Stromzählerhersteller",
    electricityMeterNumber: "Zählernummer",
    electricityMeterNumberAndManufacturer: "Zählernummer / Hersteller",
    electricityMeterNumberFull: "Stromzählernummer",
    emptyDeviceCategoriesTemplatesHint:
      "Noch keine Gerätekategorien angelegt.\nNeue Gerätekategorie mit + erstellen.",
    emptyDeviceCategory:
      "Diese Kategorie ist noch leer. Sie können neue Gerätetypen in der Verwaltung anlegen.",
    emptyDeviceTemplatesHint:
      "Noch keine Gerätetypen angelegt.\nNeuen Gerätetyp mit + erstellen.",
    emptyDeviceTemplatesHintWithoutCreateOption:
      "Noch keine Gerätetypen angelegt.",
    emptyDevicesHint: "Keine Geräte gefunden.\nNeues Gerät mit + erstellen.",
    emptyPanelTypes: "Keine {0} gefunden.",
    errorCategoryNotFound: "Kategorie nicht gefunden",
    errorDeviceNameEmpty: "Gerätetyp ist leer.",
    errorDevicePowerUsageTypeEmpty: "Gerätenutzungstyp ist leer.",
    errorDeviceTemplateHasDevices:
      "Ein Gerätetyp, der Geräte enthält, kann nicht gelöscht werden",
    errorExistingCategoryName:
      "Es existiert bereits eine Kategorie mit diesem Namen",
    errorExistingDeviceName:
      "Ein Gerätetyp mit diesem Namen existiert bereits.",
    errorInvalidElectricityMeterManufacturer: "Zählerhersteller ist ungültig",
    errorInvalidElectricityMeterNumber: "Zählernummer ist ungültig",
    errorInvalidManufacturer: "Hersteller ist ungültig",
    errorInvalidNote: "Bemerkung ist ungültig",
    errorInvalidQrCode: "QR-Code ist ungültig",
    errorInvalidSerialNumber: "Seriennummer ist ungültig",
    errorInventoryNumber: "Bitte Inventarnummer angeben",
    errorInventoryNumberAlreadyExists:
      "Diese Inventarnummer ist bereits vergeben",
    errorInventoryNumberInvalid: "Die Inventarnummer ist ungültig.",
    errorPowerConsumptionPerHourError: "Bitte typische Leistung angeben",
    errorQrCodeAlreadyExists: "Dieser QR-Code ist bereits vergeben",
    errorQrCodeTooLong:
      "QR-Code überschreitet das maximale Zeichenlimit von 30. Bitte geben Sie einen kürzeren Code an.",
    filterAllDevices: "Alle",
    filterAvailableDevices: "Einsetzbar",
    filterDevicesInUsage: "im Einsatz",
    filterUnavailableDevices: "Nicht verfügbar",
    formatLastProjectTimeInfo: "{0} - {1}",
    inventoryNumber: "Inventarnummer",
    lastCheck: "letzter Check",
    lastProject: "Letztes Projekt",
    manageAllDevices: "Geräte auswählen",
    manufacturer: "Hersteller",
    meterInfoStart: "Zählerstand Anfang: {0}",
    meterInfoStartEnd: "Zählerstand {0} - {1}",
    multiDevicesEditDialog: {
      title: "Geräte bearbeiten",
    },
    nextCheck: "nächster Check",
    noDevicePowerUsage: "Keiner",
    noDevicesFound: "Keine Geräte gefunden",
    noMatchingDevicesFound: "Keine passenden Geräte gefunden",
    noQrCode: "Kein Code",
    notAvailable: "Nicht verfügbar",
    note: "Bemerkung",
    operatingHours: "Betriebsstunden",
    operatingHoursFromAssignment: "Zuweisung",
    powerConsumptionPerHour: "Typische Leistung (W)",
    powerUsageType: "Zähler",
    qrCodeNotStored: "Keiner",
    qrCodeStored: "Hinterlegt",
    recentlyClosedProject: "Projekt {0}, von {1} bis {2}",
    recentlyClosedProjectAlt: "Projekt {0}, {1}",
    serialNumber: "Seriennummer",
    title: "Verwaltung Alle Geräte",
  },
  appointmentType: {
    damageAssessment: "Schadenaufnahme",
    dryingConclusion: "Trocknungsabbau",
    dryingSetup: "Trocknungsaufbau",
    followUpInspection: "Wiedervorlage",
    leakDetection: "Leckortung",
    measurement: "Messung",
    repair: "Wiederherstellung",
  },
  archivedProjectList: {
    activeFilters: "--- Aktive Filter: {0} ---",
    deletionConfirmationDialog: {
      errorMessage: "Ausgewählte Projekte konnten nicht gelöscht werden",
      errorMessageAlt: "Ausgewählte Projekte konnten nicht entfernt werden",
      message: "Sind Sie sicher, dass Sie diese Projekte löschen wollen?",
      messageAlt:
        "Sind Sie sicher, dass Sie diese Projekte unwiderruflich entfernen wollen?",
      successMessage: "1 Projekt gelöscht | {count} Projekte gelöscht",
      successMessageAlt: "1 Projekt entfernt | {count} Projekte entfernt",
      title: "1 Projekt löschen | {count} Projekte löschen",
      titleAlt: "1 Projekt entfernen | {count} Projekte entfernen",
    },
    deletedProjectsOverview: "Gelöschte Projekte Übersicht",
    description:
      "Verwaltung alte Projekte: 1 Projekt | Verwaltung alte Projekte: {count} Projekte",
    descriptionAllProjects:
      "Globale Projektsuche: 1 Projekt gefunden | Globale Projektsuche: {count} Projekte gefunden",
    descriptionAlt:
      "Verwaltung gelöschte Projekte: 1 Projekt | Verwaltung gelöschte Projekte: {count} Projekte",
    descriptionSelectionMode:
      "Auswahl alte Projekte: 1 Projekt | Auswahl alte Projekte: {count} Projekte",
    descriptionSelectionModeAlt:
      "Auswahl gelöschte Projekte: 1 Projekt | Auswahl gelöschte Projekte: {count} Projekte",
    filterArchivedProjects: "archiviert",
    filterDeletedProjects: "gelöscht",
    hint: "Zum {0} Projekt mit Klick auswählen",
    manageDeletedProjects: "Gelöschte Projekte auswählen",
    manageOldProjects: "Alte Projekte auswählen",
    loadingArchive: "{0} % geladen",
    noArchivedProjectsFound: "--- keine alten Projekte gefunden ---",
    noProjectsFound: "--- keine Projekte gefunden ---",
    oldProjectsOverview: "Alte Projekte Übersicht",
    title: "Alte Projekte",
    titleAllProjects: "Alle Projekte",
    delete: "Löschen",
    permanentlyDelete: "Entfernen",
    projectsBeingLoaded: "... einen Moment, Liste wird erstellt ...",
    restorationConfirmationDialog: {
      errorMessage:
        "Ausgewählte Projekte konnten nicht wiederhergestellt werden",
      message:
        "Sind Sie sicher, dass Sie die ausgewählten Projekte wiederherstellen wollen?",
      successMessage:
        "1 Projekt wiederhergestellt und in FERTIGE PROJEKTE verschoben | {count} Projekte wiederhergestellt und in FERTIGE PROJEKTE verschoben",
      title: "1 Projekt wiederherstellen | {count} Projekte wiederherstellen",
    },
    restore: "Wiederherstellen",
    restoreAndDelete: "Wiederherstellen / Löschen",
    restoreAndPermanentDelete: "Wiederherstellen / Entfernen",
    maximumProjectsSelectionLimitWarning:
      "Es können maximal 100 Projekte ausgewählt werden",
  },
  archivedProjects: {
    deletionConfirmationDialog: {
      errorMessage:
        "Fehler beim Löschen von Projekt {0}. Projekt nicht gelöscht.",
      errorMessageAlt:
        "Fehler beim Entfernen von Projekt {0}. Projekt nicht entfernt.",
      message: "Sind Sie sicher, dass Sie dieses Projekt löschen wollen?",
      messageAlt:
        "Sind Sie sicher, dass Sie dieses Projekt unwiderruflich entfernen wollen?",
      successMessage: "Projekt {0} gelöscht",
      successMessageAlt: "Projekt {0} entfernt",
      title: "Projekt {0} löschen",
      titleAlt: "Projekt {0} entfernen",
    },
    restorationConfirmationDialog: {
      errorMessage:
        "Fehler beim Wiederherstellen von Projekt {0}. Projekt nicht wiederhergestellt.",
      message:
        "Sind Sie sicher, dass Sie dieses Projekt wiederherstellen wollen?",
      messageAlt: "Dieses Projekt ist archiviert. Projekt wiederherstellen?",
      successMessage:
        "Projekt {0} wiederhergestellt und in FERTIGE PROJEKTE verschoben",
      title: "Projekt {0} wiederherstellen",
      titleAlt: "Projekt wiederherstellen",
    },
    restorationAndDeletionDialog: {
      message: "",
      title: "Projekt {0} wiederherstellen / löschen?",
      titleAlt: "Projekt {0} wiederherstellen / entfernen?",
    },
  },
  assignDevice: {
    addAssignmentHint: "Neue Zuordnung mit +",
    addHyDryAssignmentHint: "Neue Hydry Geräte zuordnen mit +",
    assignDevice: "Gerät zuordnen",
    assignHyDryDevice: "HyDry Gerät zuordnen",
    assignPanel: "Panel zuordnen",
    assignToday: "Heute zuordnen",
    assignmentFrom: "Zuordnung von",
    assignmentHintTitle: "Zuordnung von HyDry Geräten",
    assignmentUntil: "Zuordnung bis",
    billingViaDevice: "Abrechnung über: {0}",
    externalCountingStartDateError:
      "Zuordnung nicht möglich. Startdatum muss ab {0} liegen.",
    externalCountingOpenAssignmentError:
      "Zuordnung nicht möglich. Offene Zuordnung ist nicht erlaubt, da das Abrechnungsgerät bis {0} zugeordnet ist.",
    externalCountingEndDateError:
      "Zuordnung nicht möglich. Enddatum muss bis {0} liegen.",
    countingDeviceHasActiveDependentsError:
      "Freigabe nicht möglich. Es gibt noch aktive Zuordnungen, die über dieses Gerät abgerechnet werden. Bitte geben Sie diese Geräte zuerst frei.",
    countingDeviceWindowBeforeMinDate:
      "Zuordnung nicht möglich. Die Zuordnung von Gerät {0} endet vor dem frühestmöglichen Startdatum dieses Geräts.",
    countingDeviceEndDateTooEarlyError:
      "Freigabe nicht möglich. Das Enddatum muss am oder nach dem {0} liegen, da es zugeordnete Geräte mit einem späteren Enddatum gibt.",
    externalCountingStartDateAdjustedTitle: "Hinweis",
    externalCountingStartDateAdjustedMessage:
      "Das Zuordnungsdatum wurde auf die Zuordnung von Gerät {0} angepasst.",
    collidingAssignment:
      "Am {0} gibt es eine andere Zuordnung (ab {1}).\nZuordnung kann nicht angelegt werden.",
    correct: "Korrigieren",
    correctedBy: "korrigiert {0} {1}",
    countedViaExternalDevice: "Stromabrechnung über anderes Gerät?",
    deleteAssignmentMessage:
      "Sind Sie sicher, dass Sie die Zuordnung löschen wollen?",
    deleteAssignmentTitle: "Gerätezuordnung löschen",
    deviceAlreadyAssigned:
      "HyDry Gerät {0} ist bereits Projekt {1} zugewiesen.",
    genericDeviceAlreadyAssignedMessage:
      "Gerät {0} ist bereits Projekt {1} zugewiesen.",
    deviceAlreadyAssignedMessage:
      "Am {0} gibt es eine andere Zuordnung (bis {1}). \nZuordnung kann nicht angelegt werden.",
    deviceAlreadyAssignedTitle: "HyDry Gerät bereits zugewiesen",
    genericDeviceAlreadyAssignedTitle: "Gerät bereits zugewiesen",
    deviceBranchError:
      "Zuordnung nicht möglich. HyDry Gerät ist am Standort {0}.",
    dryingNoStartedWarning: "Trocknung noch nicht begonnen",
    errorEndDateTitle: "Datum für Ende der Zuordnung prüfen",
    errorMeterReadingEnd: "Wert muss >= Zählerstand Anfang sein",
    errorMeterReadingStart: "Wert muss >= 0 sein",
    errorStartDateTitle: "Datum für Beginn der Zuordnung prüfen",
    formatAssignComBox: "HyDry Box {0} zuordnen",
    formatAssignGenericDevice: "{0} ({1}) zuordnen",
    formatAssignPanel: "HyDry Panel {0} zuordnen",
    formatCalculatedPowerConsumption: "Berechneter Stromverbrauch:",
    assignmentHoursPrompt: "Bitte geben Sie die Einsatzzeit in Stunden an.",
    operationTimeHint: "{0} Stunden (berechnet aus {1} 12:00 bis {2} 12:00)",
    formatCorrectionComBox: "HyDry Box {0} korrigieren",
    formatCorrectionGenericDevice: "{0} ({1}) korrigieren",
    formatCorrectionPanel: "HyDry Panel {0} korrigieren",
    formatHyDryInApartment: "HyDry Geräte Wohnung {0}",
    formatHyDryInElectricitySupply: "HyDry Geräte Strombezug {0}",
    roomLevelAssignToRoomHint: "Geräte werden in diesem Projekt einem Raum zugeordnet. Nutze das Plus beim Raum.",
    roomLevelNoRoomsHint: "Diese Wohnung hat noch keine Räume. Lege zuerst einen Raum an, um Geräte zuzuordnen.",
    formatPowerConsumption: "Stromverbrauch: {0}",
    formatSignOffComBox: "HyDry Box {0} abmelden",
    formatSignOffGenericDevice: "{0} ({1}) abmelden",
    formatSignOffPanel: "HyDry Panel {0} abmelden",
    genericAssignmentHintTitle: "Zuordnung von Geräten",
    meterReadingEnd: "Zählerstand Ende:",
    meterReadingEndChanged: "Zählerstand geändert",
    meterReadingEndChangedMessage: "Zählerstand geändert. Trotzdem sichern?",
    meterReadingFromAssignment: "Projekt {0}: {1}",
    meterReadingFromIot: "ausgelesen: {0}",
    meterReadingStart: "Zählerstand Anfang:",
    meterReadingsForPowerConsumption: "Zählerstände für Stromverbrauch",
    selectNoCountingDevice: "Keine Auswahl",
    selectCountingDeviceTitle: "Geräte für Stromzählung auswählen",
    useForElectricityBilling: "Für Stromabrechnung nutzen?",
    noAvailableHyDryDevices: "Keine verfügbaren HyDry Geräte gefunden",
    noAvailableDevices: "Keine verfügbaren Geräte gefunden",
    deviceAssignedToOtherProject: "Dieses Gerät ist bereits dem Projekt \"{0}\" zugeordnet.",
    deviceInOtherBranch:
      "Dieses Gerät gehört zum Standort \"{0}\". Ändere seinen Standort, um es diesem Projekt zuzuordnen.",
    noMatchingDeviceFound: "Keine passenden HyDry Geräte gefunden",
    noProgramChainsInAssignmentWarning:
      "Keine Trocknung gefunden.\nBitte Zeitraum prüfen.",
    note: "Bemerkung: {0}",
    noUnassignedProgramChainFoundMessage:
      "Im Zeitraum der Zuordnung wurden keine zuordenbaren Trocknungen gefunden.\nZuordnung trotzdem anlegen?",
    powerConsumption: "Stromverbrauch",
    powerConsumptionKWh: "Stromverbrauch (kWh)",
    powerConsumptionRemote: "Stromverbrauch (Fernauslesungen bitte überprüfen)",
    signOff: "Abmelden",
    signOffToday: "Heute abmelden",
    releaseDependantDevicesFirst: "Abhängige Geräte müssen zuerst abgemeldet werden.",
    assignmentSavedSuccess: "Zuordnung erfolgreich gespeichert.",
    assignmentSavedError: "Beim Speichern der Zuordnung ist ein Fehler aufgetreten.",
    assignmentReleasedSuccess: "Zuordnung erfolgreich abgemeldet.",
    assignmentReleasedError: "Beim Abmelden der Zuordnung ist ein Fehler aufgetreten.",
    assignmentCorrectedSuccess: "Zuordnung erfolgreich korrigiert.",
    assignmentCorrectedError: "Beim Korrigieren der Zuordnung ist ein Fehler aufgetreten.",
    assignmentDeletedSuccess: "Zuordnung erfolgreich gelöscht.",
    assignmentDeletedError: "Beim Löschen der Zuordnung ist ein Fehler aufgetreten.",
    releaseDevices: "Geräte freigeben",
    devicesAssignedCount: "1 Gerät zugeordnet | {n} Geräte zugeordnet",
  },
  assignDeviceToProjectBranchDialog: {
    changeBranch: "Gerät holen",
    message:
      "Gerät {0} ist am Standort {1} verfügbar.\nSoll das Gerät an den aktuellen Standort {2} geholt werden?",
    title: "Standort Gerät",
  },
  assignIresDevice: {
    assignAnyway: "Trotzdem an diesem Tag zuordnen",
    assignAnywayMessage:
      "Die Zuordnung erfolgt ab {0}.\nTrocknung {1} kann nicht zugeordnet werden.",
    chainWillBeAssignedMessage:
      "Die Abmeldung erfolgt am {0}.\nTrocknung {1} wird zugeordnet.",
    dialogIncludeOverlappingProgramChainFinishedMessage:
      "Am {0} läuft eine Trocknung (Trocknung {1}, begonnen am {2}, abgeschlossen am {3}).\nDiese Trocknung wird zugeordnet.\nWählen Sie möglichst einen anderen Tag.",
    dialogOverlappingProgramChainFinishedMessage:
      "Am {0} läuft eine Trocknung (Trocknung {1}, begonnen am {2}, abgeschlossen am {3}).\nDiese Trocknung wird nicht zugeordnet.\nWählen Sie möglichst einen anderen Tag.",
    dialogOverlappingProgramChainMessage:
      "Am {0} läuft eine Trocknung (Trocknung {1}, begonnen am {2}).\nDiese Trocknung wird nicht zugeordnet.\nWählen Sie möglichst einen anderen Tag.",
    releaseAnyway: "Trotzdem an diesem Tag abmelden",
  },
  assignLicences: {
    basic: "Basis",
    basicLicences: "Lizenzen Basis",
    damageAssessmentAndLeakDetection: "Aufnahme",
    damageAssessmentAndLeakDetectionLicences: "Lizenzen Aufnahme",
    drying: "Trocknung",
    dryingLicences: "Lizenzen Trocknung",
    dryingAndRepair: "Trocknung",
    dryingAndRepairLicences: "Lizenzen Trocknung",
    errorLicencesV3LimitExceeded:
      "Zulässige Lizenzen überschritten. Sicherung nicht möglich.",
    errorMissingLicences: "Alle Lizenzen vom Typ {0} werden bereits verwendet.",
    formatUsage: "{0} von {1}",
    formatUsageMemberClients: "{0}",
    numMemberClients: "Niederlassungen (ohne Master)",
    leakDetection: "Leckortung",
    overviewLicences: "Übersicht Lizenzen",
    overviewUsedLicences: "Übersicht genutzte Lizenzen",
    selectLicences: "Lizenzen auswählen",
  },
  assignmentDetails: {
    titleComBox: "HyDry Box {0}",
    titlePanel: "HyDry Panel {0}",
  },
  changeEmailAndPassword: {
    changeEmailAndPasswordTitle: "Datenbank Mailadresse und Passwort ändern",
    emailAddress: "E-Mail-Adresse",
    emailAddressAlreadyUsed: "Diese E-Mail-Addresse wird bereits verwendet",
    firstSignInMessage: "Bitte die nachfolgenden Felder ausfüllen",
    firstSignInTitle: "Erstanmeldung",
    newEmailAddress: "Neue Datenbank-Mailadresse",
    oldPassword: "Bisheriges Passwort",
    password: "Passwort",
    passwordError: "Passwort stimmt nicht",
  },
  chartData: {
    ground: "Boden",
    groundTemp: "Temperatur Boden",
    humidity: "Feuchte",
    intensity: "Intensität",
    temp: "Temperatur",
    wall: "Wand",
    wallTemp: "Temperatur Wand",
  },
  clientData: {
    addContactPerson: "Kontaktperson +",
    addDevices: "Geräte hinzufügen",
    additionalInsuranceInfo: "Versicherungszusatz",
    apartment: "Wohnung",
    apartmentNumber: "W{0}",
    appointmentAgreement: "Terminvereinbarung",
    approveProject: "Projekt bestätigen",
    approvedBy: "Projekt bestätigt: {0} durch {1}",
    changeProjectOwner: "Projektbearbeiter ändern",
    changingProjectTypeToPortalMessage:
      "Sind Sie sicher, dass das Projektmanager-Projekt zu einem Portal-Projekt geändert werden soll?",
    changingProjectTypeToPortalTitle: "Änderung des Projekttyps",
    changingProjectTypeToProjectmanagerMessage:
      "Sind Sie sicher, dass das Portal-Projekt zu einem Projektmanager-Projekt geändert werden soll?",
    changingProjectTypeToProjectmanagerTitle: "Änderung des Projekttyps",
    client: "Auftraggeber",
    confirmProject: "Projekt bestätigen",
    confirmProjectTitle: "Projekt bestätigen?",
    contact: "Kontakt Allgemein",
    contactBy: "Kontakt durch",
    contactPerson: "Kontakt Wohnung",
    contract: "Auftrag",
    contractCreatedBy: "Ausgeführt von",
    contractType: "Auftragsart",
    copyClient: "Wie Auftraggeber",
    copyPolicyHolder: "Wie Versicherungsnehmer",
    createProject: "Projekt anlegen",
    createdAt: "Auftrag erfasst: {0} durch {1}",
    createdWithAppVersion: "Projekt App Version",
    damage: "Schaden",
    damageAssessment: "Schadenaufnahme",
    damageDay: "Schadendatum",
    damageId: "Schadenreferenz",
    damageLocation: "Schadenort",
    damageNumber: "Schadennummer",
    damageNumberShort: "Schadennr.",
    damageType: "Schadenart",
    datePlanned: "Datum geplant",
    deleteContactPartnerConfirmationMessage:
      "Kontaktperson {0} wirklich löschen?",
    deleteContactPartnerConfirmationTitle: "Kontaktperson löschen",
    deleteContactPerson: "Kontaktperson -",
    deleteContactPersonBlockedByDevices:
      "Wohnung {0} kann nicht gelöscht werden, da Geräte zugeordnet sind.",
    contactPersonAddedSuccess: "Wohnung {0} hinzugefügt",
    contactPersonDeletedSuccess: "Wohnung {0} gelöscht",
    deleteProject: "Projekt löschen",
    deleteProjectMessage:
      "Willst du dieses Projekt wirklich löschen?",
    deleteProjectErrorMessage:
      "Fehler beim Löschen von Projekt {0}. Projekt nicht gelöscht.",
    deleteProjectSuccessMessage: "Projekt {0} gelöscht",
    deleteProjectTitle: "Projekt {0} löschen",
    directOrder: "Direktauftrag",
    doNotApproveProject: "Projekt nicht bestätigen",
    firstContact: "Kontaktaufnahme",
    saveProjectErrorMessage: "Fehler beim Speichern des Projekts",
    formatApartment: "Wohnung {0}",
    formatElectricitySupply: "Strombezug {0}",
    formatBranch: "Standort: {0}",
    formatContactPerson: "Kontaktperson {0}",
    formatNote: "Notiz: {0}",
    formatProjectNumberIres: "Projektnummer IRES: {0}",
    formatProjectNumberOffice: "Projektnummer Office: {0}",
    formatProjectNumberOfficeForSantec: "Projektnummer Office: {0} / {1}",
    formatProjectOwner: "Projektbearbeiter: {0}",
    formatProjectStart: "Projektbeginn: {0}",
    formatProjectSupervisor: "Projektleiter: {0}",
    insurance: "Versicherung",
    insuranceCase: "Versicherungsfall",
    insuranceContactName: "Name",
    insuranceName: "Versicherungsname",
    lossAdjuster: "Schadenbearbeiter",
    mainContractNumber: "Hauptauftragsnummer: {0}",
    missingProjectNumberOfficeMessage:
      "„Projektnummer Office“ nicht angegeben. Projekt trotzdem bestätigen?",
    missingProjectNumberOfficeTitle: "Projektnummer Office",
    mobilePhone: "Mobil {0}",
    moveProjectToFinishedDialog: {
      errorMessage: "Projekt {0} wurde nicht in FERTIGE PROJEKTE verschoben",
      message:
        "Willst du dieses Projekt wirklich in FERTIGE PROJEKTE verschieben?",
      successMessage: "Projekt {0} wurde in FERTIGE PROJEKTE verschoben",
      title: "Projekt {0} verschieben",
    },
    moveProjectToRunningDialog: {
      acceptButtonText: "Wieder öffnen",
      acceptButtonTextAlt: "Wieder aktivieren",
      errorMessage: "Projekt {0} nicht wieder geöffnet",
      errorMessageAlt: "Projekt {0} nicht wieder aktiviert",
      message: "Projekt wirklich wieder öffnen?",
      messageAlt: "Projekt wirklich wieder aktivieren?",
      messageForRestoredProjects:
        "Dieses Projekt wurde wiederhergestellt. Projekt wieder öffnen?",
      messageForRestoredProjectsAlt:
        "Dieses Projekt wurde wiederhergestellt. Projekt wieder aktivieren?",
      successMessage:
        "Projekt {0} wieder geöffnet und in AKTUELLE PROJEKTE verschoben",
      successMessageAlt:
        "Projekt {0} wieder aktiviert und in AKTUELLE PROJEKTE verschoben",
      title: "Projekt {0} wieder öffnen",
      titleAlt: "Projekt {0} wieder aktivieren",
    },
    newOrder: "Neuer Auftrag",
    note: "Notiz",
    pdfDocument: "PDF 1 hinzufügen",
    pdfDocument2: "PDF 2 hinzufügen",
    pdfDocumentInfo: "Weitere Informationen im PDF",
    phone: "Tel. {0}",
    policy: "Police",
    policyHolder: "Versicherungsnehmer",
    policyNumber: "Policenummer",
    process: "Vorgang",
    processNumber: "Vorgangsnummer",
    projectControl: "Projektsteuerung",
    projectControlHint: "Eingeben und Ändern durch Klick auf farbige Felder",
    projectData: "Projektdaten",
    projectHint: "Eingeben und Ändern durch Klick auf farbige Felder",
    projectName: "Projektname",
    projectNameErp: "Sammelnummer",
    projectNumber: "Projektnummer",
    projectNumberIres: "Projektnummer IRES",
    projectNumberOffice: "Projektnummer Office",
    projectOwner: "Projektbearbeiter",
    projectStartDate: "Projektbeginn",
    projectSupervisor: "Projektleiter",
    regulation: "Regulierung",
    regulationBy: "Regulierung durch",
    rejectProject: "Projekt ablehnen",
    rejectedBy: "Projekt abgelehnt: {0} durch {1}",
    runningTasksSuspensionDeleteQuestion: "Wirklich löschen?",
    runningTasksSuspensionMoveToFinishedQuestion:
      "Wirklich in FERTIGE PROJEKTE verschieben?",
    runningTasksSuspensionWarning:
      "Auf diesem Projekt wird noch gearbeitet ({0}). Die Aufgabe wird unterbrochen. | Auf diesem Projekt wird noch gearbeitet ({0}). Die Aufgaben werden unterbrochen.",
    setProjectOwner: "Projektbearbeiter setzen",
    setProjectSupervisor: "Projektleiter setzen",
    timePlanned: "Zeit geplant",
    title: "Anrede",
    uploadDocument: "Dokument hochladen",
  },
  clientSelector: {
    client: "Welche Niederlassung(en)?",
  },
  cockpit: {
    allDevices: "Geräteverwaltung",
    allHyDryDevices: "Alle HyDry Geräte",
    allProjects: "Alle Projekte",
    appointmentManagement: "Terminvereinbarung",
    appointments: {
      later: "Später",
      overdue: "Überfällig",
      today: "Heute",
      tomorrow: "Morgen",
    },
    createNewProject: "Neues Projekt anlegen",
    dummyCardTitle: "Nichts zu tun!",
    extras: "Extras",
    formatCompany: "Niederlassung: {0}",
    iresExtra: {
      backToUser: "Zurück zu {0}",
      selectClient: "Mandant auswählen",
      selectSharedUser: "Geteilten Benutzer auswählen",
      selectUser: "Benutzer auswählen",
    },
    iresExtras: "IRES Extras",
    myAppointments: "Meine Termine",
    myHyDryDevices: "Meine HyDry Geräte",
    myMessages: "Meine Nachrichten",
    myProjects: "Meine Projekte",
    projectOrganisation: "Projektorganisation",
    projects: "Projekte",
    relevantProjects: "Relevante Projekte",
  },
  comBox: {
    deviceList: {
      formatSensorValuesFloor: "Boden: {0}, Feuchte: {1}",
      formatSensorValuesRoom: "Raum: {0}, Feuchte: {1}",
    },
    deviceState: {
      active: "Trocknung läuft",
      dryRunEnded: "Trocknung beendet",
      idle: "Trocknung beginnen",
      lidClosed: "Deckel geschlossen",
      lidOpen: "Deckel geöffnet",
      malfunction: "Fehler",
      paused: "Pausiert",
      powerFail: "Stecker gezogen",
      standBy: "Aus",
      suspended: "angehalten",
      transition: "Transition",
      waiting: "unterbrochen",
      warning: "Warnung",
    },
    dryingPauseType: {
      humidityThresholdReached: "Entfeuchtungs-Pause aktiv",
      manual: "Manuelle Pause aktiv",
      powerOverload: "Überlast-Pause aktiv",
      program: "Programmpause aktiv",
      temperatureTooHigh: "Übertemperatur-Pause aktiv",
    },
    errors: {
      error0: "Echtzeituhr defekt",
      error1: "Ungültige Uhrzeit",
      error2: "Speicher defekt (EEPROM)",
      error3: "Speicher defekt (SPI Flash)",
      error4: "Display Timeout",
      error5: "Energiemengenzähler antwortet nicht",
      error6: "Kein Leitsensor",
      error7: "Sensortemperatur zu hoch",
      error8: "Umgebungstemperatur zu hoch",
      error9: "Leistungsaufnahme zu hoch",
      error10: "Kurzschluss an einem der Sensoren",
      error11: "Sensor 1 reagiert nicht",
      error11New: "Min. einer der Sensoren reagiert nicht",
      error12: "Sensor 2 reagiert nicht",
      error13: "Sensor 3 reagiert nicht",
      error14: "Sensor 4 reagiert nicht",
      error15: "Umgebungssensor reagiert nicht",
      error15New: "Raumsensor defekt",
      error16: "Relais defekt",
      error17: "BLE Modem reagiert nicht",
      error18: "NB1 Modem bootet nicht",
      error19: "SIM-Karte nicht erkannt",
      error20: "Box auf Werkszustand zurückgesetzt",
      error21: "Gerätekonfig zurückgesetzt",
      error22: "Mandantenkonfig zurückgesetzt",
      error23: "Trocknungskonfig zurückgesetzt",
      error24: "Watchdog-Reset",
      error25: "Overrun UART 1",
      error26: "Overrun UART 2",
      error27: "Overrun UART 3",
      error28: "Overrun UART 4",
      error29: "Overrun UART 5",
    },
    events: {
      event: "Event {0}",
      event1: "Box mit Strom verbunden",
      event2: "Box eingeschaltet, Trocknung unterbrochen",
      event3: "Box eingeschaltet, Trocknung fortgesetzt",
      event6: "Box eingeschaltet",
      event7: "Neue Trocknung gestartet",
      event8: "Neuer Lauf gestartet",
      event9: "Trocknung angehalten",
      event10: "Trocknung fortgesetzt",
      event11: "Trocknung fortgesetzt",
      event12: "Trocknung beendet",
      event13: "Trocknung beginnen",
      event14: "Box ausgeschaltet",
      event15: "Stufe beendet",
      event16: "Programmende",
      event17: "Neuer Lauf gestartet (max. Laufzeit)",
      event18: "Neuer Lauf gestartet (max. Anzahl Samples)",
      event20: "Nachtpause begonnen",
      event21: "Nachtpause beendet",
      event22: "Monitor Sample",
      event23: "Monitorintervall beendet",
      event24: "Trocknungspause begonnen",
      event25: "Trocknungspause beendet",
      event26: "Verlängerung Phase",
      event28: "Warnung",
      event29: "Fehlfunktion",
      event30: "Neustart (Boot)",
      event31: "Box vom Strom getrennt",
      event32: "BLE Verbindung aufgebaut",
      event33: "BLE Verbindung abgebaut",
      event34: "Programmstart",
      event36: "Deckel geöffnet",
      event37: "Deckel geschlossen",
      event40: "NB1 Verbindung mit Netz aufgebaut",
      event41: "NB1 Verbindung mit Netz fehlgeschlagen",
      event42: "NB1 Verbindung mit Server aufgebaut",
      event43: "NB1 Verbindung mit Server fehlgeschlagen",
      event44: "NB1 Verbindung Timeout",
      event45: "NB1 Verbindung geschlossen",
      event46: "NB1 Netz abgemeldet",
      event47: "NB1 deaktiviert",
      event48: "NB1 Verbindung beendet (0) (abmelden)",
      event49: "NB1 Verbindung beendet (1) (neu aufbauen)",
      event50: "NB1 Verbindung beendet (2)",
      event53: "NB1 Update Signalqualität",
      event54: "NB1 Modem eingeschaltet",
      event55: "NB1 Modem ausgeschaltet",
      event56: "NB1 Session Retry",
      event59: "Sommer- / Winterzeit",
      event60: "Uhrzeit aktualisiert",
      event61: "Neustart (Kommando)",
      event62: "Neustart (neue Konfiguration)",
      event64: "Reset (Gerätekonfiguration)",
      event65: "Neustart (neue Firmware)",
      event66: "Neustart (neue Firmware Display)",
      event67: "Update (Konfiguration)",
      event68: "Update (Firmware IPU)",
      event69: "Update (Firmware Display)",
      event70: "Messung Batteriespannung",
      event71: "Depassivierung Batterie begonnen",
      event72: "Depassivierung Batterie beendet",
      event75: "128 Fehler auf I2C2",
      event76: "NB1 Status bei Powerfail",
      event77: "Sensorkonfiguration geändert",
      event80: "Raumtemperatur zu hoch",
      event81: "Raumtemperatur okay",
      event82: "Raumluft ausreichend entfeuchtet",
      event83: "Raumluft wird wieder entfeuchtet",
      event84: "Raumtemperatur sehr niedrig",
      event86: "Raumfeuchte sehr hoch",
      event88: "Überlastungspause",
      event125: "Steckdose wurde verzögert eingeschaltet",
      warningFixed: "Warnung behoben",
    },
    formatComBox: "Box {0}",
    formatComBoxError: "Fehler:\n{0}",
    formatComBoxInfo: "Info:\n{0}",
    formatComBoxWarning: "Warnung:\n{0}",
    humidityUnit: {
      absoluteHumidity: "abs. Feuchte",
      absoluteHumidityAll: "abs. Feuchte/Regen/Druck/Leistung",
      absoluteHumidityAllWithoutPower: "abs. Feuchte/Regen/Druck",
      absoluteHumidityAndPower: "abs. Feuchte/Leistung",
      absoluteHumidityAndPressure: "abs. Feuchte/Druck",
      formatAbsoluteHumidity: "{0} g/m³",
      formatAbsoluteHumidityAll: "{0} g/m³ / {1}mm / {2}hPa / {3}W",
      formatAbsoluteHumidityAllWithoutPower: "{0} g/m³ / {1}mm / {2}hPa",
      formatAbsoluteHumidityAndPower: "{0} g/m³ / {1}W",
      formatAbsoluteHumidityAndPressure: "{0} g/m³ / {1}hPa",
      formatMixingRatio: "{0} g/kg",
      formatMixingRatioAll: "{0} g/kg / {1}mm / {2}hPa / {3}W",
      formatMixingRatioAllWithoutPower: "{0} g/kg / {1}mm / {2}hPa",
      formatMixingRatioAndPower: "{0} g/kg / {1}W",
      formatMixingRatioAndPressure: "{0} g/kg / {1}hPa",
      formatPercent: "{0}%",
      formatPercentAll: "{0}% / {1}W / {2}hPa",
      formatPercentAndPressure: "{0}% / {1}hPa",
      formatPercentAndPowerConsumption: "{0}% / {1}W",
      formatPercentAndPowerConsumptionAndPressure: "{0}% / {1}W / {2}hPa",
      formatRelativeHumidity: "{0} %rF",
      mixingRatio: "Mischverhältnis",
      mixingRatioAll: "Mischv/Regen/Druck/Leistung",
      mixingRatioAllWithoutPower: "Mischv/Regen/Druck",
      mixingRatioAndPower: "Mischv/Leistung",
      mixingRatioAndPressure: "Mischv/Druck",
      powerConsumption: "Leistung",
      relativeHumidity: "rel. Feuchte",
      relativeHumidityAll: "rel. Feuchte/Regen/Druck/Leistung",
      relativeHumidityAndPressure: "rel. Feuchte/Regen/Druck",
      relativeHumidityAndPowerConsumption: "rel. Feuchte/Leistung",
      relativeHumidityAndPowerConsumptionAndPressure:
        "rel. Feuchte/Leistung/Druck",
    },
    nightModeActive: "Nachtschaltung aktiv",
    relativeHumidity: "rel. Feuchte",
    sensorType: {
      bluetoothType3: "BLE Typ 3",
      bluetoothType1: "BLE Typ 1",
      bluetoothType5: "BLE Typ 5",
      empty: "Kein Sensor",
      radon: "Radon",
      sht3x: "SHT3X",
      telaire: "Telaire",
      unknow: "Unbekannt",
    },
    temperature: "Temperatur",
  },
  comBoxClientConfig: {
    clientConfig: "HyDry Control Mandantenkonfiguration",
    createClientConfig: "HyDry Control Mandantenkonfiguration erstellen",
    displayMessage: "Displaytext",
    expertMode: "Expertenmodus",
    formatSensorProgram: "S{0}",
    invalidHumidityUnitError: "Bitte wählen Sie eine andere bevorzugte Feuchtigkeitseinheit aus.",
    name: "Name",
    programmSensors: "Programmsensoren",
    selectableDryingPrograms: "Auswählbare Trocknungsprogramme",
    selectableDryingProgramsBox: "Auswählbare Trocknungsprogramme (Box)",
    selectableDryingProgramsMini: "Auswählbare Trocknungsprogramme (Mini)",
    defaultProgramMini: "Standard Programm (Mini)",
    selectableSensorPrograms: "Auswählbare Sensorprogramme",
    sensor: "Sensor {0}",
    version: "Version",
  },
  sensorInfo: {
    title: "SENSOR INFO ({0})",
    titleRoom: "SENSOR INFO (RAUM)",
    serialNumber: "Seriennummer",
    type: "Typ",
    status: "Status",
    statusOk: "OK",
    statusBatteryLow: "Batterie schwach",
    statusPoorLink: "Schlechte Verbindung",
    statusSensorLost: "Sensor verloren",
    statusTurnedOff: "Sensor wurde manuell ausgeschaltet",
    typeTempHumidity: "Temp / Feuchte-Sensor",
    typePressure: "Drucksensor",
    typeHammerElectrode: "Einschlagelektrode",
    typeRadon: "Radonsensor",
    typeInternalSensor: "Interner Sensor der Box",
    connection: "Verbindung",
    wired: "Kabelgebunden",
    wireless: "Kabellos",
    integrated: "Integriert",
    signalStrength: "Signalstärke",
    batteryStatus: "Batteriestatus",
    firmware: "Firmware",
    noData: "Keine Sensordaten verfügbar",
  },
  dryingGraph: {
    temperatureAxisLabel: "Temp",
    absoluteHumidityAxisLabel: "abs. Feuchte",
    relativeHumidityAxisLabel: "rel. Feuchte",
    mixingRatioAxisLabel: "Mischv",
    resistanceDigitsAxisLabel: "Digits",
    formatResistanceDigits: "{0}",
    tooltipSensorHumidity: "Feuchte",
    tooltipSensorResistance: "Digits",
    tooltipSensorTemperature: "Temperatur",
    tooltipWeather: "Wetter",
    tooltipPower: "Leistung",
    tooltipIntensity: "Intensität",
    weatherDataUnavailable: "Wetterdaten konnten nicht geladen werden. Bitte versuchen Sie es später erneut.",
  },
  comBoxDetail: {
    confirmMeterReadingPowerUpTitle: "HyDry Box wird eingeschaltet",
    confirmMeterReadingUpMessage:
      "Bitte aktuellen Stand des Stromzählers bestätigen",
    control: {
      change: "ÄNDERN",
      confirmPowerOn: {
        messageBox:
          "Sind Sie sicher, dass Sie die Box einschalten wollen?\nWenn der Deckel geöffnet ist, werden die Steckdosen aktiviert.",
        messageMini:
          "Sind Sie sicher, dass Sie den MINI einschalten wollen?\nBeim Einschalten werden die Steckdosen aktiviert.",
        title: "HyDry Box aus Standby einschalten",
      },
      formatPowerOnTitle: "Box {0} einschalten",
      iotMeterReadingHint:
        "Anweisung wird bei nächster IoT-Verbindung ausgeführt. Zählerstand wird über IoT ausgelesen und übernommen. Sind Sie sicher?",
      pause: "Pause",
      powerOff: "Ausschalten",
      powerOn: "Einschalten",
      relays: "Relais",
      resume: "Fortsetzen",
      start: "Starten",
      terminate: "Beenden",
    },
    controlConfig: {
      changeDryRun: "Box {0}: Trocknung ändern",
      currentConfigUnknown:
        "Die aktuellen Einstellungen dieser Box sind nicht bekannt. Vorausgefüllt sind die Standardeinstellungen: prüfe sie, bevor du speicherst.",
      defaultDryingMode: "Standard Verfahren",
      defaultNightMode: "Standardkonfiguration Nachtbetrieb",
      defaultProgram: "Standard Programm",
      defaultProgramBox: "Standard Programm (Box)",
      defaultSocketAB: "Standardkonfiguration Steckdosen A+B",
      defaultSocketCD: "Standardkonfiguration Steckdosen C+D",
      dryRunParameters: "BETRIEBSPARAMETER",
      dryingMode: "Verfahren",
      dryingModeChangeDisabledDialogMessage:
        "Betriebsart kann bei laufender Trocknung nicht geändert werden. Trocknung zuerst beenden.",
      dryingModeChangeDisabledDialogTitle: "Betriebsart ändern",
      dryingModeOptions: {
        monitor: "Monitor",
        negativePressure: "Unterdruck",
        positivePressure: "Überdruck",
        pushPull: "Schiebezug",
        roomDrying: "Raumtrocknung",
        tentDrying: "Target drying",
      },
      formatNightModeParameters: "von {0} bis {1}\n{2}   {3}",
      formatNightModeParametersAlternate: "{0}-{1}, {2}, {3}",
      formatNightModeParametersNoDaysAlternate: "{0}-{1}, {2}",
      missingFloorSensorWarningMessageForBoxDefault:
        "Trocknungsprogramm ohne Bodensensoren ausgewählt:\nEs erfolgt eine rein zeitliche Steuerung bis zur maximalen Programmdauer.",
      missingFloorSensorWarningMessageForBoxSupportingRoomDrying:
        "Trocknungsprogramm ohne Bodensensoren ausgewählt:\nEs erfolgt eine rein zeitliche Steuerung bis zur maximalen Programmdauer.\n\nWir empfehlen die Trocknung mit dem Programm RAUMTROCKNUNG.",
      missingFloorSensorWarningStartAnyway: "Trotzdem Starten",
      missingFloorSensorWarningTitle: "Trocknungsprogramm prüfen",
      nightMode: "Nachtbetrieb",
      nightModeDays: "Tage Nachtschaltung",
      nightModeEnd: "Ende Nachtschaltung",
      nightModeOff: "Nachtbetrieb aus",
      nightModeOn: "Nachtbetrieb ein",
      nightModeSockets: "Nachtbetrieb Steckdosen",
      nightModeSocketsOptions: {
        allSockets: "Alle Steckdosen",
        allSocketsAlternate: "Alle",
        allSocketsShort: "Alle",
        allSocketsShortAlternate: "Alle",
        programSockets: "Programmsteckdosen",
        programSocketsAlternate: "Prog",
        programSocketsShort: "Prog",
        programSocketsShortAlternate: "Prog",
      },
      nightModeStart: "Anfang Nachtschaltung",
      program: "Programm",
      roomDryingHintMessageBox:
        "Folgende Einstellungen werden empfohlen:\n\nSteckdosen A+B PROG: Luftentfeuchter\nSteckdosen C+D AN: Gebläse und/oder Geräte für Wandtrocknung",
      roomDryingHintMessageMini:
        "Folgende Einstellungen werden empfohlen:\n\nSteckdose A PROG: Luftentfeuchter\nSteckdose B AN: Gebläse und/oder Geräte für Wandtrocknung",
      roomDryingHintTitle: "Raumtrocknung",
      sensors: "SENSOREN",
      socketA: "Steckdose A",
      socketAB: "Steckdosen A+B",
      socketB: "Steckdose B",
      socketCD: "Steckdosen C+D",
      socketModeOptions: {
        off: "Aus",
        on: "An",
        program: "Prog",
      },
      start: "Starten",
      startDryRun: "Box {0}: Trocknung starten",
    },
    floorTempHumidity: "Boden Temp / Feuchte",
    tempHumidity: "Temp / Feuchte",
    formatEndOfPhase: "P{0} Ende",
    formatEndOfPhases: {
      boost: "Boost Ende",
      comfort: "Comfort Ende",
      eco: "Eco Ende",
      smart: "Smart Ende",
    },
    formatPhase: "Phase {0}",
    formatProgram: "P{0}",
    formatSensor: "Sensor {0}",
    monitor: "Monitor",
    nightModeParameters: {
      title: "Einstellungen Nachtbetrieb",
    },
    pause: {
      confirm: "Pause bestätigen",
      hint: "Pause (min)",
      message: "Bitte Länge der Pause (min) angeben",
      title: "Box {0} pausieren",
    },
    phases: "Phasen",
    postDryingRun: "Nachlauf",
    program: "Programm",
    programDryingSensor: "Trocknung Sensor",
    programDryingTime: "Trocknung Zeit",
    roomTempHumidity: "Raum Temp / Feuchte",
    sensorData: {
      roomSensor: "Raum",
      sensor: "Sensor",
    },
    sensorUsage: {
      measurement: "Messung",
      measurementShort: "MESS",
      program: "Programm",
      programShort: "PRG",
      reference: "Referenz",
      referenceShort: "REF",
      usage: "Verwendung",
    },
    sensorUsageRecommendation: {
      dryingMode: "Betriebsart",
      hint1: "Folgende Sensoreinstellungen werden empfohlen:",
      hint2: "Siehe auch Betriebsanleitung.",
      referenceSensor: "Referenzsensor",
      roomSensor: "Raumsensor",
      roomSensorOrSensor1: "Raumsensor oder Sensor 1",
      sensor1: "Sensor 1",
      title: "Trocknungsprogramm mit Sensorsteuerung ausgewählt",
    },
    terminateDryRun: {
      dryRunKeyValues: "TROCKNUNGSDATEN",
      keyValueCurrent: "Aktuell",
      keyValueDuration: "Laufzeit",
      keyValueHumidity: "Feuchte",
      keyValueMeter: "Zähler",
      keyValueStart: "Start",
      terminateDryRun: "Trocknung abschließen",
    },
    testRelays: {
      numCycles: "Schaltzyklen",
      onOffDuration: "Ein- und Ausschaltdauer (1/10 sec)",
      relay1Active: "Relais 1 aktiv",
      relay2Active: "Relais 2 aktiv",
      title: "Relais Test {0}",
    },
    title: "Details Box {0}",
  },
  comBoxSampleIotInfo: {
    batteryVoltageToLow: "Batteriespannung zu niedrig",
    configurationType: "Konfigurationstyp: {0}",
    configurationInfo: "Konfigurationsinformationen: {0}",
    disconnectFailure: "Fehler beim Senden des NB1-Disconnects",
    formatIotInfo:
      "Powerfail Meldung: {0} ({1}), BC66: {2}, NB1: {3}, Zähler: {4}",
    iotConnectonDisabled: "NB1 Verbindung deaktiviert",
    iotServerConnectionFailure: "IoT Server nicht erreichbar",
    noIpAddress: "Keine IP Adresse",
    noNetwork: "Einbuchen fehlgeschlagen",
    reserved: "Reserviert",
    socketFailure: "Fehler bem Öffnen des Sockets",
    success: "Erfolgreich versandt",
    timeoutIotServerConnect: "Timeout beim Verbinden mit IoT Server",
    unexpectedModemReset: "Unerwarteter Modem Reset",
  },
  comBoxSettings: {
    battery: "Batterie",
    electricityMeter: "Stromzähler",
    factoryReset: {
      action: "Werkseinstellungen",
      confirm: "Zurücksetzen",
      consequences: {
        datalog: "Alle Läufe auf der Box werden gelöscht. Was die Box bereits übertragen hat, bleibt im Portal erhalten.",
        queued: "Die Befehle werden über IoT vorgemerkt und beim nächsten Kontakt der Box ausgeführt.",
        reboot: "Die Box startet danach neu.",
        terminate: "Läuft auf der Box eine Trocknung, wird sie zuerst beendet.",
      },
      flags: {
        bConfig: "Basiskonfiguration",
        cConfig: "Mandantenkonfiguration",
        counters: "Betriebsstunden- und Einschaltzähler",
        datalog: "Datenlog: alle Läufe auf der Box löschen",
        dConfig: "Trocknungs- und Sensorprogramme",
        fileInfo: "Dateien: Logo und Firmware-Images",
      },
      queueFailed: "Das Zurücksetzen konnte nicht vorgemerkt werden.",
      reboots: "Startet die Box neu",
      title: "Box {0} zurücksetzen",
    },
    firmwareDisplay: "Firmware Display",
    firmwareIPU: "Firmware IPU",
    mcuResetSource: "MCU Reset Source",
    mcuResetSourceValues: {
      independentWatchdog: "Independent Watchdog",
      lowPower: "Low-Power",
      powerOn: "Power-On",
      resetPin: "Reset-Pin",
      software: "Software",
      windowWatchdog: "Window Watchdog",
    },
    restartConfirmMessage: "Der Neustart wird über IoT vorgemerkt.",
    restartConfirmTitle: "Box {0} neu starten?",
    title: "Einstellungen Box {0}",
  },
  common: {
    abort: "ABBRECHEN",
    apply: "ÜBERNEHMEN",
    refresh: "Aktualisieren",
    download: "Herunterladen",
    address: "Adresse",
    all: "Alle",
    allDevices: "Alle Geräte",
    activeDevices: "Aktive Geräte",
    activeHydryDevices: "Aktive HyDry Geräte",
    and: "und",
    api: "API",
    appointment: "Termin",
    appUpdate: {
      message: "Eine neue Version ist verfügbar.",
      refresh: "Neu laden",
      later: "Später",
    },
    archived: "Archiviert",
    areYouSure: "Sind Sie sicher?",
    assign: "Zuordnen",
    back: "ZURÜCK",
    barcode: "BARCODE",
    both: "Beide",
    box: "Box",
    branch: "Standort",
    branchDeleted: "Standort gelöscht",
    branches: "Standorte",
    build: "Build {0} ({1})",
    change: "ÄNDERN",
    changesNotSaved: "Änderungen nicht gespeichert",
    changesSaved: "Änderungen gespeichert",
    close: "Schließen",
    concluded: "Abgeschlossen",
    confirm: "Bestätigen",
    confirmationDialog: {
      cancelMessage:
        "Sie haben bereits Änderungen getätigt. Möchten Sie diese Änderungen verwerfen?",
      cancelTitle: "Änderungen verwerfen?",
      unsavedChangesMessage: "Willst du wirklich abbrechen?",
      unsavedChangesTitle: "Vorsicht Datenverlust",
    },
    confirmSignOutMessage: "Wollen Sie sich wirklich abmelden?",
    confirmSignOutTitle: "Abmelden",
    country: "Land",
    currentProject: "Aktuelles Projekt: {0}",
    dataComplete: "Daten vollständing",
    dataSaved: "Daten gespeichert",
    date: "Datum",
    dayOfTheWeek: {
      friday: "Fr",
      monday: "Mo",
      saturday: "Sa",
      sunday: "So",
      thursday: "Do",
      tuesday: "Di",
      wednesday: "Mi",
    },
    delete: "Löschen",
    deleted: "Gelöscht",
    details: "Details",
    development: "Development V{0}",
    device: "Gerät",
    deviceManager: "IRES Work",
    devices: "Geräte",
    drying: "Trocknung",
    duration: {
      formatDays: "1 Tag | {count} Tage",
      formatDaysOpenEnded: "1 Tag | {count} Tagen",
      formatHours: "1 Stunde | {count} Stunden",
      formatMinutes: "1 Minute | {count} Minuten",
      now: "Jetzt",
    },
    edit: "Bearbeiten",
    electricityMeter: "Stromzähler",
    electricityMeterKwh: "Stromzähler (kWh):",
    email: "E-Mail-Adresse",
    emailShort: "E-Mail",
    invalidEmailAddress: "Ungültige E-Mail-Adresse",
    end: "Ende",
    endViewAs: "Sicht auf beenden",
    execute: "Ausführen",
    executionBy: "Ausführung durch",
    additionalUser: "Weiterer Mitarbeiter",
    additionalUsers: "Weitere Mitarbeiter",
    addAdditionalUser: "Weiteren Mitarbeiter hinzufügen",
    export: "Exportieren",
    externalSystem: "Externes System",
    filter: "Filtern",
    finished: "Fertig",
    firstName: "Vorname",
    floor: "Adresszusatz",
    formatKWh: "{0} kWh",
    formatPercent: "{0} %",
    formatRelativeHumidity: "{0} %rF",
    formatRun: "Lauf {0}",
    formatRuns: "1 Lauf | {count} Läufe",
    formatTemperature: "{0} °C",
    formatTemperatureCompact: "{0} °C",
    from: "von {0}",
    fromAlt: "aus",
    fromUntil: "von {0} bis {1}",
    fromUntilAlt: "vom {0} bis {1}",
    homeLocation: "Heimatstandort",
    houseNumber: "Hausnummer",
    hydryDevices: "HyDry Geräte",
    usedDevices: "Verwendete Geräte",
    ires: "IRES",
    iresFunctionsHint: "Kundenansicht",
    isAdmin: "JA",
    kwh: "kWh",
    lastName: "Nachname",
    lastNameOrCompanyName: "Nachname/Firma",
    lastProject: "Letztes Projekt: {0}",
    leakDetection: "Leckortung",
    load: "Laden",
    location: "Ort",
    mobilePhone: "Mobil",
    moveToFinished: "Verschieben",
    movedToFinished: "Verschoben",
    name: "Name",
    new: "Neu",
    never: "Nie",
    nfc: "NFC",
    no: "Nein",
    noMatchFound: "Keine Übereinstimmung gefunden",
    none: "Keine",
    noUsersToShow:
      "Es wurde kein für diese Aufgabe geeigneter Benutzer gefunden.",
    notAvailable: "nicht verfügbar",
    numPanels: "{0} HyDry",
    off: "Aus",
    ok: "Ok",
    on: "Ein",
    onDate: "am {0}",
    open: "Öffnen",
    otherDevices: "Andere Geräte",
    pageNotAvailable: "Diese Seite steht dir nicht zur Verfügung.",
    panel: "Panel",
    phone: "Telefon",
    portal: "IRES Office",
    production: "Production V{0}",
    project: "Projekt",
    projectAppVersion: "IRES Project {0}",
    projectType: "Projekttyp",
    projectManager: "IRES Project",
    projects: "Projekte",
    qrCode: "QR",
    roomInfoConfigVersion: "Beschreibung {0}",
    restore: "Wiederherstellen",
    restored: "Wiederhergestellt",
    save: "SICHERN",
    saveData: "Daten sichern",
    search: "Suchen",
    select: "Auswählen",
    serialNumber: "Seriennummer",
    signOut: "Abmelden",
    more: "Mehr",
    moreActions: "Weitere Aktionen",
    toggleTheme: "Erscheinungsbild umschalten",
    signedInAs: "Angemeldet als {0}",
    since: "seit {0}",
    sinceUntil: "von {0} bis {1}",
    sort: "Sortieren",
    start: "Beginn",
    startingAt: "ab {0}",
    street: "Straße",
    submit: "Übernehmen",
    testProjectAppVersion: "[TEST] IRES Project {0}",
    testRoomInfoConfigVersion: "[TEST] Beschreibung {0}",
    time: "Zeit",
    timeOfDay: "Uhrzeit",
    todo: "TODO",
    unknown: "Unbekannt",
    unsavedChangesDialog: {
      doNotSave: "NICHT SICHERN",
      message: "Es gibt ungesicherte Änderungen. Wollen Sie diese sichern?",
      title: "Ungesicherte Änderungen",
    },
    until: "bis {0}",
    user: "Benutzer",
    userProjects: "Sicht {0}",
    version: "Version: {0}",
    viewAsEndedNoRight: "Sicht auf wurde beendet, weil dir die Berechtigung dafür fehlt.",
    viewAsEndedUserUnavailable: "Sicht auf wurde beendet, weil der Benutzer nicht mehr verfügbar ist.",
    viewAsReadOnly: "Während Sicht auf kann nichts geändert werden.",
    viewOf: "Sicht auf: {0}",
    viewOfProjects: "Sicht {0}",
    web: "Web",
    yes: "Ja",
    zipCode: "PLZ",
  },
  dataViewer: {
    rows: "Zeilen",
    columns: "Spalten",
    search: "Suchen...",
    noResults: "Keine Ergebnisse gefunden",
    noData: "Keine Daten vorhanden",
    noSections: "Keine Abschnitte vorhanden",
    expandAll: "Alle aufklappen",
    collapseAll: "Alle zuklappen",
    editModeOn: "Bearbeiten",
    editModeOff: "Bearbeiten beenden",
  },
  pdeViewer: {
    title: "Projektdatenaustausch (PDE)",
    loading: "PDE wird geladen...",
    loadError: "Fehler beim Laden der PDE-Daten",
    noStorageLocation: "Kein PDE-Dateipfad vorhanden",
    download: "Herunterladen",
    noSelection: "Keine Auswahl",
    saveSuccess: "PDE-Daten gespeichert",
    saveError: "Fehler beim Speichern der PDE-Daten",
    sections: {
      projectInfo: "Projektdaten",
      apartments: "Wohnungen",
      rooms: "Räume",
      consolidatedWorkItems: "Leistungsliste (CWI)",
      materials: "Material",
      timeEstimate: "Zeitschätzung",
      timeTracking: "Zeiterfassung",
      deviceAssignments: "Gerätezuordnungen",
      workItems: "Arbeitspositionen",
      affectedComponents: "Betroffene Bauteile",
    },
    fields: {
      projectIdIres: "Projekt-ID IRES",
      projectIdErp: "Projekt-ID ERP",
      projectTypeId: "Projekttyp",
      creationTimestamp: "Erstellt",
      pdeSchemaVersion: "Schema-Version",
      infoConfigVersion: "Beschreibung-Version",
      erpBoQVersion: "LV-Version",
      senderId: "Absender",
      projectStatus: "Status",
      apartmentNumber: "Wohnung",
      lastName: "Nachname",
      firstName: "Vorname",
      floor: "Stockwerk",
      roomNumber: "Raum-Nr.",
      roomName: "Raumname",
      note: "Notiz",
      numberOfAffectedWalls: "Betroffene Wände",
      numberOfWalls: "Anzahl Wände",
      roomWidth: "Breite",
      roomLength: "Länge",
      roomHeight: "Höhe",
      roomArea: "Fläche",
      component: "Bauteil",
      workItemId: "Arbeitsposition",
      billingItemId: "Abrechnungsposition",
      billingItemId2: "Abrechnungsposition 2",
      workItemText: "Beschreibung",
      billingItemTextErp: "ERP-Text",
      quantityIres: "Menge IRES",
      quantityErp: "Menge ERP",
      quantityCompleted: "Menge fertig",
      unit: "Einheit",
      phase: "Phase",
      trade: "Gewerk",
      serviceProviderIres: "Leistungserbringer IRES",
      serviceProviderErp: "Leistungserbringer ERP",
      chapter: "Kapitel",
      section: "Abschnitt",
      paragraph: "Absatz",
      asset: "Material",
      quantity: "Menge",
      technicianId: "Techniker",
      protectionHours: "Schutz (Std.)",
      dismantlingHours: "Demontage (Std.)",
      setupDryingHours: "Trocknung aufbauen (Std.)",
      measurementHours: "Messung (Std.)",
      packupDryingHours: "Trocknung abbauen (Std.)",
      restorationHours: "Wiederherstellung (Std.)",
      entryNumber: "Nr.",
      date: "Datum",
      startOfWork: "Arbeitsbeginn",
      endOfWork: "Arbeitsende",
      travelTimeHours: "Fahrtzeit (Std.)",
      leakDetectionHours: "Leckortung (Std.)",
      damageAssessmentHours: "Schadenaufnahme (Std.)",
      userNumber: "Arbeiter-Nr.",
      workDone: "Arbeit",
      materialUsed: "Material verwendet",
      deviceAssignmentNumber: "Zuordnung-Nr.",
      deviceType: "Gerätetyp",
      deviceId: "Geräte-ID",
      countingDeviceId: "Zählgerät-ID",
      electricityMeterType: "Zählertyp",
      meterStart: "Zählerstand Anfang",
      meterEnd: "Zählerstand Ende",
      consumption: "Verbrauch",
      fromDate: "Von",
      toDate: "Bis",
      wallNumber: "Wand-Nr.",
      componentWidth: "Bauteil Breite",
      componentLength: "Bauteil Länge",
      componentHeight: "Bauteil Höhe",
      componentArea: "Bauteil Fläche",
      damageWidth: "Schaden Breite",
      damageLength: "Schaden Länge",
      damageHeight: "Schaden Höhe",
      damageArea: "Schaden Fläche",
    },
    biInfo: {
      notFound: "Keine Abrechnungsposition im Leistungsverzeichnis gefunden.",
      noCatalogReference: "Die PDE nennt kein Leistungsverzeichnis, deshalb sind keine LV-Texte verfügbar.",
      catalogNotFound: "Kein aktives Leistungsverzeichnis zu „{0}“ gefunden, deshalb sind keine LV-Texte verfügbar.",
      catalogAmbiguous: "Achtung: {0} Leistungsverzeichnisse passen zu „{1}“. Angezeigt werden die Texte von „{2}“. Bitte prüfe, ob das richtig ist.",
      catalogLoadFailed: "Die LV-Texte konnten nicht geladen werden.",
    },
  },
  beschreibungViewer: {
    title: "Beschreibung (Gewerke)",
    loading: "Beschreibung wird geladen...",
    loadError: "Fehler beim Laden der Beschreibungsdaten",
    noStorageLocation: "Kein Dateipfad vorhanden",
    download: "Herunterladen",
    sections: {
      projectInfo: "Projektinfo",
      apartments: "Wohnungen",
      rooms: "Räume",
      workItems: "Gewerke",
      materials: "Material",
      timeEstimate: "Zeitschätzung",
      timeTracking: "Zeiterfassung",
      buildingStructure: "Bauteilaufbau",
      workItemChanges: "Gewerke Änderungen",
      tasks: "Arbeitsschritte",
    },
    fields: {
      projectId: "Projekt-Nr.",
      address: "Adresse",
      dateTime: "Datum/Uhrzeit",
      lastName: "Nachname",
      firstName: "Vorname",
    },
  },
  deviceDetailsDialog: {
    deviceInVehicle: "Gerät im Fahrzeug {0}",
    deviceLastMovedInfo: "Geladen von {0} am {1}",
    openProject: "Projekt öffnen",
    openVehicle: "Fahrzeug öffnen",
  },
  deviceFilter: {
    active: "aktiv",
    available: "einsetzbar",
    finished: "fertig",
    inUsage: "im Einsatz",
    noAssignedToProject: "ohne Projekt",
    notAvailable: "nicht verfügbar",
    overall: "gesamt",
    overdue: "überfällig",
  },
  deviceHistory: {
    externalMeterUsed: "Zählung extern",
    headerLabel: "Einsatz {0}",
  },
  dryingHistory: {
    dryingHistoryDevice: "Historie Device {0}",
    formatDryingHistoryBox: "Historie Box {0}",
    formatDryingHistoryPanel: "Historie Panel {0}",
    formatDryingHistoryWithChainNumber: "{0}   Trocknung {1}",
    notAvailable: "--- Historie nicht verfügbar ---",
  },
  dryingInfo: {
    assigned: "Zugeordnet",
    createDryingReport: "Trocknungsbericht",
    day: "Tag",
    devicesAssinged: "Zuordnung",
    drying: "Trocknung",
    endValue: "Ende",
    formatDurationClosedAssignment: "von {0} bis {1} ({2})",
    formatDurationCompletedChain: "von {0} bis {1} ({2})",
    formatDurationOpenAssignment: "seit {0} ({1})",
    formatDurationOpenChain: "seit {0} ({1})",
    formatMeterReading: "Anfang {0}, Ende {1}, Verbrauch {2}",
    formatMeterReadingActiveProject: "Anfang {0}",
    formatMeterReadingActiveRun: "Anfang {0}, Aktuell {1}, Verbrauch {2}",
    formatMeterReadingConsumed: "Verbrauch {0}",
    formatMeterReadingEnd: "Ende {0}",
    formatMeterReadingStart: "Anfang {0}",
    formatPercentageDryingPause: "{0}, davon {1} % Trocknungspausen",
    formatRelativeAndAbsoluteChainNumber: "{0}. Trocknung ({1})",
    formatRelativeChainNumber: "{0}. Trocknung",
    groundTemp: "Temperatur Boden °C",
    heatRatioWall: "Intensität Wand %",
    humidity: "Feuchte",
    latestValue: "aktuell",
    maxValue: "max",
    measurements: "Messwerte",
    minValue: "min",
    noProject: "Kein Projekt",
    program: "Programm",
    project: "Projekt {0}",
    resistanceDigits: "Digits",
    startValue: "Anfang",
    temp: "Temp",
    wallTemp: "Temperatur Wand °C",
  },
  dryingProjectOverview: {
    apartments: "1 Wohnung | {count} Wohnungen",
    damagePatternCompletedItem: "{0} {1} ({2})",
    damagePatternConclusionStates: {
      carryOutDrying: "Trocknung durchführen",
      carryOutRestoration: "Wiederherstellung durchführen",
      noContract: "Kein Auftrag",
      noDryingNecessary: "Keine Trocknung notwendig",
      noRestorationNecessary: "Keine Wiederherstellung notwendig",
      onHold: "Projekt angehalten",
      yesOffer: "Ja, Angebot",
    },
    damagePatternProjectStates: {
      finished: "Projekt fertig",
    },
    damagePatternItem: "{0} Schadenbild ({1})",
    devices: "1 Gerät | {count} Geräte",
    dryingStartItem: "Trocknungsbeginn",
    plannedDamageAssessmentItem: "{0} Schadenaufnahme geplant ({1})",
    projectItemFinished: "Projekt fertig",
    projectNoContract: "Projekt fertig, kein Auftrag",
    projectNoDryingNecessary: "Projekt fertig, keine Trocknung notwendig",
    projectNumberItem: "{0} Projekt {1} ({2})",
    projectOnHold: "Projekt angehalten",
    projectTitle: "Trocknung: {0}",
    rooms: "1 Raum | {count} Räume",
  },
  hyDryEventLog: {
    date: "Datum",
    deleteNote: "Notiz löschen",
    event: "Event",
    formatCycle: "Z{0}",
    formatPhase: "P{0}",
    formatStep: "S{0}",
    lid: "Deckel",
    log: "Log",
    logbook: "Logbuch",
    noLogs: "Das LOGBUCH ist für diese Trocknung noch nicht verfügbar.",
    note: "Notiz",
    pause: "Pause",
    program: "Programm",
    sortAscending: "Aufsteigend sortieren",
    sortDescending: "Absteigend sortieren",
    step: "Step",
  },
  hyDryEvents: {
    categories: {
      longDescription: {
        alert: "Alert",
        drying: "Trocknung",
        ires: "IRES",
        lid: "Deckel",
        note: "Notiz",
        organisation: "Organisation",
        other: "Sonstige",
        pause: "Pause",
        sensor: "Sensor",
      },
      shortDescription: {
        alert: "Alert",
        drying: "Trocknung",
        ires: "IRES",
        lid: "Deckel",
        note: "Notiz",
        organisation: "Orga",
        other: "Sonst",
        pause: "Pause",
        sensor: "Sensor",
      },
    },
    longDescription: {
      battery: "Batterie {0}%",
      checkDryingProgress: "Trocknungsfortschritt prüfen",
      comBoxDryingCompleted: "Trocknung beendet",
      deviceOverdue: "IoT überfällig",
      dryingEnded: "Trocknung beendet",
      dryingParametersChanged: "Trocknungsparameter geändert",
      dryingPausedAfterPowerOn: "Strom wieder da, Trocknung unterbrochen",
      dryingProgramDone: "Trocknungsprogramm fertig",
      dryingProgramStarted: "Trocknungsprogramm gestartet",
      dryingProgramTerminated: "Trocknungsprogramm abgeschlossen",
      dryingProgressNotPlausible: "Trocknungsverlauf nicht plausibel",
      dryingQualityAssessment: "Qualitätsbeurteilung Trocknung ",
      dryingResumed: "Trocknung fortgesetzt",
      dryingResumedAfterPowerOn: "Strom wieder da, Trocknung wird fortgesetzt",
      dryingStartNotPlausible: "Trocknungsbeginn nicht plausibel",
      dryingStarted: "Neue Trocknung begonnen",
      dryingSucceed: "Trocknung fertig",
      dryingSuspended: "Trocknung angehalten",
      errorWhileDrying: "Gerätefehler innerhalb Trocknung",
      firmware: "FW {0}",
      formatPowerFailWhileDrying:
        "Stromverlust innerhalb Trocknung (mehr als {0} h)",
      interruptedDryingEnded: "unterbrochene Trocknung beendet",
      interruptedDryingResumed: "unterbrochene Trocknung fortgesetzt",
      lidClosed: "Deckel geschlossen",
      lidOpened: "Deckel geöffnet",
      malfunction: "Fehler: {0}, keine Trocknung",
      malfunctionWhileDrying: "Fehler: {0}, Trocknung läuft",
      manualPauseEnded: "Manuelle Pause beendet",
      manualPauseStarted: "Manuelle Pause gestartet",
      newDrying: "Trocknung beginnen",
      note: "Notiz",
      pauseEnded: "Pause beendet",
      pauseStarted: "Pause in Trocknung",
      powerFailWhileDrying: "Stromverlust innerhalb Trocknung",
      poweredOff: "Ausgesteckt, keine Trocknung",
      poweredOffWhileDrying: "Ausgesteckt bei laufender Trocknung",
      poweredOn: "Eingesteckt",
      programCompleted: "Trocknungsprogramm fertig",
      programPauseEnded: "Programmpause beendet",
      programPauseStarted: "Programmpause gestartet",
      programPhaseEnded: "Phase {0} gestartet",
      programStepCompleted: "Trocknung Phase {0} begonnen",
      prolongedPowerFail: "längerer Stromverlust",
      roomDryingHumidityVeryHigh: "Raumfeuchte sehr hoch",
      roomDryingPauseEndendHumidityTargetReached:
        "Raumluft wird entfeuchtet, Pause beendet",
      roomDryingPauseEndendTemperatureTooHigh: "Temperatur okay, Pause beendet",
      roomDryingPauseStartedHumidityTargetReached:
        "Ausreichend entfeuchtet, Pause begonnen",
      roomDryingPauseStartedTemperatureTooHigh:
        "Temperatur zu hoch, Pause begonnen",
      roomDryingTemperatureVeryLow: "Raumtemperatur sehr niedrig",
      rssi: "RSSI {0}",
      sensorBackInRange: "Sensor (Slot {0}) wieder in Reichweite",
      sensorBatteryWeak: "Sensor (Slot {0}): Batterie schwach",
      sensorButtonPressed: "Sensor (Slot {0}): Taste gedrückt",
      sensorConfigurationChanged: "Sensorkonfiguration geändert: {0}",
      sensorConfigurationChangedWithEventNo:
        "Sensorkonfiguration geändert (Event {0}):\n{1}",
      sensorConfigurationSnapshot:
        "Trocknung gestartet mit Sensor-Konfiguration: {0}",
      sensorOutOfRange: "Sensor (Slot {0}) außer Reichweite",
      sensorLinkGood: "Sensor (Slot {0}): Verbindung ok",
      sensorLinkTimeout: "Sensor (Slot {0}): Kommunikationszeitüberschreitung",
      sensorLinkTimeoutResolved:
        "Sensor (Slot {0}): Kommunikation wieder hergestellt",
      sensorLinkWeak: "Sensor (Slot {0}): Verbindung schwach",
      sensorTurnedOff: "Sensor (Slot {0}) ausgeschaltet",
      successfulDryingEndend: "Fertige Trocknung beendet",
      timerPauseEnded: "Nachtpause beendet",
      timerPauseStarted: "Nachtpause gestartet",
      turnedOff: "Ausgeschaltet",
      turnedOn: "Eingeschaltet",
      unknownEvent: "Unbekannt",
      warning: "Warnung: {0}, keine Trocknung",
      warningWhileDrying: "Warnung: {0}, Trocknung läuft",
    },
    shortDescription: {
      battery: "Batterie {0}%",
      checkDryingProgress: "Trocknungsfortschritt prüfen",
      comBoxDryingCompleted: "Trocknung beendet",
      deviceOverdue: "IoT überfällig",
      dryingEnded: "Trocknung beendet",
      dryingParametersChanged: "Trocknungsparameter geändert",
      dryingPausedAfterPowerOn: "Trocknung angehalten",
      dryingProgramDone: "Trocknungsprogramm ",
      dryingProgramStarted: "Trocknungsprogramm gestartet",
      dryingProgramTerminated: "Trocknungsprogramm abgeschlossen",
      dryingProgressNotPlausible: "Trocknungsverlauf prüfen",
      dryingQualityAssessment: "Qualitätsbeurteilung Trocknung",
      dryingResumed: "Trocknung fortgesetzt",
      dryingResumedAfterPowerOn: "Trocknung fortgesetzt",
      dryingStartNotPlausible: "Trocknungsverlauf prüfen",
      dryingStarted: "Trocknung begonnen",
      dryingSucceed: "Trocknung fertig",
      dryingSuspended: "Trocknung angehalten",
      errorWhileDrying: "Gerätefehler",
      firmware: "FW {0}",
      formatPowerFailWhileDrying: "Stromverlust (> {0} h)",
      interruptedDryingEnded: "Trocknung beendet",
      interruptedDryingResumed: "Trocknung fortgesetzt",
      lidClosed: "Deckel geschlossen",
      lidOpened: "Deckel geöffnet",
      malfunction: "Fehler: {0}, keine Trocknung",
      malfunctionWhileDrying: "Fehler: {0}, Trocknung läuft",
      manualPauseEnded: "Manuelle Pause beendet",
      manualPauseStarted: "Manuelle Pause gestartet",
      newDrying: "Trocknung beginnen",
      note: "Notiz",
      pauseEnded: "Pause beendet",
      pauseStarted: "Pause begonnen",
      powerFailWhileDrying: "Stromverlust",
      poweredOff: "Ausgesteckt, keine Trocknung",
      poweredOffWhileDrying: "Ausgesteckt bei laufender Trocknung",
      poweredOn: "Eingesteckt",
      programCompleted: "Trocknungsprogramm fertig",
      programPauseEnded: "Programmpause beendet",
      programPauseStarted: "Programmpause gestartet",
      programPhaseEnded: "Programmschritt {0} vollendet",
      programStepCompleted: "Trocknung hat Programmschritt vollendet",
      prolongedPowerFail: "längerer Stromverlust",
      roomDryingHumidityVeryHigh: "Raumfeuchte sehr hoch",
      roomDryingPauseEndendHumidityTargetReached:
        "Raumluft wird entfeuchtet, Pause beendet",
      roomDryingPauseEndendTemperatureTooHigh: "Temperatur okay, Pause beendet",
      roomDryingPauseStartedHumidityTargetReached:
        "Ausreichend entfeuchtet, Pause begonnen",
      roomDryingPauseStartedTemperatureTooHigh:
        "Temperatur zu hoch, Pause begonnen",
      roomDryingTemperatureVeryLow: "Raumtemperatur sehr niedrig",
      rssi: "RSSI {0}",
      sensorBackInRange: "Sensor (Slot {0}) wieder in Reichweite",
      sensorBatteryWeak: "Sensor (Slot {0}): Batterie schwach",
      sensorButtonPressed: "Sensor (Slot {0}): Taste gedrückt",
      sensorConfigurationChanged: "Sensorkonfiguration geändert: {0}",
      sensorConfigurationChangedWithEventNo:
        "Sensorkonfiguration geändert (Event {0}):\n{1}",
      sensorConfigurationSnapshot:
        "Trocknung gestartet mit Sensor-Konfiguration: {0}",
      sensorOutOfRange: "Sensor (Slot {0}) außer Reichweite",
      sensorLinkGood: "Sensor (Slot {0}): Verbindung gut",
      sensorLinkTimeout: "Sensor (Slot {0}): Kommunikationszeitüberschreitung",
      sensorLinkTimeoutResolved:
        "Sensor (Slot {0}): Kommunikation wieder hergestellt",
      sensorLinkWeak: "Sensor (Slot {0}): Verbindung schwach",
      sensorTurnedOff: "Sensor (Slot {0}) ausgeschaltet",
      successfulDryingEndend: "Trocknung beendet",
      timerPauseEnded: "Nachtpause beendet",
      timerPauseStarted: "Nachtpause gestartet",
      turnedOff: "Ausgeschaltet",
      turnedOn: "Eingeschaltet",
      unknownEvent: "Unbekannt",
      warning: "Warnung: {0}, keine Trocknung",
      warningWhileDrying: "Warnung: {0}, Trocknung läuft",
    },
  },
  iresDevice: {
    deviceAssignedToProject: "Gerät, das einem Projekt zugeordnet ist",
    deviceInUsage: "Gerät ist im Einsatz",
    deviceNotAvailable: "Gerät ist einer anderen Niederlassung zugeordnet",
    formatBatteryStatus: "{0} V, Note {1}",
    moveDevicesButtonText: "Geräte verschieben",
    moveDevicesDialog: {
      assignmentStartDate: "ab Datum",
      branch: "Standort",
      client: "Welche Niederlassung(en)?",
      errorMessage: "Geräte konnten nicht verschoben werden",
      successMessage:
        "1 Gerät erfolgreich verschoben | {count} Geräte erfolgreich verschoben",
      title: "Geräte verschieben",
    },
    notAvailable: "--- Gerät nicht verfügbar ---",
  },
  iresDeviceDetail: {
    comBoxDoesNotExist: "Es gibt keine HyDry Box mit der Seriennummer {0}.",
    panelDoesNotExist: "Es gibt kein HyDry Panel mit der Seriennummer {0}.",
    neverReportedSince: "{0} wurde am {1} angelegt, hat sich aber noch nie gemeldet.",
    neverReported: "{0} ist angelegt, hat sich aber noch nie gemeldet.",
    warningCheckProjectAssignment: "Zeitraum Projektzuordnung prüfen",
    warningNoProgramChainsInClosedAssignment:
      "Diese Zuordnung enthält keine Trocknung",
  },
  iresDeviceSensor: {
    floorSensor1: "Sensor1",
    floorSensor2: "Sensor2",
    floorSensor3: "Sensor3",
    floorSensor4: "Sensor4",
    floorSensor5: "Sensor5",
    floorSensor6: "Sensor6",
    floorSensor7: "Sensor7",
    floorSensor8: "Sensor8",
    ground: "Boden",
    guideSensor: "Leit",
    humidity: "Feuchte",
    resistanceDigits: "Digits",
    intensity: "Intensität",
    intensityAll: "Intensität/Regen/Druck",
    intensityAndRelativeHumidityAndPressure: "Intensität/rel. Feuchte/Druck",
    roomSensor: "Raum",
    temperature: "Temperatur",
    wall: "Wand",
  },
  iresDeviceType: {
    box: "HyDry Box",
    edge: "HyDry Edge",
    formatHyDryBox: "HyDry Box {0}",
    formatHyDryMini: "HyDry Mini {0}",
    formatHyDryPanel: "HyDry Panel {0}",
    mini: "HyDry Mini",
    panel: "HyDry Panel",
    slim: "HyDry Slim",
  },
  joinSharedEmailAddress: {
    errorWrongPassword: "Kennwort ungültig",
    formatMessage:
      "Die E-Mail-Adresse {0} wird von einem anderen Benutzer geteilt.\nBitte das Kennwort der geteilten E-Mail-Adresse eingeben.",
    title: "Geteilte E-Mail-Adresse",
  },
  language: {
    de: "Deutsch",
    en: "Englisch",
    fr: "Französisch",
    it: "Italienisch",
    pl: "Polnisch",
  },
  leakDetectionProjectOverview: {
    conclusion: "Abschluss",
    leakDetection: "Leckortung",
    projectCreation: "Neuanlage",
    projectItemFinished: "Projekt fertig",
    projectTitle: "Leckortung: {0}",
  },
  location: {
    addressEdited: "Adresse geändert. Klicke, um die Position neu zu suchen.",
    ambiguous:
      "Zu dieser Adresse gibt es {0} mögliche Orte. Wähle den richtigen aus der Vorschlagsliste oder setze den Punkt selbst.",
    backfilled: "PLZ und Ort aus der gefundenen Adresse übernommen: {0}",
    confidence: {
      CONFIRMED: "Adresse bestätigt",
      GOOD: "Automatisch ermittelt, gute Qualität",
      POOR: "Automatisch ermittelt, schlechte Qualität",
      UNRELIABLE: "Keine brauchbare Position",
    },
    crossCheckMismatch:
      "Die gefundene Position gehört zu einer anderen Adresse als der eingegebenen. Prüfe sie bitte auf der Karte.",
    geocodingFailed: "Adresse konnte nicht gefunden werden. Setze den Punkt bitte selbst auf der Karte.",
    legend: {
      CONFIRMED: "bestätigt",
      GOOD: "gut",
      POOR: "ungenau",
      UNRELIABLE: "unbrauchbar",
      title: "Farben",
    },
    lookingUp: "Position wird gesucht …",
    mapLoadFailed: "Karte konnte nicht geladen werden.",
    noAddress: "Gib bitte mindestens Ort, Straße oder PLZ ein.",
    pickerHint:
      "Ziehe den Punkt oder klicke auf die Karte, um die Position genau zu setzen. Die Position wird für die Fahrt-Funktionen gespeichert, deine eingegebene Adresse bleibt unverändert.",
    pickerHintReadonly: "Position der Adresse.",
    pickerTitle: "Position",
    quality: {
      APPROXIMATE: "Auf Karte anzeigen (ungefähre Lage)",
      GEOMETRIC_CENTER: "Auf Karte anzeigen (Straßen- bzw. Ortsmitte)",
      MANUAL: "Auf Karte anzeigen (von Hand gesetzt)",
      RANGE_INTERPOLATED: "Auf Karte anzeigen (Hausnummer geschätzt)",
      ROOFTOP: "Auf Karte anzeigen (Gebäude genau)",
      none: "Noch nicht verortet. Auf Karte anzeigen",
      unknown: "Auf Karte anzeigen (Genauigkeit unbekannt)",
    },
    search: {
      hint: "Tippe die Adresse und wähle den passenden Vorschlag aus.",
      label: "Adresse suchen",
      noResults: "Keine Vorschläge gefunden.",
    },
  },
  login: {
    clientHandover: {
      opening: "Wird als Mandant geöffnet …",
      failed: "Die Anmeldung als Mandant ist fehlgeschlagen. Schließe diesen Tab und versuche es im IRES Admin Client erneut.",
      refused: "Die Anmeldung als Mandant wurde abgelehnt: {0} Schließe diesen Tab.",
    },
    backToLogin: "Zurück zum Login",
    clientPortal: "HyDry Kundenportal",
    clientPortalEmail: "Portal Mailadresse",
    emailAddress: "E-Mail-Adresse",
    forgotPassword: "Passwort vergessen?",
    forgotUserPassword: "Benutzerpasswort vergessen?",
    forgotUserPasswordMessage:
      "Bitte wende dich an deinen Administrator oder kontaktiere uns unter support@hydry.de",
    login: "Anmelden",
    loginContactEmail: "Mail support@hydry.de",
    loginContactText:
      "Solltest du als unser Partner nicht für die Nutzung registriert sein, teile uns dies bitte per E-Mail mit.",
    loginFailed:
      "Anmeldung fehlgeschlagen. Bitte überprüfe Mailadresse und Passwort.",
    loginFailedBlocked:
      "Anmeldung fehlgeschlagen. Der Benutzer mit Mailadresse {0} ist gesperrt.",
    signInRefused: {
      CLIENT_BLOCKED: "Anmeldung nicht möglich. Der Zugang deiner Firma ist gesperrt. Bitte wende dich an IRES.",
      USER_BLOCKED: "Anmeldung nicht möglich. Dein Benutzer ist gesperrt. Bitte wende dich an einen Administrator.",
    },
    loginWelcomeText: "Bitte anmelden",
    loginWelcomeTitle: "HyDry Geräteverwaltung und Fernsteuerung",
    networkBlocked: "Verbindung blockiert. Bitte prüfe deine Proxy- oder VPN-Einstellungen und versuche es erneut.",
    noInternetAvailable: "Keine Internetverbindung. Bitte prüfe deine Netzwerkverbindung und versuche es erneut.",
    password: "Passwort",
    passowrdEmailSharing: "Kennwort",
    passwordResetEmailAlreadySent:
      "Eine E-Mail zum Zurücksetzen deines Passworts wurde bereits gesendet. Bitte überprüfe deinen Posteingang und ggf. deinen Spam-Ordner.",
    passwordResetEmailError:
      "Beim Senden der E-Mail zum Zurücksetzen deines Passworts ist ein Fehler aufgetreten. Bitte versuche es erneut.",
    passwordResetEmailSent:
      "Die E-Mail zum Zurücksetzen deines Passworts wurde erfolgreich versendet.",
    passwordResetSharedEmailError:
      "Das Passwort für einen geteilten Benutzer kann nicht zurückgesetzt werden. Bitte wende dich an den Systemadministrator.",
    pleaseSignIn: "Bitte Nutzerkennung und Passwort angeben",
    pleaseSignInWithEmail: "Bitte E-Mail-Adresse angeben",
    resetPassword: "Passwort zurücksetzen",
    sessionEnd: "Du hast dich auf einem anderen Gerät angemeldet",
    unknownEmailAddress:
      "HyDry Portalanmeldung für {0}: E-Mail-Adresse {1} konnte nicht gefunden werden. Ist der Benutzer richtig angelegt?",
    userIdentification: "Nutzerkennung",
  },
  messageSettings: {
    erp: "ERP",
    erpConnection: "ERP-Anbindung",
    filterAll: "Filter Gesamt",
    filterMyProject: "Nachrichten von Projekten",
    filterNoProject: "Filter Projekt",
    logCategories: "Log-Klassen",
    logCategoriesTotal: "Log-Klassen Gesamt",
    mailboxes: "Postfächer",
    messages: "Nachrichten",
    organisationCapability: "Orga-Aufgabe",
    organisationRole: "Orga-Rolle",
    projectRole: "Projekt-Rolle ",
    selectLogCategories: "Auswahl Log-Klassen",
    showMessagesToProjectOwners: "an Bearbeiter",
    showMessagesToProjectSupervisors: "an Leiter",
  },
  messages: {
    details: {
      currentProject: "Aktuelles Projekt",
      device: "Gerät",
    },
    formatDrying: "Trocknung {0}",
    formatMessagesTitle: "Neue Nachrichten ({0})",
    formatMoreMessages: "+{0}",
    formatNewMessages: "{0} gesamt",
    formatNewMessagesForCapability: "{0} an {1}",
    formatNewMessagesForMailbox: "{0} neue an Postfach {1}",
    formatNewMessagesForMe: "{0} an mich",
    formatNewMessagesForRole: "{0} an {1}",
    formatNumNewMesssages: "1 neue Nachricht | {count} neue Nachrichten",
    markAsRead: "Gelesen",
    message: "Nachricht",
    messages: "Nachrichten",
    newMessages: "gesamt",
    newMessagesForCapability: "an {0}",
    newMessagesForMailbox: "an Postfach {0}",
    newMessagesForMe: "an mich",
    newMessagesForRole: "an {0}",
    noMessagesFound: "--- keine Nachrichten gefunden ---",
    sortBy: {
      messageDate: "Neuste",
      projectNumber: "Projektnummer",
      serialNumber: "Seriennummer",
    },
    yesterday: "gestern",
  },
  openProgramChainDecision: {
    confirmReleaseMessage:
      "Die Abmeldung erfolgt am {0}.\nTrocknung {1} wird zugeordnet.\nBei Bedarf Zählerstand Ende korrigieren.",
    decide: "Bitte entscheiden Sie",
    deleteAssignment: "Zuordnung löschen",
    message:
      "Am {0} läuft eine Trocknung (Trocknung {1}, begonnen am {2}).\n\nSoll die Zuordnung wirklich am {3} abgemeldet werden? Die laufende Trocknung wird dann beendet, bei Bedarf kann der Stromzählerstand angepasst werden.",
    noProgramChainsFoundInAssignmentRange:
      "Im Zeitraum der Zuordnung wurden keine zuordenbaren Trocknungen gefunden. Zuordnung trotzdem abmelden?",
    openProgramChain: "Laufende Trocknung",
    recentlyActiveDeviceWarning:
      "Alternativ sollten Sie ABBRECHEN und ein anderes Abmeldedatum wählen.",
    release: "Abmelden",
    releaseDescription: "Trotzdem abmelden",
    stop: "Stop",
    stopBoxMessage: "Möchten Sie die Trocknung mit Box {0} beenden?",
    stopCommandQueuedMessage:
      "STOP-Befehl über IoT vorgemerkt. Möchten Sie warten oder jetzt trotzdem abmelden?",
    stopDescription: "Trocknung jetzt beenden?",
    stopDrying: "Trocknung beenden",
    stopPanelMessage: "Möchten Sie die Trocknung mit Panel {0} beenden?",
    wait: "Warten",
    waitDescription: "Auf das Ende der Trocknung warten",
  },
  notFound: {
    message: "Diese Seite gibt es nicht (mehr).",
    toCockpit: "Zum Cockpit",
  },
  overview: {
    active: "aktiv",
    activeProjects: "Aktive Projekte",
    availableIresDevices: "Verfügbare HyDry Geräte",
    default: "HyDry Projektmanager",
    deviceTypeHyDryComBoxes: "HyDry Boxen",
    deviceTypeHyDryPanels: "HyDry Panels",
    deviceTypes: "1 Gerätetyp | {count} Gerätetypen",
    devices: "1 Gerät | {count} Geräte",
    devicesOnlyWebsite: "HyDry",
    error: "Fehler",
    finished: "fertig",
    inUsage: "im Einsatz",
    iotClientPortal: "HyDry Kundenportal",
    manageDevices: "Geräte verwalten",
    manageProjects: "Projekte verwalten",
    office: "Office",
    overall: "gesamt",
    overdue: "überfällig",
    projectManagement: "Projektverwaltung",
    projectOption: "HyDry Projektoption",
    recentlyFinished: "abgeschlossen",
    warning: "Warnung",
    website: "HyDry Projektportal",
    withDevice: "davon mit HyDry Geräten",
  },
  pages: {
    allDevices: "Alle Geräte",
    archivedProjects: "Alte Projekte",
    cockpit: "Cockpit",
    createProject: "Projekt anlegen",
    devices: "HyDry Geräte",
    help: "Über",
    maps: "Karten",
    mira: "Mira",
    messages: "Nachrichten",
    notFound: "Seite nicht gefunden",
    overview: "Übersicht",
    panelDetails: "Panel Details",
    projectDetails: "Details Projekt ",
    projects: "Projekte",
    aiPredictions: "RENO",
    scheduling: "Einsatzplanung",
    settings: "Einstellungen",
    users: "Benutzer",
    vehicles: "Fahrzeugbeladung",
    timeTrackingHistory: "Zeiterfassung",
  },
  panel: {
    events: {
      event: "Event {0}",
      event0: "Data Sample every minute",
      event1: "Eingeschaltet",
      event10: "Programmende (letzte Stufe)",
      event11: "Programmende (maximale Laufdauer)",
      event12: "Programmende (Heizanteil)",
      event13: "Programmende (manuell)",
      event13Log: "Trocknung manuell beendet",
      event14: "Abkühlphase abgebrochen",
      event15: "Trocknung wird fortgesetzt",
      event16: "Max. Trocknungsdauer erreicht",
      event18: "Stufe beendet",
      event19: "Manueller Restart",
      event1Log: "Panel eingeschaltet",
      event2: "Stecker gezogen",
      event20: "Maximale Heizzeit überschritten",
      event20Warning: "Warnung: Maximale Heizzeit überschritten",
      event21: "Warnung: Lagesensor ausgelöst",
      event22: "Max. Bodentemperatur erreicht",
      event24: "Temperaturüberschreitung (85 °C)",
      event24Log: "Temperaturüberschreitung an Wand und / oder Boden",
      event25: "Gehäusetemperatur zu hoch",
      event255: "Unbekannt",
      event25Log: "Temperaturüberschreitung im Panelgehäuse",
      event26: "Max. Sensorchiptemperatur erreicht",
      event27: "Max. Sensorchiptemperatur Edge erreicht",
      event28: "Heizpanel angeschaltet",
      event28Log: "Heizpanel (Wand) nach Übertemperatur wieder aktiv.",
      event29: "Heizpanel Boden angeschaltet.",
      event29Log: "Heizpanel (Boden) nach Übertemperatur wieder aktiv",
      event2Log: "Ausgesteckt bei laufender Trocknung",
      event3: "Neustart nach Netzunterbrechung / Reset",
      event30: "NB1 Verbindung mit Netz fehlgeschlagen",
      event31: "NB1 Verbindung mit Netz aufgebaut",
      event32: "NB1 Verbindung mit Server fehlgeschlagen",
      event33: "NB1 Verbindung mit Server aufgebaut",
      event34: "NB1 Verbindung Timeout",
      event35: "NB1 Verbindung beendet (0) (abmelden)",
      event36: "NB1 Verbindung beendet (1) (neu aufbauen)",
      event37: "NB1 Verbindung beendet (2) (Timeout)",
      event39: "NB1 nicht verfügbar",
      event39Log: "NB1 Modem wurde abgeschaltet",
      event4: "Automatischer Start",
      event48: "DATALOG_EVT_MIN_MALFUNCTION",
      event49: "DATALOG_EVT_POSITION",
      event5: "Manueller Start",
      event50: "Fehler: EEPROM kann nicht initialisiert werden.",
      event51: "Fehler: Konfiguration des Gerätes ist fehlerhaft.",
      event52: "Fehler: SPI-Flash kann nicht initialisiert werden.",
      event53: "Fehler: Datalog nicht konsistent (Dateisystem defekt?)",
      event54: "Fehler: RTCC kann nicht initialisiert werden.",
      event55:
        "Fehler: Uhrzeit des Gerätes stimmt nicht bzw. Uhr ist nicht gesetzt.",
      event56:
        "Fehler: ADC-Wandler der MCU ist defekt bzw. liefert fehlerhafte Werte.",
      event57: "Fehler: Einer der IR-Sensoren ist defekt.",
      event59:
        "Fehler: Energiemengenzähler ist defekt bzw. liefert fehlerhafte Werte.",
      event5Log: "Manueller Start der Trocknung",
      event6: "Start nach Einschaltverzögerung",
      event60: "Fehler: Stromaufnahme passt nicht zum Betriebszustand.",
      event61: "Fehler: Programmtabelle ist ungültig.",
      event62:
        "Sicherheitsabschaltung (Hardware-Temperatur-Alarm) hat ausgelöst.",
      event63: "Fehler: Beschleunigungssensor für Lage-Erkennung ist defekt.",
      event64: "Fehler: BLE-Modul",
      event65: "Fehler: NB1-Modul",
      event66: "DATALOG_OUT_OF_TIME",
      event68: "Firmware Update gestartet",
      event69: "Firmware Update erfolgreich",
      event6Log: "Programmstart nach WAIT",
      event7: "Start nach Erreichung Basistemperatur",
      event70: "Messung Batterie",
      event71: "Heizung aus",
      event71Log: "Leistungsüberwachung aktiv: Bitte Stromversorgung prüfen!",
      event72: "Heizung ein",
      event72Log: "Leistungsüberwachung beendet: Stromversorgung in Ordnung.",
      event73:
        "Leistungsreduktion aufgrund von Schwankungen in der Versorgungsspannung.",
      event74: "Schwankungen in der Versorgungsspannung",
      event75: "Versorgungsspannung stabil",
      event76: "NB1 Status bei Powerfail",
      event8: "Step Event",
      event80: "Reboot für Konfig Update",
      event81: "Reboot für Firmware Update",
      event82: "Uhrzeit eingestellt",
      event9: "Start Folgeprogramm",
      event90: "Depassivierung Start",
      event91: "Depassivierung Ende",
    },
  },
  panelControl: {
    command: "Command",
    commandFlag: "Command Flagge",
    confirmCancelQueuedRequestMessage:
      "Sind Sie sicher, dass die vorgemerkte Aktion nicht durchgeführt werden soll?",
    confirmCancelQueuedRequestTitle: "Vorgemerkte Aktion stoppen",
    executingCommandImmediatly:
      "Kommunikation erfolgt über IoT. Das dauert einen Moment.",
    executingCommandNextIotConnection:
      "Anweisung wird bei nächster IoT-Verbindung ausgeführt.",
    loadRunsQueued: "Ladeläufe vorgemerkt",
    programSelection: "Programmwahl",
    queuedRequestFactoryReset: "Zurücksetzen über IoT vorgemerkt",
    queuedRequestLoadRuns: "Ladeläufe über IoT vorgemerkt",
    queuedRequestPause: "Pause über IoT vorgemerkt",
    queuedRequestPowerChangeDryRun: "Ändern über IoT vorgemerkt",
    queuedRequestPowerOffComBox: "Ausschalten über IoT vorgemerkt",
    queuedRequestPowerOnComBox: "Einschalten über IoT vorgemerkt",
    queuedRequestPowerStartDryRun: "Start über IoT vorgemerkt",
    queuedRequestRelayTest: "Relay Test über IoT vorgemerkt",
    queuedRequestRestartPanel: "Neustart über IoT vorgemerkt",
    queuedRequestResume: "Fortsetzen über IoT vorgemerkt",
    queuedRequestSelectProgram: "Start P {0} über IoT vorgemerkt",
    queuedRequestStartPanel: "Start über IoT vorgemerkt",
    queuedRequestStopPanel: "Stop über IoT vorgemerkt",
    queuedRequestTerminate: "Trocknung Beenden über IoT vorgemerkt",
    queuedRequestUpdateIotConfig: "Update IoT Config über IoT vorgemerkt",
    runId: "Lauf-ID",
    runIdError: "Bitte geben Sie eine Zahl zwischen 0 und 255 ein.",
    start: "Starten",
    startPanelTitle: "Panel {0} mit P {1} {2} starten",
    startQueued: "Start vorgemerkt",
    stopPanelTitle: "Panel {0} stoppen",
    stopQueued: "Stop vorgemerkt",
  },
  panelDetail: {
    actions: {
      closeProgramChainText: "Trocknung von {0} bis",
      endDrying: "Trocknung beenden",
      history: "Historie",
      loadRuns: "Läufe laden",
      notes: "Notizen",
      programChooser: "Programmwahl",
      progress: "Verlauf",
      restart: "Neustart",
      graph: "Grafik",
      runs: "Runs",
      setComBoxOffline: "Box abmelden",
      setHyDryDeviceOffline: "HyDry Gerät abmelden",
      setPanelOffline: "Panel abmelden",
      setPanelOfflineMessage:
        "Bitte Datum angeben, an dem das Panel ausgeschaltet wurde",
      startPanel: "Start",
      stopPanel: "Stop",
    },
    connectReason: "Connect Reason",
    connectReasonDescriptions: {
      0: "UNBEKANNT",
      1: "Strom ein",
      2: "periodisch",
      3: "Neuer Lauf",
      4: "Stufe beendet",
      5: "Strom aus",
      6: "Warnung",
      7: "Fehler",
      8: "BLE getrennt",
      9: "Session Retry",
      10: "Reconnect",
    },
    coooling: "Abkühlen",
    disconnected: "Getrennt",
    drying: "Trocknung",
    dryingPhaseInfo: {
      error: "Fehler",
      program0: "Nachlauf",
      program1ToProgram7: "Trocknung aktiv",
      warning: "Warnung",
    },
    dryingProgram: "Trocknungsprogramm",
    dryingProgressGraph: {
      formatTemperature: "{0} °C",
      temperature: "Temperatur",
    },
    dryingProgressGraphControl: {
      formatDrying: "Trocknung {0}",
      groundTemp: "Temperatur Boden",
      log: "Log",
      new: "Neu",
      next: "Trocknung >",
      nextShort: ">",
      overview: "Gesamt",
      previous: "< Trocknung",
      previousShort: "<",
      rateDrying: "Qualität",
      single: "Einzeln",
      wallTemp: "Temperatur Wand",
    },
    event: "Event",
    externalCountingMeter: "Stromabrechnung: {0}",
    formatChainAndProgram: "Trocknung {0} / Programm {1}",
    formatDryingProgram: "P{0}",
    formatDryingProgramWithName: "P{0}: {1}",
    formatHeatRatio: "{0}%",
    formatHeatRatioAll: "{0}% / {1}hPa",
    formatHeatRatioAndRelativeHumidityAndPressure: "{0}% / {1}% / {2}hPa",
    formatHeatRatioWithLabel: "Intensität: {0}%",
    formatTemperatureGround: "Boden: {0} °C",
    formatTemperatureWall: "Wand: {0} °C",
    formatTemperatureWallAndGround: "Wand: {0} °C / Boden: {1} °C",
    formatTemperatureWallAndGroundMax: "Wand max {0} °C / Boden max {1} °C",
    formatTemperatureWallMax: "Wand max {0} °C",
    heatRatio: "Intensität",
    heating: "Aufwärmen",
    heatingInfo: "FirstTime/FHR/HR/CR/HRatio",
    idle: "Temperaturkontrolle",
    lastEvent: "Letztes Ereignis",
    lastInfo: {
      current: "aktuell",
      days: "vor 1 Tag | vor {count} Tagen",
      hours: "vor {0} h",
      lastPing: "PING {0}",
      lastPingCurrent: "PING aktuell",
      minutes: "vor {0} min",
    },
    lastInformation: "Letzte Information",
    lastMeterReading: "letzte Ablesung {0}",
    loadRunsOptions: {
      startFromBeginning: "Von Anfang an",
      startFromRunId: "Von Lauf-ID",
    },
    malfunction: "Fehler",
    maxTemperature: "max Temperatur",
    meterReading: "Zählerstand",
    meterReadingByUser: "Abgelesener Stromverbrauch (kWh)",
    metereReadingStartEnd: "Anfang {0}    Ende {1}",
    noActiveProgramChainWarning: "Keine Trocknung aktiv",
    noData: "keine Daten",
    noInfoAvailable: "keine Informationen verfügbar",
    noProgramChainFound:
      "Keine Trocknung im Zeitfenster dieser Zuordnung gefunden.",
    numDryings: "1 Trocknung | {count} Trocknungen",
    numRuns: "Läufe",
    operatingStatus: "Betriebszustand",
    powerConsumption: "Stromverbrauch",
    powerFail: "Stecker gezogen",
    powerUp: "Hochgefahren",
    progStepCycle: "Prog/Step/Zyklus",
    runInfo: {
      duration: "Dauer: {0}",
      durationActiveRun: "Daten: {0} von {1}",
      formatRunProgramInfo: "T {0} / Lauf {1} / {2}",
      heatingPercentageAndPowerConsumption: "{0}% geheizt, {1} kWh",
      programDescription: "T {0} / P {1}",
      programDescriptionIdle: "T {0} / P 0 Temperaturkontrolle",
      programMonitor: "Monitor",
      programP0: "Temperaturkontrolle",
      programPX: "P{0}",
      runAssigned: "{0} vom {1} - {2}",
      runAssignedOpenEnded: "{0} seit {1}",
      runDescription: "Lauf {0} von {1} bis {2}",
      runDescriptionActive: "Lauf {0} seit {1} {2}",
      runDescriptionAdjusted: "Lauf {0} von {1} bis {2}*",
      runDescriptionSingleDay: "Lauf {0} am {1} bis {2}",
      runDescriptionSingleDayAdjusted: "Lauf {0} am {1} bis {2}*",
      runNoProject: "Kein Projekt",
      runNotAssigned: "Nicht zugeordnet",
      stepsAndCycles: "Stufen/Zyklen: {0}/{1}",
      t0: "T0: {0}m",
      temperatureGroundAndWall: "Wand: {0}-{1} °C / Boden: {2}-{3} °C",
      temperatureWall: "Wand: {0}-{1} °C",
    },
    runTime: "Laufzeit",
    runningSince: "Trocknung läuft",
    source: {
      ble: "BLE",
      iot: "IoT",
    },
    step: "Stufen",
    temperature: "Temperatur",
    title: "Details Panel {0}",
    waiting: "Warten",
    warning: "Warnung",
  },
  panelList: {
    activeFilters: "--- Aktive Filter: {0} ---",
    description:
      "Verwaltung HyDry Geräte: 1 Gerät | Verwaltung HyDry Geräte: {count} Geräte",
    descriptionAlt:
      "Auswahl HyDry Geräte: 1 Gerät | Auswahl HyDry Geräte: {count} Geräte",
    devicesOfProject: "'Gerätestatus Projekt \"{0}\"'",
    filterActiveDevices: "aktive Geräte",
    filterAllDevices: "alle Geräte",
    filterDevicesOverdueDevices: "überfällige Geräte",
    filterDevicesWithWarningOrError: "Geräte mit Warnung / Fehler",
    filterFinishedDevices: "fertige Geräte",
    filterInUsage: "Geräte im Einsatz",
    filterNotAssignedToProject: "Geräte ohne Projekt",
    hint: "Gerät wählen mit Klick",
    hyDryDevicesOverview: "Geräte Übersicht",
    manageHyDryDevices: "Geräte auswählen",
    noDevicesFound: "--- keine Geräte gefunden ---",
    ownComBoxes: "Eigene Geräte anzeigen",
    sortByDryingStart: "Trocknungsbeginn",
    sortByInventoryNumber: "Inventarnummer",
    sortByProject: "Projekt",
    sortBySerialnumber: "Seriennummer",
    sortByStatus: "Status",
    testBoxes: "Boxen Test Anzeigen",
  },
  panelSettings: {
    configName: "Konfiguration",
    firmwareIPU: "Firmware IPU",
    restartConfirmMessage: "Der Neustart wird über IoT vorgemerkt.",
    restartConfirmTitle: "Panel {0} neu starten?",
    title: "Einstellungen Panel {0}",
  },
  pdfReport: {
    device: "Gerät",
    deviceNumber: "Nr",
    end: "Ende",
    finalReport: "Technische Trocknung:\nAbschlussbericht",
    formatPowerConsumption: "Stromverbrauch {0}",
    formatProjectName: "Projekt {0}",
    from: "von",
    hyDryDevicesUsgae: "HyDry Geräteeinsatz",
    hyDryDryingInfo: "HyDry Trocknungsdaten",
    intermediateReport: "Technische Trocknung:\nZwischenbericht",
    meterNumber: "ZählerNr.",
    noHyDryDevicesUsed: "Diesem Projekt wurden keine HyDry Geräte zugeordnet.",
    powerConsumption: "Verbrauch",
    start: "Anfang",
    sumPowerConsumption: "Stromverbrauch gesamt",
    until: "bis",
  },
  pickerDialog: {
    noSelection: "Keine Auswahl",
  },
  programChainNote: {
    createNoteTitle: "Kommentar anlegen",
    deleteNoteConfirmationDialogMessage:
      "Wollen Sie den Kommentar wirklich löschen?",
    deleteNoteConfirmationDialogTitle: "Kommentar löschen",
    note: "Kommentar +",
    notePlus: "Kommentar +",
    noteSaved: "Kommentar gespeichert",
  },
  projectConclusion: {
    concludeProject: "Projekt abschließen",
    concludeProjectDialogMessage:
      "Wollen Sie Projekt {0} abschließen?",
    concludeProjectMessage:
      "Wollen Sie Projekt {0} abschließen und einen Abschlussbericht erstellen?",
    createFinalReport: "Zwischenbericht erstellen",
    createFinalReportButton: "Abschlussbericht erstellen",
    createInterimReport: "Zwischenbericht erstellen",
    createReport: "Bericht erstellen",
    description: "Projekt abschließen und HyDry Geräte abmelden",
    formatProjectFinished: "Abgeschlossen am {0} von {1}",
    projectConcluded: "Projekt abgeschlossen",
    projectDuration: "Projekt-Laufzeit",
    releaseFinalReport: "Abschlussbericht freigeben",
    reopenProjectButtonText: "Projekt wieder öffnen",
    sendFinalReport: "Abschlussbericht freigeben",
    signOffAllDevices: "Alle Geräte abmelden",
    signOffAllHyDryDevices: "Alle HyDry Geräte abmelden",
    signOffAllDevicesMessage:
      "Wollen Sie alle HyDry Geräte von diesem Projekt abmelden?",
    signOffAllDevicesSuccess: "Alle HyDry Geräte abgemeldet",
    withReport: "Mit Bericht",
    withoutReport: "Ohne Bericht",
  },
  projectDetails: {
    createNote: "Notiz erstellen",
    documents: "Dokumente",
    erp: "ERP",
    logBook: "Logbuch",
    meterReadingStart: "Stromzähler Anfang: {0}",
    noDevicesAssigned: "--- keine Geräte zugeordnet ---",
    notAvailable: "--- Projekt nicht verfügbar ---",
    note: "Notiz",
    notes: "Notizen",
    powerConsumption: "Stromverbrauch: {0}",
    project: "Projekt",
    projectConclusion: "Projektabschluss",
    projectConclusionShort: "Abschluss",
    projectNameAlreadyExistsMessage:
      "Es existiert bereits ein Projekt mit dem von Ihnen gewählten Projektnamen. Trotzdem sichern?",
    projectNameAlreadyExistsTitle: "Projektname existiert bereits",
    projectNumberAlreadyExists: "Projektnummer bereits vorhanden",
    projectScope: {
      damageAssessment: "Schadenaufnahme",
      deviceAssignment: "Gerätezuordnung",
      drying: "Trocknung",
      leakDetection: "Leckortung",
      devicesRental: "Leihgeräte",
      restoration: "Wiederherstellung",
    },
    projectTypeCodes: {
      0: "",
      1: "LO",
      2: "TR",
      3: "TW",
      4: "LT",
      5: "LW",
      6: "WH",
      7: "BR",
      8: "GZ",
      9: "GL",
    },
    projectTypeDefault: "Projekt Typ {0}",
    projectTypeDefaultLables: {
      0: "",
      1: "Leckortung",
      2: "Trocknung",
      3: "Trocknung+Wiederherstellung",
      4: "Leckortung+Trocknung",
      5: "Leckortung bis Wiederherstellung",
      6: "Wiederherstellung nach Trocknung",
      7: "Brandschaden",
      8: "Gerätezuordnung",
      9: "Geräteverleih",
    },
    reports: "Berichte",
    timeLine: "Zeitleiste",
    updateNote: "Notiz bearbeiten",
  },
  projectList: {
    activeFilters: "--- Aktive Filter: {0} ---",
    description:
      "Verwaltung Trocknungsprojekte: 1 Projekt | Verwaltung Trocknungsprojekte: {count} Projekte",
    filterAllProjects: "alle Projekte",
    filterOverdue: "überfällig",
    filterProjectsWithOngoingDrying: "Trocknung aktiv",
    filterRecentlyFinished: "abgeschlossen",
    filterRestoredProjects: "wiederhergestellt",
    filterWithDevices: "mit HyDry Geräten",
    finishedProjects: "Fertige Projekte",
    filterProjectsMovedToFinished: "verschoben",
    hint: "Projekt wählen mit Klick, neues Projekt mit +",
    hintWithoutOptionToCreate: "Projekt wählen mit Klick",
    newestProjets: "Neueste Projekte",
    noProjectsFound: "--- keine Projekte gefunden ---",
    numAllDevices: "{0}/{1} Geräte aktiv",
    numAllDevicesAllActive: "1 Gerät aktiv | {count} Geräte aktiv",
    numAllDevicesNoneActive: "1 Gerät | {count} Geräte",
    numApartments: "1 Wohnung | {count} Wohnungen",
    numRooms: "1 Raum | {count} Räume",
    oldestProjects: "Älteste Projekte",
    overdueProjects: "Überfällige Projekte",
    projectFinished: "Projekt fertig",
    projectNumber: "Projektnummer",
    projectProgress: "Projektfortschritt",
    recentProjects: "Aktuelle Projekte",
    relevantProjectsTitle: "Relevante Projekte",
    showFinishedProjects: "Fertige Projekte anzeigen",
    showFinishedProjectsShort: "Fertige",
    showRecentProjects: "Aktuelle Projekte anzeigen",
    showRecentProjectsShort: "Aktuelle",
    title: "Alle Projekte",
    types: {
      archived: "Alte",
      deleted: "Gelöschte",
      finished: "Fertige",
      running: "Aktuelle",
    },
    urgency: "Dringlichkeit",
  },
  projectLogs: {
    activeFilters: "--- Aktive Filter: {0} ---",
    eventLogs: {
      appointmentDamageAssessment: "Termin Schadenaufnahme",
      appointmentDryingConclusion: "Termin Trocknungsabbau",
      appointmentDryingConclusionPortalProject: "Beginn Trocknungsabbau",
      appointmentDryingPreparation: "Termin Trocknungsaufbau",
      appointmentDryingPreparationPortalProject: "Beginn Trocknungsaufbau",
      appointmentFollowUpInspection: "Wiedervorlage",
      appointmentIntermediate: "Termin Messung",
      appointmentLeakDetection: "Termin Leckortung",
      appointmentRepair: "Termin Wiederherstellung",
      autoTimeTracking: "",
      clientDataCompleted: "K1: Projektdaten vollständig",
      damageAssessmentCompleteFinished:
        "K3: Vollständige Schadenaufnahme abgeschlossen",
      damageAssessmentEasyFinished:
        "K3: Einfache Schadenaufnahme abgeschlossen",
      damageAssessmentFinished: "K3: Schadenaufnahme abgeschlossen",
      damageAssessmentPlanned: "K1: Schadenaufnahme geplant {0}",
      damageAssessmentRoomAdded: "{0}: {1}, {2} hinzugefügt",
      damageAssessmentRoomDeleted: "{0}: {1}, {2} gelöscht",
      contactPersonAdded: "Wohnung {0} hinzugefügt",
      contactPersonDeleted: "Wohnung {0} gelöscht",
      damageAssessmentStarted: "K3: Schadenaufnahme begonnen",
      damagePatternConclusion: "K4: Schadenbild fertig",
      damagePatternFinished: "K3: Schadenaufnahme abgeschlossen",
      damagePatternReopened: "K4: Schadenbild wieder geöffnet",
      damagePatternStarted: "K4: Schadenbild begonnen",
      damageReportSent: "K4: Schadenbericht versandt",
      devicesSetupCompleted: "K7: Gerätezuordnung vollständig",
      documentationAndLeakDetectionFinished: "K2: Leckortung durchgeführt",
      documentationAndLeakDetectionSectionFinished: "K2: Projektdaten erfasst",
      dryingCompleted: "K8: Trocknung abgeschlossen",
      dryingFinished: "K7: Trocknungsende, Geräte abgebaut",
      dryingNecessary: "Trocknung erforderlich",
      dryingNotNecessary: "Trocknung nicht erforderlich",
      dryingNotSuccessful: "Trocknung nicht erfolgreich",
      dryingProgressCompletedFollowUp: "K6: Wiedervorlage abgeschlossen",
      dryingProgressCompletedMeasurement: "K6: Messung abgeschlossen",
      dryingProgressStarted: "K6: Messung begonnen",
      dryingProjectFinished: "K4: Projekt fertig",
      dryingRunning: "Trocknung aktiv",
      dryingSetupFinished: "K5: Trocknungsaufbau abgeschlossen",
      dryingSetupStarted: "K5: Trocknungsaufbau begonnen",
      dryingSuccessful: "Trocknung erfolgreich",
      finished: "Fertig",
      followUpInspectionDate: "Wiedervorlage {0}",
      interimReportSent: "K8: Zwischenbericht versandt",
      leakDetectionExecutionCompleted: "K2: Leckortung fertig",
      leakDetectionExecutionStarted: "K2: Leckortung begonnen",
      leakDetectionPreparationCompleted:
        "K2: Leckortung Vorbereitung abgeschlossen",
      leakDetectionPreparationFinished: "K2: Vorbereitung fertig",
      leakDetectionPreparationStarted: "K2: Vorbereitung begonnen",
      leakDetectionProjectConclusionStarted: "K4: Projektabschluss begonnen",
      leakDetectionProjectFinished: "K4: Projekt abgeschlossen",
      leakDetectionProjectReopened: "K4: Projekt wieder geöffnet",
      leakDetectionReportSent: "K4: Leckortungsbericht versandt",
      leakDetectionStarted: "K2: Leckortung begonnen",
      measurementCreated: "K6: Messung durchgeführt (Messreihe {0})",
      measurementSeriesChangedK2WithDescription: "K6: Messreihe {0} geändert",
      measurementSeriesChangedK2WithDescriptionWithoutTile:
        "Messreihe {0} geändert",
      measurementSeriesCreatedK2WithDescription: "K6: Messreihe {0} angelegt",
      measurementSeriesCreatedK2WithDescriptionWithoutTile:
        "Messreihe {0} angelegt",
      mergedDevicesSetup: "K7: Gerätezuordnung begonnen",
      note: "",
      packupDevicesFinished: "K7: Geräte abgebaut",
      packupDevicesStarted: "K7: Geräteabbau begonnen",
      portalProjectCreation: "Neues Projekt",
      projectAssigned: "Projekt zugeordnet",
      projectAssignedWithUserInfo: "Projekt auf Benutzer {0} zugeordnet",
      projectCompletedFinalTile: "K8: Projekt abgeschlossen",
      projectConclusionCompleted: "K8: Abschluss",
      projectConclusionStarted: "K8: Projektabschluss begonnen",
      projectCreation: "K1: Neues Projekt",
      projectCreationWithDamageDay: "K1: Neues Projekt, Schadentag {0}",
      projectDeleted: "Projekt gelöscht",
      projectDeletedInApp: "Projekt in Project App gelöscht",
      projectFinished: "K8: Projekt fertig",
      projectMovedToArchived: "Projekt archiviert",
      projectMovedToFinished: "Projekt verschoben",
      projectReactivated: "Projekt wieder aktiviert",
      projectReopened: "K8: Projekt wieder geöffnet",
      projectReopenedFromPortal: "Projekt wieder geöffnet",
      projectReportSent: "K8: Projektbericht versandt",
      projectRestored: "Projekt wiederhergestellt",
      projectResult: "",
      projectWorkStarted: "K2: Projektbearbeitung begonnen",
      repairCompleted: "K8: Wiederherstellung abgeschlossen",
      repairStarted: "K8: Wiederherstellung begonnen",
      restorationNecessary: "Wiederherstellung erforderlich",
      restorationNotNecessary: "Wiederherstellung nicht erforderlich",
      restorationNotSuccessful: "Wiederherstellung nicht erfolgreich",
      restorationSuccessful: "Wiederherstellung nicht erfolgreich",
      startedCachedProjectEdit: "",
      stepDamageAssessmentAppointment: "",
      stepDamageAssessmentComplete: "K4: Schadenaufnahme abgeschlossen",
      stepDamageAssessmentResult: "",
      stepDryingConclusionAppointments: "",
      stepDryingConclusionResults: "K7: Trocknung abgeschlossen",
      stepDryingSetUpAppointments: "",
      stepDryingSetUpCompletions: "Trocknung läuft",
      stepFirstContact: "K1: Kontakt aufgenommen",
      stepIntermediateMeasurementAppointments: "",
      stepIntermediateMeasurementCompletions: "K6: Messung abgeschlossen",
      stepLeakDetectionAppointment: "",
      stepLeakDetectionResult: "K4: Leckortung fertig",
      stepOfferResultDryingApproved: "K4: Trocknung freigegeben",
      stepOfferResultDryingNotApproved: "K4: Projekt fertig",
      stepOfferResulRestorationApproved: "K4: Wiederherstellung freigegeben",
      stepOfferSendToInsurance: "K4: Angebot an Versicherung geschickt",
      stepProjectAccepted: "K1: Auftrag erfasst",
      stepProjectApprovedProjectFinished: "K8: Projekt fertig",
      stepProjectApprovedProjectSaved: "K1: Projekt bestätigt",
      stepProjectResult: "K8: Projekt fertig",
      stepRepairAppointments: "",
      stepRepairStart: "",
      tile1: "K1",
      tile2: "K2",
      tile3: "K3",
      tile4: "K4",
      tile5: "K5",
      tile6: "K6",
      tile7: "K7",
      tile8: "K8",
      timeTracking: "",
      timeTrackingReportSent: "Zeiteintrag versandt",
    },
    eventLogFilter: {
      allLogs: "alle Einträge",
      autoTimeTracking: "automatische Einträge",
      notes: "Notizen",
      noteAndStatus: "Status + Notizen",
      timeTracking: "Manuelle Einträge",
    },
    eventLogSortOrder: {
      newestFirst: "Neueste",
      oldestFirst: "Älteste",
    },
    noLogs: "--- keine Logs gefunden ---",
    noteLogs: {
      apartment: "Wohnung",
      defaultApartmentName: "Wohnung",
      dialog: {
        createErrorMessage: "Fehler beim Hinzufügen der Notiz",
        createSuccessMessage: "Notiz wurde erfolgreich hinzugefügt",
        deletionConfirmationMessage:
          "Sind Sie sicher, dass Sie die Notiz löschen wollen?",
        deletionConfirmationTitle: "Notiz löschen",
        deletionErrorMessage: "Fehler beim Löschen der Notiz",
        deletionSuccessMessage: "Notiz wurde erfolgreich gelöscht",
        editErrorMessage: "Fehler beim Bearbeiten der Notiz",
        editSuccessMessage: "Notiz wurde erfolgreich bearbeitet",
        titleCreate: "Notiz anlegen",
        titleEdit: "Notiz bearbeiten",
        useForReport: "in externen Bericht",
      },
      note: "Notiz",
      noteTitle: "Notiz:",
      noteIn: "Notiz in {0}",
      room: "Raum",
      roomName: "Raum {0}",
    },
    numberOfLogsDisplayed: "1 Log | {count} Logs",
    projectState: {
      allApartments: " (Alle Wohnungen)",
      apartmentNumber: " (W{0})",
      approveProject: "Projekt bestätigen",
      damageAssessmentBegun: "Schadenaufnahme begonnen",
      damageAssessmentCompletedWithoutTile: "Schadenaufnahme abgeschlossen",
      damageAssessmentResumed: "Schadenaufnahme fortgesetzt",
      damageAssessmentSuspended: "Schadenaufnahme unterbrochen",
      dryingConcluded: "Trocknung abgeschlossen",
      dryingDuration: "Trocknung: 1 Tag | Trocknung: {count} Tage",
      dryingPackupBegun: "Trocknungsabbau begonnen",
      dryingPackupFinished: "Trocknung abgeschlossen",
      dryingPackupResumed: "Trocknungsabbau fortgesetzt",
      dryingPackupSuspended: "Trocknungsabbau unterbrochen",
      dryingRunning: "Trocknung aktiv",
      dryingSetupBegun: "Trocknungsaufbau begonnen",
      dryingSetupFinished: "Trocknung aufgebaut",
      dryingSetupResumed: "Trocknungsaufbau fortgesetzt",
      dryingSetupSuspended: "Trocknungsaufbau unterbrochen",
      establishFirstContact: "Kontakt aufnehmen",
      firstContactEstablished: "Kontakt aufgenommen",
      interimReportCreated: "Zwischenbericht erstellt",
      intermediateMeasurementBegun: "Messung begonnen",
      intermediateMeasurementFinished: "Messung durchgeführt",
      intermediateMeasurementResumed: "Messung fortgesetzt",
      intermediateMeasurementSuspended: "Messung unterbrochen",
      leakDetectionBegun: "Leckortung begonnen",
      leakDetectionFinished: "Leckortung fertig",
      leakDetectionResumed: "Leckortung fortgesetzt",
      leakDetectionSuspended: "Leckortung unterbrochen",
      makeAppointment: "Termin vereinbaren",
      noDrying: "Keine Trocknung",
      noReport: "Kein Bericht",
      offerSendToInsurance: "Angebot an Versicherung geschickt",
      orderRecorded: "Auftrag erfast",
      orderRejected: "Auftrag abgelehnt",
      projectApproved: "Projekt bestätigt",
      projectItemFinished: "Projekt fertig",
      projectOnHold: "Projekt angehalten",
      reportCreated: "Bericht erstellt",
      repairBegun: "Wiederherstellung begonnen",
      repairFinished: "Wiederherstellung abgeschlossen",
      repairResumed: "Wiederherstellung fortgesetzt",
      repairStarted: "Wiederherstellung läuft",
      repairSuspended: "Wiederherstellung unterbrochen",
    },
  },
  projectOperationSource: {
    api: "API",
    cloudFunction: "IRES Cloud",
    deviceManagerApp: "IRES Work",
    portal: "IRES Office",
    projectManagerApp: "IRES Project",
    pythonScript: "Script",
  },
  projectOverview: {
    recordedByItem: "{0} {1} ({2})",
  },
  projectStateFilter: {
    allProjects: "Projekt | Projekte",
    assignDevices: "Geräte zuordnen",
    concludeProjekt: "Projekt abschließen",
    damageAssessment: "Schadenaufnahme",
    drying: "Trocknung",
    dryingConclusion: "Trocknungsabbau",
    dryingSetup: "Trocknungsaufbau",
    followUpInspection: "Wiedervorlage",
    insuranceOffer: "Angebot an Versicherung",
    intermediateMeasurement: "Zwischenmessung",
    leakDetection: "Leckortung",
    missingDryingApproval: "Trocknung freigeben | Trocknungen freigeben",
    missingFirstContact: "Kontaktaufnahme | Kontaktaufnahmen",
    missingProjectApproval: "Projekt bestätigen | Projekte bestätigen",
    missingProjectConclusion: "Projektabschluss | Projektabschlüsse",
    missingProjectOwner: "ohne Bearbeiter",
    missingProjectSupervisor: "ohne Projektleiter",
    missingReport: "ohne Bericht",
    new: "Neu",
    overall: "Gesamt",
    overdue: "Überfällig",
    ownProjects: "eigenes Projekt | eigene Projekte",
    projectSupervisor: "Projekt verantwortlich | Projekte verantwortlich",
    recentlyFinished: "kürzlich abgeschlossen",
    repair: "Wiederherstellung",
    withHyDryDevices: "mit HyDry Geräten",
  },
  projectStatus: {
    acceptOrder: "Projekt bestätigen?",
    actionAcceptOrder: "Projekt bestätigen",
    actionRejectOrder: "Projekt ablehnen",
    allApartments: "Alle Wohnungen",
    appointmentStep4: "Termin Leckortung",
    appointmentStep6: "Termin Schadenaufnahme",
    appointmentStep10: "Termin Trocknungsaufbau",
    appointmentStep12: "Termin Messung",
    appointmentStep14: "Termin Trocknungsabbau",
    appointmentStep16: "Termin Wiederherstellung",
    approvalStatus: "Freigabestatus: {0}",
    approvalStatuses: {
      noDryingNecessary: "keine Trocknung notwendig",
      noRestorationNecessary: "keine Wiederherstellung notwendig",
      yesExecute: "Ja, durchführen",
      yesOffer: "Ja, Angebot",
    },
    concludedStep5: "Leckortung fertig",
    concludedStep7: "Schadenaufnahme fertig",
    concludedStep11: "Trocknungsaufbau fertig",
    concludedStep13: "Messung fertig",
    concludedStep15: "Trocknungsabbau fertig",
    concludedStep17: "Wiederherstellung fertig",
    controlMeasurement: "Abschluss Kontrollmessung",
    csvTrades: "Gewerke",
    damageDescription: "Schadenbeschreibung: {0}",
    dateTime: "Datum / Uhrzeit",
    documentsFilename: "ALLE_DOKUMENTE",
    downloadAll: "Alle Dokumente",
    downloadExternalReport: "Externer Bericht",
    downloadInternalReport: "Interner Bericht",
    downloadReport: "Bericht",
    dryingAreaFloor: "Fläche Boden (m²)",
    dryingAreaWallCeiling: "Fläche Wand / Decke (m²)",
    dryingDuration: "Trocknungsdauer (Tage)",
    dryingPackupStarted: "Trocknungsabbau begonnen",
    dryingSetupStarted: "Trocknungsaufbau begonnen",
    formatAppointment: "Termin: {0}",
    formatDryingDuration: "Trocknung: 1 Tag | Trocknung: {count} Tage",
    formatEstimatedDryingDuration: "Trocknungsdauer 1 Tag | Trocknungsdauer {count} Tage",
    formatDryingAreaFloor: "Boden {0} m²",
    formatDryingAreaWallCeiling: "Wand / Decke {0} m²",
    formatRestorationDuration:
      "Wiederherstellung: 1 Tag | Wiederherstellung: {count} Tage",
    hyDryCertificate: "HyDry Zertifikat",
    note: "Bemerkung: {0}",
    ongoingStep4: "Leckortung läuft",
    ongoingStep6: "Schadenaufnahme läuft",
    ongoingStep10: "Trocknungsaufbau läuft",
    ongoingStep12: "Messung läuft",
    ongoingStep14: "Trocknungsabbau läuft",
    ongoingStep16: "Wiederherstellung läuft",
    orderAccepted: "Projekt bestätigt",
    orderRejected: "Projekt abgelehnt",
    parameters: "Information",
    phaseInfo4: "Leckortung begonnen",
    phaseInfo6: "Schadenaufnahme begonnen",
    phaseInfo10: "Trocknungsaufbau begonnen",
    phaseInfo12: "Messung begonnen",
    phaseInfo14: "Trocknungsabbau begonnen",
    phaseInfo16: "Wiederherstellung begonnen",
    projectEndDesc: "Projektende: {0}",
    projectState: {
      archived: "Projekt war archiviert",
      deleted: "Projekt war gelöscht",
      finished: "Projekt war abgeschlossen",
      movedToFinished: "Projekt wurde verschoben",
    },
    projectStepDescription: "Beschreibung",
    releaseDrying: "Trocknung freigeben?",
    releaseRestoration: "Wiederherstellung freigeben?",
    resumedStep5: "Leckortung fortgesetzt",
    resumedStep7: "Schadenaufnahme fortgesetzt",
    resumedStep11: "Trocknungsaufbau fortgesetzt",
    resumedStep13: "Messung fortgesetzt",
    resumedStep15: "Trocknungsabbau fortgesetzt",
    resumedStep17: "Wiederherstellung fortgesetzt",
    servicesCSV: "Leistungstablle CSV",
    step: "Schritt",
    step1: "Auftrag erfasst",
    step10: "Beginn Trocknungsaufbau",
    step11: "Abschluss Trocknungsaufbau",
    step12: "Beginn Messung",
    step13: "Abschluss Messung",
    step14: "Beginn Trocknungsabbau",
    step15: "Abschluss Trocknung",
    step16: "Beginn Wiederherstellung",
    step17: "Abschluss Wiederherstellung",
    step18: "Projekt abgeschlossen",
    step2: "Projekt bestätigt?",
    step3: "Kontaktaufnahme",
    step4: "Beginn Leckortung",
    step5: "Abschluss Leckortung",
    step6: "Beginn Schadenaufnahme",
    step7: "Abschluss Schadenaufnahme",
    step8: "Angebot an Versicherung",
    step9: "Freigabe Trocknung",
    step9Restoration: "Freigabe Wiederherstellung",
    stepDoneBy: "Durchgeführt von",
    suspendedStep5: "Leckortung unterbrochen",
    suspendedStep7: "Schadenaufnahme unterbrochen",
    suspendedStep11: "Trocknungsaufbau unterbrochen",
    suspendedStep13: "Messung unterbrochen",
    suspendedStep15: "Trocknungsabbau unterbrochen",
    suspendedStep17: "Wiederherstellung unterbr.",
    appointmentAlreadyCompleted: "Der Termin wurde bereits abgeschlossen und kann nicht gelöscht werden.",
    appointmentDeleteError: "Beim Löschen des Termins ist ein Fehler aufgetreten.",
    appointmentDeleteSuccess: "Termin erfolgreich gelöscht.",
    appointmentSaveSuccess: "Termin erfolgreich gespeichert.",
    user: "User",
  },
  projectStep: {
    acceptOrder: "Auftrag annehmen?",
    appointmentDamageAssessment: "Schadenaufnahme",
    appointmentDryingConclusion: "Trocknungsabbau",
    appointmentDryingSetup: "Trocknungsaufbau",
    appointmentIntermediateMeasurement: "Messung",
    appointmentLeakDetection: "Leckortung",
    appointmentMissingDate: "Wann???",
    appointmentMissingResponsibleUser: "Wer???",
    appointmentNow: "sofort",
    appointmentOpenResposibleUser: "Bearbeiter: offen",
    appointmentRestoration: "Wiederherstellung",
    approveDrying: "Trocknung freigeben?",
    approveProject: "Projekt bestätigen",
    assignDevices: "Geräte zuordnen",
    concludeProject: "Projekt abschließen",
    damageAssessmentFinished: "Schadenaufnahme fertig",
    damageAssessmentResumed: "Schadenaufnahme fortgesetzt",
    damageAssessmentRunning: "Schadenaufnahme läuft",
    damageAssessmentSuspended: "Schadenaufnahme unterbrochen",
    damageDescription: "Gesprächspartner / Schadenbeschreibung",
    dryingApproved: "Trocknung freigegeben",
    dryingCompleted: "Trocknung abgebaut",
    dryingConcluded: "Trocknung abgeschlossen",
    dryingFinished: "Trocknung beendet",
    dryingNecessary: "Trocknung erforderlich?",
    dryingPackupFinished: "Trocknung abgebaut",
    dryingPackupResumed: "Trocknungsabbau fortgesetzt",
    dryingPackupSuspended: "Trocknungsabbau unterbrochen",
    dryingRunning: "Trocknung aktiv",
    dryingSetupFinished: "Trocknung aufgebaut",
    dryingSetupResumed: "Trocknungsaufbau fortgesetzt",
    dryingSetupSuspended: "Trocknungsaufbau unterbrochen",
    dryingSuccessful: "Trocknung erfolgreich?",
    establishFirstContact: "Kontakt aufnehmen",
    firstContactEstablished: "Kontakt aufgenommen",
    followUpInspectionShorthand: "WV",
    formatDryingFinished: "{0}: Trocknung abgebaut",
    formatDryingResumed: "{0}: Trocknung fortgesetzt",
    formatDryingSuspended: "{0}: Trocknung unterbrochen",
    formatDryingRunningSince: "Trocknung aktiv\nseit {0}",
    formatDryingSetupFinished: "{0}: Trocknung aufgebaut",
    formatDryingSetupResumed: "{0}: Trocknungsaufbau fortgesetzt",
    formatDryingSetupSuspended: "{0}: Trocknungsaufbau unterbrochen",
    formatIntermediateMeasurementFinished: "{0}: Messung durchgeführt",
    formatIntermediateMeasurementResumed: "{0}: Messung fortgesetzt",
    formatIntermediateMeasurementSuspended: "{0}: Messung unterbrochen",
    formatRepairFinished: "{0}: Wiederherstellung abgeschlossen",
    formatRepairResumed: "{0}: Wiederherstellung fortgesetzt",
    formatRepairSuspended: "{0}: Wiederherstellung unterbrochen",
    intermediateMeasurementFinished: "Messung durchgeführt",
    intermediateMeasurementResumed: "Messung fortgesetzt",
    intermediateMeasurementSuspended: "Messung unterbrochen",
    interimReportCreated: "Zwischenbericht erstellt",
    leakDetectionFinished: "Leckortung fertig",
    leakDetectionResumed: "Leckortung fortgesetzt",
    leakDetectionRunning: "Leckortung läuft",
    leakDetectionSuspended: "Leckortung unterbrochen",
    makeAppointment: "Termin vereinbaren",
    noContract: "Kein Auftrag",
    noDrying: "Keine Trocknung",
    noReport: "Kein Bericht",
    noRestoration: "Keine Wiederherstellung",
    note: "Bemerkung",
    offerSend: "Angebot an Versicherung geschickt",
    orderRecorded: "Auftrag erfasst",
    orderRejected: "Auftrag abgelehnt",
    projectApproved: "Projekt bestätigt",
    projectEnd: "Projektende",
    projectFinished: "Projekt fertig",
    projectOnHold: "Projekt angehalten",
    projectStepRepairFinished: "Wiederherstellung abgeschlossen",
    projectStepRepairResumed: "Wiederherstellung fortgesetzt",
    projectStepRepairStarted: "Wiederherstellung läuft",
    projectStepRepairSuspended: "Trocknungsaufbau unterbrochen",
    projectStepSetupDrying: "Trocknungsaufbau läuft",
    projectStepSetupDryingResumed: "Trocknungsaufbau fortgesetzt",
    projectStepSetupDryingSuspended: "Trocknungsaufbau unterbrochen",
    repairFinished: "Wiederherstellung abgeschlossen",
    repairSuspended: "Wiederherstellung unterbrochen",
    reportCreated: "Bericht erstellt",
    restorationApproved: "Wiederherstellung freigegeben",
    restorationNecessary: "Wiederherstellung erforderlich",
    restorationNotNecessary: "Wiederherstellung nicht erforderlich",
    setProjectSupervisor: "Projektleiter setzen",
  },
  rateDrying: {
    dryingDuration: {
      formatShouldHaveStoppedAt: "J. hätte die Trocknung am {0} abgebaut.",
      shouldHaveRunLonger: "J. hätte die Trocknung noch länger laufen lassen.",
      shouldHaveStoppedAt: "Wann würde J. abbauen?",
      title: "Trocknungsdauer",
    },
    formatPhase: "Phase {0}",
    formatPhases: {
      boost: "Boost",
      comfort: "Comfort",
      eco: "Eco",
      smart: "Smart",
    },
    formatPhaseNew: "Phase",
    formatPhaseShort: "P{0}",
    formatPhaseShortNew: "P",
    formatRateHistoryBox: "Qualität Box {0} Trocknung {1}",
    formatRateHistoryPanel: "Qualität Panel {0} Trocknung {1}",
    postDryingRun: "Nachlauf",
    quality: "Qualität",
    qualityDrying: {
      bad: "befriedigend",
      dryingSpeed: "Geschwindigkeit",
      flow: "Strömung",
      good: "gut",
      long: "eher lang",
      ok: "ok",
      roomHumidity: "Raumfeuchte",
      roomTemperature: "Raumtemperatur",
      short: "eher kurz",
      title: "Qualität Trocknung",
      tooLong: "zu lang",
      tooShort: "zu kurz",
      veryBad: "schlecht",
      veryGood: "sehr gut",
    },
    qualityNotes: {
      EDTGeneral: "EDT allgemein",
      EDTPauses: "EDT Pausen",
      EDTPhase4: "EDT Phase 4",
      anomalies: "Anomalien",
      dryingWithPreDriedAir: "warme vorgetrocknete Luft",
      general: "Allgemein",
      gkgConstant: "g/kg konstant",
      gkgConstantInPause: "g/kg konstant in Pause",
      gkgDecreasedInPause: "g/kg steigt in Pause",
      gkgIncreasedAfterPause: "g/kg steigt nach Pause",
      gkgIncreasedInPause: "g/kg fällt in Pause",
      gkgOfProcessAirTooHigh: "g/kg der Prozessluft zu hoch",
      gkgRoomTooHigh: "g/kg Raum zu hoch",
      humidityOfProcessAirTooHigh: "rF der Prozessluft zu hoch",
      insufficientAirFlow: "Strömung zu gering",
      interruptionByCustomers: "Unterbrechung durch Kunden",
      moistureNearDrillHoles: "Feuchtigkeit in Peripherie um Löcher",
      newMoistureAppeared: "neuer Feuchteeintrag",
      noPlasticSheetingOnRawFloor: "ohne Folie auf Rohboden",
      powerConsumptionTooLow: "Stromverbrauch zu niedrig",
      relayMalfunction: "Relais defekt",
      roomConditions: "Raumbedingungen",
      roomHumidityTooHigh: "rF Raum zu hoch",
      roomTemperature: "Raumtemperatur",
      stableAfterXDays: "stabil nach x Tagen",
      title: "Hinweise",
      tooHigh: "zu hoch",
      tooLow: "zu niedrig",
      underfloorHeating: "Fußbodenheizung",
    },
    qualityOverall: {
      dryingDuration: "Trocknungsdauer",
      dryingProcess: "Trocknungsverlauf",
      exemplaryFor: "Beispielhaft für",
      knowledgeGain: "Input für Lernen",
      labels: {
        dryingWithPreDriedAir: "Trocknung mit vorgetrockneter, warmer Luft",
        insufficientAirFlow: "Strömung zu gering",
        moistureNearDrillHoles: "Feuchtigkeit in Peripherie um Löcher",
        newMoistureAppeared: "neuer Feuchte-Eintrag",
        nightlyInterruptionByClient: "nächtliche Unterbrechungen durch Kunden",
        noPlasticSheetingOnRawFloor: "ohne Folie auf dem Rohboden",
        relayMalfunction: "Relais defekt",
        underfloorHeating: "Fußbodenheizung",
      },
      title: "Gesamtbewertung",
    },
    qualityPhase: {
      days: "Tage",
      delta: "Delta",
      duration: "Dauer",
      maximumPowerConsumption: "max Leistung",
      minimumPowerConsumption: "min Leistung",
      mixingRatio: "Mischv",
      overall: "Gesamt",
      progress: "Fortschritt",
      progressMixingRatio: "MV/d",
      progressRelativeHumidity: "% rF/d",
      relativeHumidity: "% rF",
      title: "Qualität Phasen",
      watt: "Watt",
    },
    qualityProgram: {
      activity: "Aktivität",
      ok: "ok",
      pauses: "Pause",
      phaseChange: "Phasenwechsel",
      title: "Qualität Programm",
      toFast: "zu schnell",
      toLong: "zu lange",
      toShort: "zu kurz",
      toSlow: "zu langsam",
    },
    ratingSaved: "Bewertung gespeichert",
    title: "Qualität bewerten",
  },
  regulatorTypes: {
    agent: "Makler",
    externalRegulator: "Externer Regulierer",
    vuAgency: "VU Agentur",
    vuFieldSales: "VU Außendienst",
    vuInternalSales: "VU Innendienst",
  },
  report: {
    completedPhaseReport: "Bericht",
    damageReport: "Bericht Schadenaufnahme",
    deleteReportMessage: "Wollen Sie den Bericht wirklich löschen?",
    deleteReportTitle: "Bericht löschen",
    finalReportDrying: "Abschlussbericht Trocknung",
    footer: {
      dryingReport: "HyDry Trocknungsbericht",
      finalReport: "HyDry Abschlussbericht",
      interimReport: "HyDry Zwischenbericht",
      formatPageOfPages: "{0} von {1}",
    },
    formatReportDate: "erstellt {0}",
    formatReportDateAndSendDate: "erstellt und versandt {0}",
    formatReportDateWithSendDate: "vom {0}, versandt {1}",
    interimPhaseReport: "Zwischenbericht",
    interimReportDrying: "Zwischenbericht Trocknung",
    interimReportRepair: "Zwischenbericht Wiederherstellung",
    leakDetectionReport: "Bericht Leckortung",
    reportName: {
      dryingReportFileNamePrefix: "HYDRY_TROCKNUNG",
      finalReportFileNamePrefix: "HYDRY_ABSCHLUSS",
      hyDryCertificateFileNamePostfix: "HYDRY_ZERTIFIKAT",
      interimReport: "HyDry Zwischenbericht",
      interimReportFileNamePrefix: "HYDRY_ZWISCHEN",
    },
    reportType: {
      damageReport: "SCHADENBILD",
      finalReport: "ABSCHLUSS",
      interim: "ZWISCHEN",
      leakDetection: "LECKORTUNG",
    },
    reportUsage: {
      damageAssessment: "Schadenaufnahme",
      documentDescription: "",
      drying: "Trocknung",
      external: "EXT",
      externalDescription: "extern",
      externalImagesDescription: "Bilder",
      externalShortDescription: "Bericht",
      externalSingleTimeTrackingDescription: "zeitbericht",
      externalTimeTrackingDescription: "zeitbericht",
      hyDryCertificate: "HyDry Zertifikat",
      internal: "INT",
      internalDescription: "intern",
      leakDetection: "Leckortung",
      measurementProtocol: "Messprotokoll",
      restoration: "Wiederherstellung",
      serviceDescription: "Gewerke",
      serviceJsonDescription: "PDE",
      svImage: "SV Bild Erstbericht",
    },
    subject: {
      damageAssessment: "Schadenaufnahme",
      drying: "Trocknung",
      leakDetection: "Leckortung",
      repair: "Wiederherstellung",
    },
    timeTracking: "Bericht Zeiterfassung",
  },
  reportList: {
    hint: "Berichte zur Gerätezuordnung und zum Stromverbrauch",
    noReportsFound: "--- keine Berichte gefunden ---",
  },
  resetPassword: {
    errorEmailSharingPasswordNoMatch: "Kennwort stimmt nicht überein",
    errorMinEmailSharingPasswordLength:
      "Das Kennwort muss aus mindestens 8 Zeichen bestehen.",
    errorMinPasswordLength:
      "Das Passwort muss aus mindestens 8 Zeichen bestehen.",
    errorPasswordNoMatch: "Passwörter stimmen nicht überein",
    errorWrongEmailSharingPassword: "Kennwort stimmt nicht",
    errorWrongPassword: "Passwort stimmt nicht",
    newEmailSharingPassword: "Neues Kennwort",
    newEmailSharingPasswordRepeated: "Neues Kennwort wiederholt",
    newPassword: "Neues Passwort",
    newPasswordRepeated: "Neues Passwort wiederholt",
    oldPassword: "Bisheriges Passwort",
    passwordResetFailed:
      "Beim Zurücksetzen deines Passworts ist ein Fehler aufgetreten. Bitte versuche es erneut.",
    passwordResetSuccess: "Dein Passwort wurde erfolgreich zurückgesetzt.",
    setNewEmailSharingPassword: "Neues Kennwort setzen",
    setNewPassword: "Neues Passwort setzen",
    tokenInvalid:
      "Der Link zum Zurücksetzen deines Passworts ist ungültig oder abgelaufen.",
  },
  sampleList: {
    dryingPauseTypes: {
      humidityThresholdReached: "Feuchtigkeitsschwelle erreicht",
      inactive: "Inaktiv",
      infinite: "Unendlich",
      manual: "Manuell",
      nightMode: "Nachtmodus",
      powerOverload: "Stromüberlastung",
      program: "Programm",
      suspend: "Pausieren",
      temperatureTooHigh: "Temperatur zu hoch",
    },
    event: "Event: {0}",
    filterAll: "Alle",
    filterBatteryEvent: "Batterie-Events",
    filterDryingEvent: "Trocknungs-Events",
    filterEndOfStep: "Ende Step",
    filterEvent: "Events",
    filterMonitor: "Monitor",
    filterPowerReduction: "Power Reduction",
    formatDryingPauseState: "Pause vor: {0}, Pause nach: {1}",
    formatTitle: "Samples von {0} / T{1} / Lauf {2} / P{3} ab {4}",
    formatVoltage: "{0} V",
    formatUartError: "Aggregated Counter: {0} / Error Counter: {1}",
    heatRatio: "Heat Ratio",
    pauseState: "Pause state: {0}",
    samplesPerPage: "Samples pro Seite:",
    sortAscending: "Aufsteigend sortieren",
    sortDescending: "Absteigend sortieren",
    titleChipTemp1: "Chip1",
    titleChipTemp2: "Chip2",
    titleCycle: "Zyklus",
    titleEvent: "Event",
    titleIndex: "Index",
    titlePower: "Power",
    titleStatus: "Status",
    titleStep: "Step",
    titleTime: "Zeit",
    titleWallChip1Max: "Chip1Max",
    titleWallTemp1: "Wall1",
    titleWallTemp1Max: "Wall1Max",
    titleWallTemp2: "Wall2",
    titleWallTemp2Max: "Wall2Max",
  },
  scheduling: {
    durationInMinutes: "Dauer (min)",
    taskDetails: {
      addAppointment: "Termin+",
      addNote: "Notiz+",
      appointmentConfirmed: "Termin bestätigt",
      dateSuggestions: "Mögliche Termine",
      delete: {
        message: "Bestätigten Termin wirklich löschen?",
        title: "Termin löschen?",
      },
      deleteNote: "Notiz-",
      fromDate: "ab Datum",
      noSuggestionsFound: "Kein zulässiger Termin gefunden, bitte Ziele ändern",
      note: "Notiz",
      parameterFixed: "fix",
      parametersForPlanning: "Ziele für Terminplanung",
      title: "Termin planen",
      undoConfirmation: {
        message: "Soll der bestätigte Termin freigegeben werden?",
        title: "Bestätigung entfernt",
      },
      unsavedChagnes: {
        message:
          "Es wurden Daten für die Planung geändert. Trotzdem abbrechen?",
        title: "Planungsdaten geändert",
      },
    },
    taskType: {
      damageAssessment: "Schadenaufnahme",
      dryingConclusion: "Trocknungsabbau",
      dryingSetup: "Trocknungsaufbau",
      intermediateMeasurement: "Zwischenmessung",
      leakDetection: "Leckortung",
      repair: "Wiederherstellung",
    },
    tasks: {
      confirmedTasks: "Bestätigte Aufgaben",
      filter: {
        all: "Alle",
        filterOff: "Filter aus",
        lastFourWeek: "Letzte 4 Wochen",
        lastWeek: "Letzte Woche",
        startingFromLastWeek: "Ab letzte Woche",
        startingFromToday: "Ab heute",
      },
      formatStartingAt: "ab {0}",
      openTasks: "Termine",
      sortOrder: {
        appointmentDate: "Anfangszeit",
        earliestStartDate: "Dringlichkeit",
        projectNumber: "Projektnummer",
        taskType: "Arbeitsschritt",
        user: "Bearbeiter",
      },
    },
    timeline: {
      formatMinutes: "{0} min",
    },
    timelineControl: {
      formatCalendarWeek: "KW {0}",
      moveBackward: "<",
      moveForward: ">",
    },
    timelineSettings: {
      date: "ab Datum",
      hideWeekends: "Sa+So ausblenden",
      onlyShowWorkingHours: "Nur Arbeitszeit",
      today: "Heute",
      visibleArea: {
        fourWeeks: "4 Wo",
        label: "Anzeige",
        oneDay: "Tag",
        oneWeek: "1 Wo",
        twoWeeks: "2 Wo",
      },
    },
    urgend: "Dringend",
  },
  searchIresDevice: {
    message: "Bitte Seriennummer des Geräts angeben",
    title: "HyDry Gerät suchen",
  },
  selectProjectType: {
    drying: "Trocknung",
    dryingDirectOrder: "Trocknung - Direktauftrag",
    dryingInsuranceCase: "Trocknung - Versicherungsfall",
    flexProject: "FlexAuftrag",
    formatProjectType: "Projekttyp: {0}",
    formatProjectTypes: "Projektart: {0} | Projektarten: {0}",
    leakDetection: "Leckortung",
    leakDetectionDirectOrder: "Leckortung / Direktauftrag",
    leakDetectionInsuranceCase: "Leckortung / Versicherungsfall",
    websiteOnly: "Portal",
  },
  settings: {
    administration: {
      allDevicesSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Dürfen Mitglieder (Niederlassungen) eigene GERÄTEEINSTELLUNGEN verwenden?",
        clients: "Welche Niederlassung(en)?",
        title: "Verteilung Einstellungen ALLE GERÄTE",
      },
      companySettings: {
        allowMemberClientsToDefineOwnSettings:
          "Dürfen Mitglieder (Niederlassungen) eigene \nNIEDERLASSUNGSEINSTELLUNGEN verwenden?",
        clients: "Welche Niederlassung(en)?",
        title: "Verteilung Einstellungen NIEDERLASSUNGEN",
      },
      deviceSettings: {
        title: "Geräteverwaltung",
      },
      hyDryDeviceSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Dürfen Mitglieder (Niederlassungen) eigene \nHyDry GERÄTEEINSTELLUNGEN verwenden?",
        clients: "Welche Niederlassung(en)?",
        title: "Verteilung Einstellungen HYDRY GERÄTE",
      },
      hyDryMessagesSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Dürfen Mitglieder (Niederlassungen) eigenen \nNACHRICHTENEINSTELLUNGEN verwenden?",
        clients: "Welche Niederlassung(en)?",
        title: "Verteilung Einstellungen NACHRICHTEN",
      },
      projectManagementSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Dürfen Mitglieder (Niederlassungen) eigene \nEinstellungen für PROJEKTE verwenden?",
        clients: "Welche Niederlassung(en)?",
        title: "Verteilung Einstellungen PROJEKTE",
      },
      reportSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Dürfen Mitglieder (Niederlassungen) eigenen \nBERICHTSEINSTELLUNGEN verwenden?",
        clients: "Welche Niederlassung(en)?",
        title: "Verteilung Einstellungen BERICHTE",
      },
      roleSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Dürfen Mitglieder (Niederlassungen) eigenen \nROLLENEINSTELLUNGEN verwenden?",
        clients: "Welche Niederlassung(en)?",
        enforcedMessage: "Die Rolleneinstellungen des Hauptmandanten werden automatisch für alle Niederlassungen übernommen. Einzelne Niederlassungen können keine eigenen Rolleneinstellungen definieren.",
        title: "Verteilung Einstellungen ROLLEN",
      },
      userSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Dürfen Mitglieder (Niederlassungen) eigene \nBENUTZEREINSTELLUNGEN verwenden?",
        clients: "Welche Niederlassung(en)?",
        title: "Verteilung Einstellungen BENUTZER",
      },
      sectionTitle: "Verwaltung",
      systemConfiguration: {
        allowMemberClientsToDefineOwnSettings:
          "Dürfen Mitglieder (Niederlassungen) eigene \nSYSTEMKONFIGURATION verwenden?",
        clients: "Welche Niederlassung(en)?",
        title: "Verteilung Einstellungen SYSTEMKONFIGURATION",
      },
    },
    administrator: {
      memberClientDialog: {
        clientShorthand: "Mandantenkürzel",
        createClientErrorMessage: "Fehler beim Erstellen des Member-Mandant",
        createClientSuccessMessage: "Member-Mandant erfolgreich erstellt",
        editClientErrorMessage: "Fehler beim Bearbeiten des Member-Mandant",
        editClientSuccessMessage: "Member-Mandant erfolgreich bearbeitet",
        errors: {
          duplicateClientName: "",
          duplicateEmail: "Die E-Mail-Adresse wird bereits benutzt",
          duplicateIresProjectNumberPrefix:
            "Dieses Mandantenkürzel hat schon ein anderer Mandant",
          emptyClientName: "Bitte gib einen Mandantennamen an",
          emptyEmail: "Bitte gib eine gültige E-Mail-Adresse an",
          emptyIresProjectNumberPrefix:
            "Bitte gib ein Mandantenkürzel aus 4 Zeichen an",
          emptyPassword: "Bitte gib ein Passwort an",
          invalidEmail: "Bitte gib eine gültige E-Mail-Adresse an",
          invalidIresProjectNumberPrefix:
            "Bitte gib ein Mandantenkürzel aus 4 Zeichen an",
          invalidPassword: "Das Passwort muss mindestens {0} Zeichen lang sein",
        },
        titleCreate: "Member Mandant anlegen",
        titleEdit: "Member Mandant bearbeiten",
      },
      memberClientsManagement: {
        title: "Member Mandanten verwalten",
      },
      title: "Master",
    },
    allDevices: {
      projectDevicesSettings: {
        enforceMeterReading: "Zählerstand immer eingeben und prüfen?",
        standardIdentification: "Standard für Identifikation",
        title: "Einstellungen Geräte",
      },
      title: "Alle Geräte",
    },
    allDevicesManagement: {
      title: "Alle Geräte verwalten",
    },
    branches: {
      branchNumber: "StandortId",
      branchSortValue: "Sortiernummer",
      confirmDeleteBranchMessage:
        "Sind Sie sicher, dass Sie diesen Standort unwiderruflich löschen wollen?",
      confirmDeleteBranchMessageAlt:
        "Diesem Standort sind noch 1 Gerät zugeordnet. Diese Geräte verlieren die Standortbindung. Möchten Sie fortfahren? | Diesem Standort sind noch {count} Geräte zugeordnet. Diese Geräte verlieren die Standortbindung. Möchten Sie fortfahren?",
      confirmDeleteBranchTitle: "Standort löschen",
      editTitle: "Standort bearbeiten",
      viewTitle: "Standort",
      errorDuplicateBranchNumber:
        "Diese Nummer ist bereits Standort {0} zugewiesen",
      errorMissingBranchNumber: "Bitte Nummer > 0 angeben",
      fullName: "Langname",
      location: "Ort",
      name: "Kurzname",
      rejectDeleteBranchMessage:
        "Diesem Standort sind noch 1 Gerät zugeordnet. Die Geräte müssen zuerst einem anderen Standort zugeordnet werden. | Diesem Standort sind noch {count} Geräte zugeordnet. Die Geräte müssen zuerst einem anderen Standort zugeordnet werden.",
      title: "Standorte",
      useInReport: "In Bericht",
    },
    buttons: {
      change: "BEARBEITEN",
    },
    changeLogo: "Logo ändern",
    comBoxHumidityUnit: {
      absoluteHumidity: "Absolute Feuchte (g/m3)",
      mixingRatio: "Mischverhältnis (g/kg)",
      relativeHumidity: "Relative Feuchte (%)",
      title: "Standard Einheit Feuchte",
    },
    comBoxes: "HyDry Boxen",
    company: "Welche Niederlassung(en)?",
    companySettings: {
      absoluteHumidity: "Abs. Feuchte (g/m3)",
      addressFormat: {
        availableFields: "Verfügbare Felder",
        commaNotAllowedAtEdge: "Komma darf nicht am Anfang oder am Ende stehen",
        defaultUsed: "Ohne Felder wird das Standardformat verwendet.",
        hint: "Legt fest, in welcher Reihenfolge Adressen geschrieben werden.",
        preview: "Vorschau",
        templateFields: {
          CITY: "Ort",
          COMMA: "Komma",
          COUNTRY: "Land",
          HOUSE_NUMBER: "Hausnummer",
          STREET: "Straße",
          ZIP_CODE: "PLZ",
        },
        title: "Adressformat",
      },
      addressGeocoding: "Adressen geocodieren",
      companyData: "Daten der Niederlassung",
      companyEmailAddress: "E-Mail-Adresse",
      companyIdentifier: "Niederlassungskennung",
      companyName: "Unternehmensname",
      companySettingsTitle: "Einstellungen Niederlassung",
      errorCompanyIdentifier:
        "Ungültige Eingabe. Bitte verwenden Sie nur alphanumerische Zeichen.",
      errorEmailAddress: "Bitte gültige E-Mail-Adresse angeben",
      mixingRatio: "Beladung (g/kg)",
      preferredHumidityUnit: "Bevorzugte Angabe FEUCHTE",
      primaryLanguage: "Primäre Sprache",
      shortName: "Kurzname",
      timezone: "Zeitzone",
      usePrimaryLanguageForReports: "Primärsprache für die Berichte verwenden?",
    },
    currentUser: {
      formatCurrentUser: "Aktueller Benutzer: {0}, Rolle: {1},",
      formatCurrentUserValidationLevel: "Prüfung: {0}",
      setPassword: "Benutzerpasswort ändern",
      showCurrentUserSettings: "Meine Benutzerdaten anzeigen",
      title: "Aktueller Benutzer",
    },
    aiPredictions: {
      title: "ASSIST",
      mode: {
        OFF: "Nein",
        ALL_DRYINGS: "Ja, mit allen Trocknungen",
        ACTIVE_AND_NEW_ONLY: "Ja, nur aktive und neue Trocknungen",
      },
      activationBackfill: {
        started: "ASSIST-Aktivierung gespeichert. Die historische Berechnung wurde gestartet.",
        alreadyRunning: "ASSIST-Aktivierung gespeichert. Die historische Berechnung läuft bereits.",
        noOp: "ASSIST-Aktivierung gespeichert, aber das Backend hat die historische Berechnung nicht gestartet.",
        triggerFailed: "ASSIST-Aktivierung gespeichert, aber die historische Berechnung konnte nicht gestartet werden.",
      },
    },
    billingCatalogs: {
      title: "Leistungslisten verwalten",
      sectionTitle: "Leistungslisten",
      listTitle: "Leistungsverzeichnisse",
      noCatalogs: "Keine Leistungsverzeichnisse vorhanden.",
      syncFromApi: "Von API synchronisieren",
      syncSuccess: "{0} Positionen in {1} Katalogen importiert.",
      syncError: "Fehler beim Synchronisieren der Leistungsverzeichnisse.",
      updateError: "Fehler beim Speichern der Änderung.",
      noPriceClassName: "Ohne Preisklasse",
      columns: {
        catalogName: "Herausgeber",
        tenant: "Preisquelle",
        version: "Version",
        fileName: "Dateiname",
        numberOfEntries: "Einträge",
        branchNumber: "Niederlassung",
        validFrom: "Gültig ab",
        validUntil: "Gültig bis",
        importedAt: "Importiert am",
      },
      detail: {
        title: "Leistungsverzeichnis",
        validityOpenEnded: "offen",
        loading: "Leistungsverzeichnis wird geladen...",
        loadError: "Fehler beim Laden des Leistungsverzeichnisses",
        uncategorized: "Ohne Artikelklasse",
        columns: {
          articleId: "Position",
          headline: "Kurztext",
          text: "Beschreibung",
          unit: "Einheit",
          price: "Preis",
          limit: "Limit",
          qualifier: "Qualifier",
        },
        download: "Herunterladen",
      },
    },
    deviceCheckManagement: {
      title: "Geräte-Check verwalten",
    },
    devices: {
      allowCategoryTemplateCreate:
        "Erstellung neuer Gerätekategorien/Gerätetypen beim CSV-Import zulassen?",
      allowCategoryTemplateUpdate:
        "Aktualisierung von Gerätekategorie/Gerätetyp beim CSV-Import zulassen?",
      allowNewCategory:
        "Hinzufügen neuer Gerätekategorien beim CSV-Import zulassen?",
      allowNewTemplate:
        "Hinzufügen neuer Gerätetypen beim CSV-Import zulassen?",
    },
    dryRuns: "Trocknungen",
    errorInvalidNumber: "Bitte ganze Zahl angeben",
    errorNumberRange: "Bitte ganze Zahl zwischen {0} und {1} angeben",
    exportSettings: {
      allDevices: "Alle Geräte",
      deviceFilter: "Auswahl Gerätestatus",
      devicesSelection: "Auswahl Geräte",
      exportDialog: {
        message:
          "1 Gerät wurde verarbeitet | {count} Geräte wurden verarbeitet",
        title: "Informationen exportieren",
      },
      hyDryDevices: "HyDry Geräte",
      otherDevices: "Andere Geräte",
    },
    hiddenComBoxHumidityUnit: {
      title: "Versteckte Einheit Feuchte",
    },
    hyDryBox: "HyDry Box",
    hyDryDevice: {
      cancel: "ABBRECHEN",
      configurations: "Einstellungen HyDry Geräte",
      configurationsImportExport: "Import konfigurieren",
      date: "Datum",
      deviceError: "1 Gerät enthält Fehler | {count} Geräte enthalten Fehler",
      deviceImportHistory: "Verlauf Import",
      devicesCategorySettings: "Gerätekategorien und Gerätetypen",
      devicesDetected: "1 Gerät erkannt | {count} Geräte erkannt",
      devicesDuplicated: "1 Duplikat gefunden | {count} Duplikate gefunden",
      devicesExport: "Geräte exportieren",
      devicesImport: "Geräte importieren",
      devicesNew: "1 neues Gerät hinzugefügt | {count} neue Geräte hinzugefügt",
      devicesProcessed:
        "1 Gerät wurde verarbeitet | {count} Geräte wurden verarbeitet",
      devicesUpdated:
        "1 vorhandenes Gerät aktualisiert | {count} vorhandene Geräte aktualisiert",
      devicesUpload: "Hochladen von Geräten ...",
      editComBoxClientConfig: "HyDry BOX Mandantenkonfiguration bearbeiten",
      errorMessageCategoryNotFound: "Kategorie nicht gefunden",
      errorMessageCategoryUpdateNotAllowed:
        "Kategorie kann nicht geändert werden",
      errorMessageDeviceAssignedToProject: "Dem Projekt zugewiesenes Gerät",
      errorMessageDeviceDoesNotExist: "Gerät existiert nicht",
      errorMessageBranchNotFound: "Standort existiert nicht",
      errorMessageInvalidDevicePowerUsageType: "Zähler ist ungültig",
      errorMessageInvalidElectricityMeterManufacturer:
        "Zählerhersteller ist ungültig",
      errorMessageInvalidInventoryNumber: "Inventarnummer ist ungültig",
      errorMessageInvalidManufacturer: "Hersteller ist ungültig",
      errorMessageInvalidPowerConsumptionPerHour:
        "Typische Leistung ist ungültig",
      errorMessageInvalidQrCode: "QR-Code ist ungültig",
      errorMessageInventoryNumberAlreadyExists:
        "Inventarnummer existiert bereits (Konflikt: {conflictId})",
      errorMessageInventoryNumberNotUnique:
        "Es wurden mehrere Geräte mit der gleichen Inventarnummer gefunden.",
      errorMessageIresDevice: "Neues IRES-Gerät kann nicht importiert werden",
      errorMessageMissingCategory: "Kategorie fehlt",
      errorMessageMissingCategoryColumn:
        "Die Importdatei enthält keine Spalte für die Gerätekategorie",
      errorMessageMissingInventoryNumber: "Inventarnummer fehlt",
      errorMessageMissingInventoryNumberColumn:
        "Die Importdatei enthält keine Spalte für die Inventarnummer",
      errorMessageMissingSerialNumberColumn:
        "Die Importdatei enthält keine Spalte für die Seriennummer",
      errorMessageMissingTemplate: "Typ fehlt",
      errorMessageMissingTemplateColumn:
        "Die Importdatei enthält keine Spalte für den Gerätetyp",
      errorMessageQrCodeAlreadyExists: "QR-Code existiert bereits (Konflikt: {conflictId})",
      errorMessageSerialNumberNotUnique:
        "Es wurden mehrere Geräte mit der gleichen Seriennummer gefunden.",
      errorMessageTemplateNotFound: "Typ wurde nicht gefunden",
      errorMessageTemplateUpdateNotAllowed:
        "Gerätetyp kann nicht geändert werden",
      errorMessageTryAgain:
        "Ein Fehler ist aufgetreten. Versuchen Sie es erneut mit einer anderen Datei.",
      errorMessageWrongCsvSeparator:
        "Das Dateiformat ist falsch. Bitte befolgen Sie die Anweisungen.",
      errorMessageWrongFormat: "Die Datei muss die Erweiterung .CSV haben",
      errorMessageFileTooLarge: "Die Datei ist zu groß. Maximale Dateigröße: 5 MB.",
      exportDevice: "Geräte exportieren",
      csvHeaders: {
        category: "KATEGORIE",
        type: "TYP",
        inventoryNumber: "INVENTARNUMMER",
        serialNumber: "SERIENNUMMER",
        manufacturer: "HERSTELLER",
        code: "CODE",
        power: "LEISTUNG",
        meter: "ZÄHLER",
        electricityMeterManufacturer: "STROMZÄHLERHERSTELLER",
        electricityMeterNumber: "STROMZÄHLERNUMMER",
        acquisitionDate: "ANSCHAFFUNGSDATUM",
        availability: "VERFÜGBARKEIT",
        location: "STANDORT",
        comment: "KOMMENTAR",
        meterReading: "ZÄHLERSTAND",
        locationName: "STANDORTNAME",
        error: "FEHLER",
      },
      fileName: "Dateiname",
      genericError: "Fehler",
      guide: {
        acquisitionDate: "ANSCHAFFUNGSDATUM",
        availability: "VERFÜGBARKEIT",
        category: "KATEGORIE",
        code: "CODE",
        comment: "KOMMENTAR +",
        counter: "ZÄHLER",
        counterReading: "ZÄHLERSTAND",
        electricityMeterManufacturer: "STROMZÄHLERHERSTELLER",
        electricityMeterNumber: "STROMZÄHLERNUMMER",
        inventoryNumber: "INVENTARNUMMER",
        location: "STANDORT",
        manufacturer: "HERSTELLER",
        power: "LEISTUNG",
        serialNumber: "SERIENNUMMER",
        step1:
          "Der Import erfolgt durch eine CSV Datei mit folgenden Eigenschaften:",
        step2: "Reihenfolge der Felder",
        step3: "Gerätekategorien/Gerätetypen",
        step4:
          "HyDry Geräte können nicht über den Import angelegt oder geändert werden.",
        step5:
          "Jedes Geräte muss entweder eine eindeutige Inventarnummer oder eine eindeutige Seriennummer haben, sonst kann es nicht angelegt werden.",
        step6: "Leere Felder werden nicht aktualisiert.",
        step7: "Formate / Auswahl",
        subStep1a: "Überschriftszeile (wird nicht ausgewertet)",
        subStep1b:
          "Gerätedaten mit Feldern entsprechend der Überschriftszeile.",
        subStep1c: "Feldtrennzeichen Semikolon (;)",
        subStep1d: "Zeichenformat UTF-8",
        subStep3a:
          "Gerätetypen und Gerätekategorien werden nur dann automatisch angelegt oder aktualisiert, wenn dies in KONFIGURATION IMPORT angegeben ist.",
        subStep7a:
          "ZÄHLER: Angabe des Zählertyps als 0=Kein Zähler, 1=Betriebsstunden, 2=Strom, 3=Strom fremd",
        subStep7b:
          "CODE: Barcode, QR-Code oder NFC angeben. Muss eindeutig sein.",
        subStep7c: "ANSCHAFFUNGSDATUM: Angabe im Format TT.MM.JJJJ",
        subStep7d: "VERFÜGBARKEIT: Angabe 0=verfügbar, 1-9=nicht verfügbar",
        title: "Import von Geräten",
        type: "TYP",
      },
      confirmImport: "Import bestätigen",
      import: "importieren",
      importCancelled: "Der Datei-Import wurde abgebrochen",
      importDevices: "Neue Geräte importieren",
      importSuccess: "Die Datei wurde erfolgreich importiert",
      importPreview: "Import-Vorschau",
      previewComplete: "Vorschau abgeschlossen",
      newDevices: "Neue Geräte",
      newImport: "Neue Datei importieren",
      noHistoryData: "--- keine Verlaufsdaten gefunden ---",
      readingFile: "Datei wird gelesen ...",
      reportDownload: "Bericht",
      title: "HyDry Geräte",
      updatedDevices: "Aktualisierte Geräte",
      uploadBoxTest1: "Datei per drag & drop importieren",
      uploadBoxTest2: "oder",
      uploadBoxTest3: "Datei suchen",
      user: "Benutzer",
    },
    hyDryDevices: "HyDry Geräte",
    hyDryDeviceSettings: {
      alwaysShowSerialNumber: "Bei HyDry Geräten immer Seriennummer anzeigen?",
      minRunDurationForAnalysis: "Minimale Run-Länge für Auswertungen",
    },
    ires: {
      enableSpecialRightsForIresClientOrAdmin:
        "Sonderrechte für IRES-Benutzer aktivieren?",
      ignoreIresAdminOrIresClientCheck:
        "Prüfung auf IRES Admin oder IRES Mandant ignorieren?",
      ignoreIresAdminOrIresClientCheckShort:
        "Prüfung auf IRES Admin oder IRES Mandant ignorieren?",
      iresConfiguration: "IRES Einstellungen",
      memberClients: "Member Mandanten",
      title: "IRES",
    },
    logo: "Logo",
    mailbox: {
      confirmDeleteMailboxMessage:
        "Sind Sie sicher, dass Sie dieses Postfach unwiderruflich löschen wollen?",
      confirmDeleteMailboxTitle: "Postfach löschen",
      errorNameAlreadyTaken: "Dieser Name wird bereits verwendet",
      mailbox: "Postfach",
      memberUsers: "Ausgangs-Benutzer",
      name: "Name",
      sortValue: "Sortiernummer",
      targetUsers: "Eingangs-Benutzer",
    },
    mailboxes: "Postfächer verwalten",
    messageSelection: "Nachrichten konfigurieren",
    messages: "Nachrichten",
    minProgramChainDurationInMinLabel: "Minimale Trocknungslänge",
    minProgramChainDurationInMinMessage:
      "Grenze für die Anzeige von Trocknungen für HyDry Geräte (Trocknungen mit geringerer Länge werden ausgeblendet):",
    minProgramChainDurationInMinTitle:
      "Minimale Trocknungslänge für HyDry Geräte",
    minGeneralGapDurationInMinLabel: "Maximale Lücke zum Zusammenfassen",
    minGeneralGapDurationInMinMessage:
      "Aufeinanderfolgende Einträge desselben Projekts und derselben Phase werden zu einem Eintrag zusammengefasst, wenn die Lücke dazwischen höchstens diesen Wert (in Minuten) beträgt:",
    minGeneralGapDurationInMinTitle:
      "Schwelle zum Zusammenfassen gleicher Einträge",
    travelArrivalRadiusLabel: "Ankunftsradius (m)",
    travelArrivalRadiusTitle: "Ankunftsradius für Fahrten",
    travelArrivalRadiusMessage:
      "Ab welcher Entfernung zum Ziel eine Fahrt als unterbrochen und nicht als angekommen gilt. " +
      "Luftlinie, in Metern. Gilt für alle deiner Mitarbeiter.",
    permissions: {
      assignProjectToOthers: "D2 Projekt anderen zuordnen",
      basicLicence: "B1 Basislizenz Projekte",
      cancel: "ABBRECHEN",
      clientAdministration: "M1 Mitgliederverwaltung",
      createProject: "C2 Neues Projekt anlegen",
      damageAssessmentLarge: "F2 Macht Schadenaufnahme",
      defineDeviceCategories: "E1 Gerätekategorien definieren",
      deleteProject: "C3 Projekte löschen",
      deviceAdministration: "M2 Geräteverwaltung",
      drying: "F3 Macht Trocknung",
      dryingAndRecording: "B3 Lizenz Trocknung",
      editAdmin: "A1 Admin verwalten",
      editDevices: "E3 Geräte verwalten",
      editProjects: "C5 Projekte bearbeiten",
      editUser: "A2 Benutzer verwalten",
      editValidation: "A3 Eigenes Prüflevel ändern",
      haveVehicle: "F5 Hat Fahrzeug",
      importDevicesCategories: "E2 Geräte importieren",
      leakDetection: "F1 Macht Leckortung",
      manageProduction: "P2 Produktion verwalten",
      manageClients: "P3 Mandanten verwalten",
      office: "B4 Macht Office",
      permissions: "Berechtigungen",
      projectManagement: "B5 Macht Projektmanagement",
      projectsSuperVision: "D3 Macht Projektleitung",
      rateDryings: "P1 Trocknungen bewerten",
      recording: "B2 Lizenz Aufnahme",
      reopenCompletedPhases: "C4 Projekte wieder öffnen",
      repair: "F4 Macht Wiederherstelllung",
      return: "ZURÜCK",
      save: "Speichern",
      saveEdit: "ÄNDERUNGEN SICHERN",
      saveEditsSuccessfull: "Änderungen erfolgreich gespeichert",
      seeAllProjects: "C1 Alle Projekte sehen",
      seeAllSettings: "A4 Konfiguration verwalten",
      selfAssignProjects: "D1 Projekte selbst zuordnen",
      settingsAdministration: "M3 Allgemeine Einstellungen",
    },
    permissiontManagement: {
      title: "Rollen verwalten",
    },
    projectManagement: {
      archivedProjects: {
        title: "Alte Projekte ansehen",
      },
      deviceManagerSettings: {
        canUserAddContactPersons: "Benutzer darf Wohnungen ergänzen",
        canUserAddDevices: "Benutzer darf Geräte ergänzen",
        canUserAddProjects: "Benutzer darf Projekte ergänzen",
        canUserAddRooms: "Benutzer darf Räume ergänzen",
        recentlyCompletedTask: "Abgeschlossene Arbeiten anzeigen (Tage)",
        title: "Einstellungen IRES Work",
        validation: {
          maxValue: "Der Wert darf maximal {max} betragen.",
          minValue: "Der Wert muss mindestens {min} betragen.",
        },
      },
      projectEditingSettings: {
        defaultDryingDuration: "Vorbelegung Trocknungsdauer (Tage)",
        defaultFollowUpInspectionInterval:
          "Wiedervorlage immer nach 1 Tag | Wiedervorlage immer nach {count} Tagen",
        projectDuration: "Vorbelegung Projektlaufzeiten",
        title: "Einstellungen Projektbearbeitung",
        automaticProjectNames: "Automatische Projektnamen",
        deviceAssignment: "Gerätezuordnung",
        roomLevelDeviceAssignment: "Gerätezuordnung auf Raumebene",
        projectOverviewTilesForOfficeProjects: "Kacheln für Gerätezuordnung",
        templateFields: {
          PROJECT_NUMBER: "Projektnummer",
          ZIP_CODE: "PLZ",
          CITY: "Ort",
          STREET: "Straße",
          HOUSE_NUMBER: "Hausnummer",
          NAME: "Name",
          COMMA: "Komma",
        },
        resetToAuto: "Auf automatisch zurücksetzen",
        availableFields: "Verfügbare Felder",
        commaNotAllowedAtEdge: "Komma darf nicht am Anfang oder Ende stehen.",
        preview: "Vorschau",
      },
      projectManagerSettings: {
        actionButtons: {
          apartmentAttendees: "K3 Wohnung: ANWESENDE",
          options: {
            hide: "Verbergen",
            hideAlt: "Nicht vorschlagen",
            red: "Rot",
            yellow: "Gelb",
          },
          leakDetectionSketchAndMeasurementPoints:
            "K2 Leckortung: Skizzen+Messpunkte",
          pipeSystem: "K2 Leckortung: LEITUNGSSYSTEM",
          projectAttendees: "K2 Projekt: ANWESENDE",
          projectCause: "K2 Projekt: ANLASS",
          title: "Action Buttons",
          tradeRenovation: "K3 Leckortung: GEWERKE SANIERUNG",
        },
        damageAssessment: {
          enforceFullDamageAssessment: "Immer VOLLSTÄNDIGE SCHADENAUFNAHME?",
          title: "Schadenaufnahme",
        },
        measurementPoints: {
          canAddMeasurementPointsInApartment: "Messpunkte in WOHNUNG zulassen?",
          preferAbsHumidity: "Feuchte bevorzugt als ABS. FEUCHTE angeben?",
          roomClimateMeasuringPoints: "Messpunkt RAUMKLIMA",
          measurementPointPresetPhase: "Vorbelegung in LECKORTUNG",
          measurementPointPresetPhaseOptions: {
            leakDetection: "Leckortung",
            drying: "Trocknung",
          },
          title: "Messpunkte",
        },
        photo: {
          hintPhotoQuality: "Qualitätshinweis vor Fotos",
          title: "Bilder",
        },
        projectPhases: {
          dryingSetupEnquiry: "Rückfrage bei Trocknungsaufbau?",
          enforceFullDamageAssessment: "Immer VOLLSTÄNDIGE SCHADENAUFNAHME?",
          title: "Projektphasen",
        },
        sketch: {
          errorPresetRoomHeight: "Werte müssen zwischen 0 und 500 liegen.",
          errorPresetWallThickness: "Werte müssen zwischen 0 und 99 liegen.",
          presetInnerWallThickness: "Innenwand",
          presetOuterWallThickness: "Außenwand",
          presetPartyWallThickness: "Kommunwand",
          presetRoomHeight: "Vorbelegung Raumhöhe (cm) (0 = keine)",
          presetWallThickness: "Vorbelegung Wanddicke (cm) (0 = keine)",
          sketchInRooms: "K3 Skizze in Räumen",
          title: "Skizze",
        },
        title: "Einstellungen IRES Project",
        trades: {
          quantitySurveyInReport: "Aufmaß im Bericht",
          tableAutomaticallyInReport: "Tabelle automatisch im Bericht",
          tableSorting: {
            options: {
              apartmentPhase: "Wohnung, Phase",
              apartmentTrade: "Wohnung, Gewerk",
              phaseTrade: "Phase, Gewerk",
              roomPhase: "Raum, Phase",
              roomTrade: "Raum, Gewerk",
              tradePhase: "Gewerk, Phase",
            },
            title: "Sortierung Tabelle",
          },
          title: "Leistungserbringer Gewerke",
        },
        serviceList: {
          title: "Leistungsliste",
          presetFlexibleServiceList: "Vorbelegung Leistungsliste flexibel",
        },
      },
      projectSettings: {
        editProjectsIn: "PROJEKTDATEN ÄNDERN ausführen?",
        finaliseProjectsIn: "PROJEKTABSCHLUSS ausführen?",
        newAppointmentsIn: "NEUE TERMINE ausführen?",
        newProjectsIn: "NEUE PROJEKTE ausführen?",
        projectTypesConfiguration: {
          active: "Aktiv",
          label: "Label",
          phases: "Phasen",
          platforms: "Platformen",
          title: "Mögliche Projekttypen",
          type: "Typ",
          validation: {
            atLeastOneActive: "Bitte aktiviere mindestens einen Projekttyp",
            labelDuplicate:
              "Die Bezeichnung ist bereits vergeben. Bitte wähle eine eindeutige Bezeichnung",
            typeBadgeDuplicate:
              "Der Typ-Code ist bereits vergeben. Bitte wähle einen eindeutigen Code",
            typeBadgeInvalid:
              "Der Typ-Code ist ungültig. Erlaubt sind nur 1–2 alphanumerische Zeichen (A–Z, 0–9)",
          },
        },
        title: "Einstellungen Projekte",
      },
      title: "Projekte",
    },
    report: {
      dataProtection: {
        contactDataInExternalReports: "Kontaktdaten in externen Berichten",
        title: "Datenschutz",
      },
      emailInboxes: {
        damageReportEmailAddress: "E-Mail für Schadenberichte",
        dryingReportEmailAddress: "E-Mail für Trocknungsberichte",
        leakDetectionReportEmailAddress: "E-Mail für Leckortungsberichte",
        title: "E-Mail Postfächer",
      },
      errorEmailAddress: "Bitte gültige E-Mail-Adresse angeben",
      equipmentUsage: {
        includeGenericDeviceAssignments: "Geräte in Bericht aufnehmen",
        createCertificate: "Zertifikat erstellen",
        title: "Geräteeinsatz",
      },
      images: {
        contentOrder: "Reihenfolge der Blöcke in Berichten",
        contentOrderOptions: {
          sketchImagesText: "Skizzen / Bilder / Text",
          sketchTextImages: "Skizzen / Text / Bilder",
          textSketchImages: "Text / Skizzen / Bilder",
        },
        imageForMeasurementPoints: "Bilder für Messpunkte",
        imageQuality: "Voreinstellung Bildqualität",
        imageQualityHigh: "Hoch",
        imageQualityLow: "Niedrig",
        imageQualityNormal: "Mittel",
        imageReportAfterDamageAssessment:
          "Bildbericht nach Schadenaufnahme erstellen",
        imageReportAfterDamageAssessmentOptions: {
          no: "Keine Bildberichte",
          selectionAsExternalReport: "Auswahl wie externer Bericht",
          selectionAsInternalReport: "Auswahl wie interner Bericht",
        },
        imagesPerRow: "Bilder pro Zeile",
        showDamagePatternInfoInLeakDetectionReport: "Schadenbild im Leckortungsbericht anzeigen",
        showReportConfigInProject: "Bildkonfiguration nachfragen",
        title: "Bilder in Berichten",
      },
      json: {
        title: "Berichte als JSON",
        sendReportAsJson: "Berichte als JSON erzeugen und verteilen",
      },
      logo: {
        dropHint: "Logo hierher ziehen oder klicken",
        expandPreview: "Vorschau vergrößern",
        hint: "Akzeptierte Formate: JPEG und PNG",
        noLogo: "Kein Logo",
        removeLogo: "Logo entfernen",
        uploadLogo: "Logo hochladen",
        scalingFactor: "Skalierung Logo (%)",
        selectFile: "Datei auswählen",
        title: "Logo",
      },
      outgoingReports: {
        reportsList: "Berichte als Liste",
        reportsListOptions: {
          individualPdfDocuments: "PDF-Dokumente einzeln",
          separatePdfAndTimeEntries: "PDF und Zeiteinträge einzeln",
          summarizedReportsOnly: "Nur zusammengefasste Berichte",
        },
        saveReport: "in Verzeichnis",
        sendAsEmail: "als E-Mail schicken",
        sendOutgoingReportsAsOptions: {
          iresCloud: "Ja, über IRES Cloud",
          localEmail: "Ja, über lokale E-Mail",
        },
        title: "Ausgehende Berichte",
      },
      projectDataExchange: {
        options: {
          csv: "CSV",
          json: "JSON",
          no: "Nein"
        },
        projectDataExchangeAs: "PDE erzeugen und verteilen als",
        title: "Projektdaten austauschen?",
      },
      reportEmailAddress: "E-Mail-Adresse für Berichte",
      reportSettings: "Einstellungen Berichte",
      timeEntriesOnNewPage: "Zeiteinträge auf neuer Seite?",
      timeTracking: {
        companyAddressInTimeRecord: "Firmenadresse in Zeitaufschrieb?",
        phaseInTimeRecord: "Projektphase",
        workTimeInTimeRecord: "Arbeitszeit in Zeitaufschrieb",
      },
      individualReports: {
        title: "Einzelberichte",
        documentsInReports: "PDF-Dokumente",
        timeEntriesInReports: "Zeiteinträge",
        reportInclusionOptions: {
          internalReport: "im internen Bericht",
          externalReport: "im externen Bericht",
          separateReport: "als Einzelbericht",
          separateReportTotal: "als Einzelbericht (gesamt)",
          separateReportIndividual: "als Einzelbericht (einzeln)",
        },
        measurementProtocolAsSeparateReport: "Messprotokoll als separater Bericht",
        measurementProtocolAsSeparateReportOptions: {
          no: "Nein",
          yes: "Ja",
        },
        imageReportAfterDamageAssessment: "Bildberichte und Bildauswahl",
      },
      footer: {
        title: "Fußzeile",
        footerText: "Text in Fußzeile",
        footerTextOptions: {
          appVersion: "App-Version",
          company: "Unternehmen",
          location: "Standort",
        },
        projectInfo: "Projektinfo in Fußzeile",
        projectInfoOptions: {
          projectId: "Projektnummer",
          collectionNumber: "Sammelnummer",
          projectIdAndCollectionNumber: "Projektnummer / Sammelnummer",
        },
        showTotalPageCount: "Gesamtseitenzahl anzeigen (7 von 13)",
      },
      title: "Berichte",
    },
    roleManagement: {
      cancelMessage:
        "Sie haben bereits Änderungen getätigt. Möchten Sie diese Änderungen verwerfen?",
      cancelTitle: "Änderungen verwerfen?",
      capabilityOption: {
        conditional: "Eventuell",
        no: "Nein",
        yes: "Ja",
      },
      edit: "Rollen konfigurieren",
      editRole: "Rolle bearbeiten",
      error: {
        activeUserForRole: "Es gibt noch aktive User mit dieser Rolle",
        wrongLabel: "Bitte gültige Rollenbezeichnung eingeben",
      },
      roles: {
        description: "Beschreibung",
        label: "Name",
        roleActive: "Status",
        roleId: "lfd Nr.",
        users: "# Nutzer",
      },
      memberClientHint: "Hinweis: Die Rollen-Konfiguration kann im MASTER geändert werden.",
      title: "Rollen verwalten",
      titleAlt: "Rollen anzeigen",
      viewRolesConfiguration: "Rollen-Konfiguration anzeigen",
    },
    scheduling: {
      control: {
        acceptableDelayInMin: "Verspätung",
        title: "Steuerung",
      },
      defaultBreakDurations: {
        lunchBreak: "Mittagspause",
        maxTimeWithoutBreak: "Zeit bis Pause",
        title: "Pausen",
      },
      defaultTaskDurations: "Vorbelegung Arbeitsdauer",
      objectiveFunctionParameters: {
        title: "Zielfunktion",
        weights: {
          dailyWorkTimeExceedance: "Gewichtung Arbeitszeitüberschreitung/Tag",
          targetDate: "Gewichtung Zieldatum",
          targetDateFixed: "Gewichtung Zieldatum Fix",
          targetQualification: "Gewichtung Zielqualifikation",
          targetTime: "Gewichtung Zielzeit ",
          targetTimeFixed: "Gewichtung Zielzeit fix",
          targetUser: "Gewichtung Zielbearbeiter",
          timeGap: "Gewichtung Zeitlücke",
          total: "Skalierung gesamt",
          travelTime: "Gewichtung Fahrzeit",
          weeklyWorkTimeExceedance:
            "Gewichtung Arbeitszeitüberschreitung/Woche",
        },
      },
      occupiedTimeUsage: {
        breakUsage: "Pause",
        none: "aus",
        plan: "einplanen",
        show: "anzeigen",
        travelTimeUsage: "Fahrzeiten",
      },
      planningBoard: {
        formatColor: "Farbe {0}",
        taskColors: "Farben",
        title: "Darstellung Einsatzplanung",
        visibleArea: {
          fourWeeks: "4 Wochen",
          from: "Anzeige von",
          oneDay: "1 Tag",
          oneWeek: "1 Woche",
          title: "Sichtbarer Bereich",
          twoWeeks: "2 Wochen",
          until: "Anzeige bis",
        },
        visibleRange: {
          title: "Anzeigezeitraum",
        },
      },
      section: {
        geocodingAndTravelTimes: "Geocodierung und Fahrzeiten",
        planningBoard: "Darstellung Einsatzplanung",
        planningControl: "Konfiguration der Planung",
      },
      title: "Einsatzplanung",
      travelTimeAndPauses: "Fahrzeiten und Pausen",
      travelTimeSettings: {
        betweenTaskAndDepot: "Vorbelegung Anfahrt",
        betweenTasks: "Vorbelegung Verbindungsfahrt",
        title: "Geocodierung und Fahrzeiten",
        travelTimeBuffer: "Zeitzuschlag",
        travelTimeCalculationViaMap: "Fahrzeit über Karte",
      },
      workingHours: {
        defaultWorkDayEnd: "Arbeitszeit Ende",
        defaultWorkDayStart: "Arbeitszeit Beginn",
        defaultWorkingHoursPerDay: "Arbeitszeit/Tag",
        defaultWorkingHoursPerWeek: "Arbeitszeit/Woche",
        earliestWorkDayStart: "Frühester Beginn",
        latestWorkDayEnd: "Spätestes Ende",
        lunchBreakAfter: "Pause planen nach",
        longBreakDuration: "Dauer verlängerte Pause",
        longBreakThresholdHours: "Arbeitsstunden über",
        maxWorkingHoursPerDay: "Max. Arbeitszeit/Tag",
        maxWorkingHoursPerWeek: "Max. Arbeitszeit pro Woche",
        minBreakDuration: "Min. Pausenlänge",
        shortBreakDuration: "Dauer normale Pause",
        shortBreakThresholdHours: "Arbeitsstunden über",
        title: "Arbeitszeiten und Pausen",
      },
    },
    sharedEmailAddress: {
      changePasswordHint:
        "Bitte neues Kennwort zum Teilen der E-Mail-Adresse angeben",
      changePasswordHintOld:
        "Bitte neues Passwort zum Teilen der E-Mail-Adresse angeben",
      title: "Kennwort zum Teilen der E-Mail-Adresse",
      titleOld: "E-Mail-Adresse teilen",
    },
    sharedEmailAddressOptions: {
      title: "Bearbeiten geteilte E-Mail-Adresse",
    },
    showDeviceManagementInCockpit: {
      title: "Geräteverwaltung im Cockpit anzeigen",
    },
    system: {
      clientEmailAndPassword: "Datenbank Mailadresse und Passwort",
      dataStorage: "Datenspeicherung konfigurieren",
      dataStorageDatabase: "Datenspeicherung Datenbank",
      dataStorageTablet: "Datenspeicherung Tablet",
      finishedProjects: {
        title: "Projekte archivieren",
        currentProjectsNotTouched: "Nicht mehr verfolgte Projekte verschieben?",
        deleteProjectsNotProcessed:
          "Projekt in K1, keine Aktion:\nProjekt löschen?",
        moveFinishedProjects: "FERTIGE PROJEKTE in ALTE PROJEKTE verschieben?",
        moveProjectsClosed:
          "Projekt in K8 abgeschlossen, nicht fertig:\nProjekt verschieben?",
        moveProjectsDamagePatternClosed:
          "Projekt in K4 abgeschlossen, nicht fertig:\nProjekt verschieben?",
        moveProjectsOnHold:
          "Projekt in K4 wartet auf Versicherung. Projekt verschieben?",
        numberOfDays: {
          never: "Nie",
          one: "1 Tag",
          two: "2 Tage",
          three: "3 Tage",
          four: "4 Tage",
        },
        numberOfMonths: {
          never: "Nie",
          three: "3 Monate",
          six: "6 Monate",
          nine: "9 Monate",
          twelve: "12 Monate",
          twentyFour: "24 Monate",
        },
        numberOfWeeks: {
          never: "Nie",
          one: "1 Woche",
          two: "2 Wochen",
          four: "4 Wochen",
          eight: "8 Wochen",
          twelve: "12 Wochen",
        },
        recentlyFinishedProjects:
          "Kürzlich fertiggestellte Projekte bei AKTUELLE PROJEKTE anzeigen?",
      },
      geoEncoding: "Karte",
      tracking: "Tracking",
      moveDevicesDialog: {
        message:
          "Alle Geräte werden in das Lager zurückgeführt, aus dem sie ursprünglich geladen wurden. Möchtest du fortfahren?",
        title: "Geräte zurückführen?",
      },
      operationalPlaning: "Einsatzplanung",
      mira: {
        title: "Mira",
        mode: {
          OFF: "Nein",
          IRES_ONLY: "Nur IRES",
          ON: "Ja",
        },
      },
      systemConfiguration: "Systemkonfiguration",
      chat: {
        title: "Chat / Messenger aktivieren?",
        mode: {
          NONE: "Nein",
          PERSONAL_ONLY: "Nur persönlicher Chat",
          PROJECT_ONLY: "Nur Projekt-Chat",
          BOTH: "Beide Chats",
        },
      },
      title: "System",
    },
    timeTracking: {
      configuration: "Konfiguration Zeiterfassung",
      createDailyTracking: "Tagesabschluss erstellen",
      dailyTracking: "Tagesabschluss",
      isStartEndMandatory: "Anfang und Ende verpflichtend",
      sectionTitle: "Erfassung Arbeitszeit",
      sendDailyTracking: "Tagesabschluss senden",
      specifyStartEnd: "Anfang und Ende angeben",
      title: "Zeiterfassung",
      workingHours: "Arbeitszeiten und Pausen",
    },
    upload: "Hochladen",
    userManagement: "Benutzer",
    userSettings: {
      alwaysUseManagerAsSupervisor:
        "Manager immer als Projektleiter übernehmen",
      cockpitActiveForAllUsers: "Cockpit anzeigen für alle Benutzer?",
      keepProjectOwner: "Bearbeiter beibehalten",
      strictBranchFilters: "Standortbindung",
      title: "Einstellungen Benutzer",
    },
    users: "Benutzer verwalten",
    vehicleManagement: {
      createVehicle: "Fahrzeug erstellen",
      deleteVehicle: "Fahrzeug löschen",
      deleteVehicleMessage:
        "Sind Sie sicher, dass Sie das Fahrzeug {0} löschen wollen?",
      editVehicle: "Fahrzeug bearbeiten",
      errorDuplicateLicencePlate: "Kennzeichen bereits vergeben",
      errorDuplicateVehicleId: "Fahrzeug-ID bereits vorhanden",
      errorMissingLicencePlate: "Kennzeichen darf nicht leer sein",
      errorMissingVehicleId: "Fahrzeug-ID darf nicht leer sein",
      licencePlate: "Kennzeichen",
      location: "Standort",
      size: "Größe",
      sortNumber: "SortierNr.",
      title: "Fahrzeuge verwalten",
      user: "Benutzer",
      vehicleId: "Fahrzeug ID",
    },
  },
  sharedEmailAddressForm: {
    changeHomeClientButton: "Neuen Heimat-Mandant setzen",
    changeHomeClientTitle: "Neuen Heimat-Mandant setzen",
    changePasswordButton: "Neues Kennwort für geteilte E-Mail-Adresse vergeben",
    changePasswordTitle: "Kennwort zum Teilen der E-Mail-Adresse",
    confirmChangeHomeClient: "Heimat-Mandant ändern zu {0}?",
    confirmChangeHomeClientTitle: "Sind Sie sicher?",
    quitSharingButton: "Teilen der E-Mail-Adresse für diesen Mandant beenden",
    quitSharingTitle: "Bitte neue E-Mail-Adresse angeben",
  },
  sharedEmailAddressOptionsDialog: {
    message:
      "Mehrfachanmeldung für HyDry Portal. Bitte wählen Sie den gewünschten Mandanten aus.",
    title: "Mehrfachanmeldung für HyDry Portal",
    titleForSwitchingSharedUser: "Geteilten Benutzer auswählen",
  },
  sharedUserOfGroup: {
    clientOptionsDialog: {
      message:
        "Mehrfachanmeldung für HyDry Portal. Bitte wählen Sie den gewünschten Mandanten aus.",
      title: "Mehrfachanmeldung für HyDry Portal",
      titleForSwitchingClient: "Mandant auswählen",
    },
  },
  userPicker: {
    noMatchingUsers: "Keine passenden Benutzer gefunden.",
    noUsers: "Es sind keine weiteren Benutzer verfügbar.",
    selectUser: "Benutzer auswählen",
  },
  users: {
    activateCockpit: "Cockpit aktivieren in App",
    activeFilters: "--- Aktive Filter: {0} ---",
    allRoles: "Alle Rollen",
    admin: "Admin",
    createUser: "Benutzer erstellen",
    deleteSharedEmailAddressDialog: {
      message: "Der geteilte E-Mail-Zugang wird entfernt. Sind Sie sicher?",
      title: "Geteilten E-Mail-Zugang entfernen",
    },
    deleteUser: "Löschen",
    deleteUserMessage:
      "Sind Sie sicher, dass Sie den Benutzer {0} löschen wollen?",
    editUser: "Benutzer bearbeiten",
    emailAddress: "E-Mail-Adresse",
    error: {
      notAllowedToChangeRole: "Nur ein SysAdmin dieses Mandanten darf Rollen ändern oder Benutzer anlegen.",
      saveFailed: "Der Benutzer konnte nicht gespeichert werden. Bitte versuche es noch einmal.",
      emailAlreadyUsed: "Die E-Mail-Adresse wird bereits verwendet",
      missingEmailAddress: "Bitte E-Mail-Adresse angeben",
      missingNickname: "Bitte Kurznamen angeben",
      missingRole: "Bitte Rolle angeben",
      missingValidationLevel: "Bitte Wert für die formale Prüfung angeben",
      missingStaffNumber: "Bitte Personalnummer angeben",
      invalidSupervisor: "Der ausgewählte Manager muss die Fähigkeit Projektleitung haben",
      nicknameAlreadyTaken: "Kurzname ist bereits vergeben",
      passwordToShort: "Das Passwort muss aus mindestens 8 Zeichen bestehen.",
      staffNumberAlreadyTaken: "Personalnummer ist bereits vergeben",
      invalidField: {
        nickname: "Ungültiger Kurzname (1–100 Zeichen)",
        email: "Ungültige E-Mail-Adresse",
        role: "Ungültige Rolle",
        staffNumber: "Ungültige Personalnummer (max. 50 Zeichen)",
        generic: "Ungültige Eingabe – bitte Felder prüfen",
      },
    },
    firstName: "Vorname",
    homeClient: "Home Mandant",
    language: "Sprache",
    lastEdit: "Letzte Aktualisierung: {0} {1}",
    lastName: "Nachname",
    licences: "Lizenzen",
    lock: "sperren",
    lockUser: "Benutzer sperren",
    lockUserMessage:
      "Sind Sie sicher, dass Sie den Benutzer {0} {1} sperren wollen?",
    mobilePhone: "Mobil",
    nickname: "Kurzname",
    noUsersFound: "--- keine Benutzer gefunden ---",
    passwordHint:
      "Hinweis/Für die Erstanmeldung wird als Passwort die Personalnummer verlangt",
    postalCode: "Postleitzahl",
    resetUserPassword: "Passwort zurücksetzen",
    resetUserPasswordMsg:
      "Bitte temporäres Passwort für diesen Benutzer {0} {1} angeben",
    role: {
      admin: "Admin",
      customRole1: "Benutzerdefinierte Rolle 1",
      customRole2: "Benutzerdefinierte Rolle 2",
      customRole3: "Benutzerdefinierte Rolle 3",
      customRole4: "Benutzerdefinierte Rolle 4",
      customRole5: "Gerätemanager",
      editRole: "Rolle bearbeiten",
      isActive: "Rolle aktiv",
      label: "Rollenbezeichnung",
      leakDetection: "Leckortung",
      na: "",
      notSpecified: "",
      office: "Office",
      projectManager: "Projektmanager",
      sysAdmin: "SysAdmin",
      technicanAndLeakDetection: "Techniker + Leckortung",
      technician1: "Techniker 1",
      technician2: "Techniker 2",
    },
    staffNumber: "Personalnummer",
    stationaryPhone: "Telefon Festnetz",
    supervisor: "Manager",
    temporaryPassword: "Temporäres Passwort",
    unlock: "entsperren",
    unlockUser: "Benutzer entsperren",
    unlockUserMessage:
      "Sind Sie sicher, dass Sie den Benutzer {0} {1} entsperren wollen?",
    userAddressHousenumber: "Hausnummer",
    userAddressStreet: "Straße",
    userCountry: "Land",
    userData: "Benutzerdaten",
    userLocation: "Ort",
    userRole: "Rolle",
    userValidationLevel: "Prüfung",
    usesTablet: "Tabletnutzung",
    validationLevel: {
      low: "niedrig",
      normal: "normal",
      strict: "streng",
    },
    vehicle: "Fahrzeug",
    vehicleAtHome: "Fahrzeug zuhause",
  },
  vehicles: {
    allocatedUser: "Benutzer",
    branch: "Standort",
    devices: {
      concludeLoading: "ins Fahrzeug Laden",
      concludeUnloading: "in Lager {0} Entladen",
      currentWarehouse: "Aktuelles Lager:",
      deviceMoveInfo: "{0} von {1}",
      load: "Fahrzeug Beladen",
      loadFailureMessage:
        "Es gab einen Fehler beim Laden von Geräten in das Fahrzeug {0}",
      loadSuccessMessage:
        "1 Gerät erfolgreich in das Fahrzeug geladen {0} | {count} Geräte erfolgreich in das Fahrzeug geladen {0}",
      locationUpdateFailureMessage:
        "Aktualisierung des Standorts von 1 Gerät fehlgeschlagen | Aktualisierung des Standorts von {count} Geräte fehlgeschlagen",
      locationUpdateSuccessMessage:
        "Standort von 1 Gerät erfolgreich aktualisiert | Standort von {count} Geräte erfolgreich aktualisiert",
      emptyDevicesHint: "Keine Geräte gefunden.",
      noMatchingDevicesFound: "Keine passenden Geräte gefunden",
      numberOfAvailableDevices: "1 Gerät verfügbar | {count} Geräte verfügbar",
      numberOfSelectedDevices: "Auswahl Gerät: 1 | Auswahl Geräte: {count}",
      overview: "Geräte in Fahrzeug",
      title: "Geräte in Fahrzeug {0}",
      unload: "Fahrzeug Entladen",
      unloadFailureMessage:
        "Es gab einen Fehler beim Entladen von Geräten in das Lager {0}",
      unloadSuccessMessage:
        "1 Gerät erfolgreich ins Lager entladen {0} | {count} Geräte erfolgreich ins Lager entladen {0}",
      crossWarehouseUnloadTitle: "Anderer Heimatstandort",
      crossWarehouseUnloadMessage: "Einige Geräte gehören nicht zu diesem Lager. Möchten Sie sie trotzdem hier entladen?",
    },
    licencePlate: "Kennzeichen",
    numberOfDevices: "Geräte im Fahrzeug",
    vehicleId: "Fahrzeug ID",
  },
  quality: {
    title: "RENO Tagesauswertung",
    chainTitle: "RENO Tagesauswertung: Kette {0}",
    tabs: {
      daily: "Tagesauswertung",
      manual: "Manuelle Auswertung",
    },
    windows: {
      all: "Alle",
      days: "{0} Tage",
      selectWindows: "Zeitfenster auswählen",
    },
    modelVersion: {
      label: "Modellversion",
    },
    trafficLight: {
      title: "Bewertung",
      good: "Gut",
      needsReview: "Prüfen",
      critical: "Kritisch",
      unknown: "Unbekannt",
    },
    status: {
      probablyDry: "Wahrscheinlich trocken",
      probablyStationary: "Wahrscheinlich stationär",
    },
    binary: {
      title: "Binäre Auswahl",
      abnormal: "Anormal",
      normal: "Normal",
    },
    groupA: {
      title: "Hauptlabels",
      normal: "Normal",
      powerOutages: "Stromausfälle",
      newMoistureIngress: "Neuer Feuchteeintrag",
      slowDrying: "Langsame Trocknung",
      unfavorableAmbientConditions: "Umgebungsbedingung ungünstig",
    },
    groupD: {
      title: "Ursache langsame Trocknung",
      peripheralMoisture: "Feuchte in Peripherie",
      withoutFoil: "Ohne Folie",
      ambientConditions: "Umgebungsbedingungen",
      lowAirflow: "Strömung gering",
    },
    labels: {
      title: "Labels Mehrfachauswahl",
      subGroupA: "Trocknungsprobleme",
      subGroupB: "Gerät / Meta",
      powerFailure: "Stromausfälle schlecht für Trocknung",
      newMoisture: "Neuer Feuchteeintrag",
      slowDrying: "Langsame Trocknung",
      unfavorableConditions: "Tu schlecht",
      ambientHumidityBad: "Fu schlecht",
      lowInitialMoisture: "Geringe initiale Feuchte",
      relayDefect: "Relais defekt",
      notForTraining: "Nicht für Training verwenden",
      clearClass: "Eindeutige Klasse",
    },
    actions: {
      saveCorrections: "Korrekturen speichern",
      manualCalculation: "Manuelle Berechnung",
      calculate: "Berechnen",
      cancel: "Abbrechen",
      rerun: "Neu berechnen",
    },
    messages: {
      correctionSaved: "Korrektur erfolgreich gespeichert",
      correctionError: "Fehler beim Speichern der Korrektur",
      predictionLoading: "RENO-Bewertung wird berechnet...",
      predictionComplete: "Vorhersage abgeschlossen",
      predictionError: "Fehler bei der Vorhersage",
      featureNotActivated: "Vorhersagen sind für diesen Mandanten nicht aktiviert.",
      latestModelOnlyRecalculation: "Eine Neuberechnung ist nur mit der neuesten Modellversion verfügbar.",
      backfillComplete: "Alle Tagesauswertungen wurden mit dem neuen Modell neu berechnet.",
      manualCalculationHint: "Die Berechnung wird mit dem aktuellen RENO-Modell über den gesamten Trocknungszeitraum durchgeführt.",
      noData: "Keine RENO-Daten verfügbar",
      noDailyData: "Keine Tagesauswertung verfügbar",
      noDaySelected: "Bitte einen Tag in der Zeitreihe auswählen.",
      noManualData: "Keine manuelle Auswertung verfügbar",
      programNotSupported: "RENO wird für diese Programmnummer nicht unterstützt.",
      newerModelAvailable: "Neueres Modell verfügbar ({0}). Ergebnis kann mit der neuen Version neu berechnet werden.",
      correctedBadge: "Korrigiert",
      correctedAt: "Korrigiert am {0}",
      correctedBy: "Korrigiert von {0}",
    },
    trend: {
      title: "Trend",
      days: "Letzte {0} Tage",
    },
    timeSeries: {
      title: "RENO Zeitreihe",
      qualityLabel: "Qualität",
      noData: "Keine Zeitreihendaten verfügbar",
      generateHistory: "Historie erzeugen",
      backfillProgress: "{0} von {1} Tagen berechnet",
      targets: {
        dry: "Trocken",
        stationary: "Stationär",
        newMoistureIngress: "Neue Feuchte",
        slowDrying: "Langsam",
        powerOutage: "Stromausfälle",
        relayDefect: "Relais",
        unfavorableAmbient: "Klima",
        lowAirflow: "Strömung",
        peripheralMoisture: "Periphere Feuchte",
        roomTemperature: "Temperatur",
        roomHumidity: "rel. Feuchte",
        moistureLoad: "abs. Feuchte",
        deviceOutput: "Leistung",
        favorableWeather: "Lüften",
      },
    },
    timeline: {
      stationary: "Stationär",
      dry: "Trocknen",
    },
    noAiModel: "Kein KI-Modell",
  },
  mira: {
    exceptions: {
      leftOut: "{0} als Ausnahme ausgelassen",
    },
    landing: {
      comingSoon: "Detailansicht folgt",
      available: "1 Kennzahl verfügbar | {n} Kennzahlen verfügbar",
      waiting: "1 wartet auf Daten | {n} warten auf Daten",
      ratioLong: "{0} von {1} Kennzahlen",
      settings: {
        open: "Einstellungen",
        title: "{0}: Kennzahlen",
        editTitle: "{0}: Kennzahlen bearbeiten",
        availableHeading: "Verfügbare Kennzahlen",
        waitingHeading: "Was weitere Kennzahlen freischaltet",
        defaultChoice: "Die Kachel zeigt die ersten {0} Kennzahlen dieses Bereichs.",
        ownChoice: "Die Kachel zeigt nur die gewählten Kennzahlen.",
        hint: "Klicke die Kennzahlen in der Reihenfolge an, in der sie auf der Kachel stehen sollen (höchstens {0}). Ein zweiter Klick nimmt eine wieder heraus.",
        reset: "Standard",
        saved: "Auswahl gespeichert",
        saveError: "Die Auswahl konnte nicht gespeichert werden.",
      },
      descriptions: {
        businessDevelopment: "Projekte, Projektdauer, Abschlussarten und Reaktionszeit",
        processFlow: "Wie lange die Schritte eines Auftrags dauern und wo gewartet wird",
        hydry: "Trocknungsdauer, Pausen, Messfrequenz und Trocknungsfläche",
        devices: "Gerätetage, Betriebsstunden, Stromverbrauch und Flottenauslastung",
        insurance: "Freigabedauer, Annahmequote und freigegebene Trocknungsdauer",
        dataQuality: "Wie vollständig deine Projekte und Geräte erfasst sind",
      },
    },
    unlock: {
      title: "Mehr Kennzahlen freischalten",
      waiting: "1 Kennzahl wartet auf deine Daten | {n} Kennzahlen warten auf deine Daten",
      allUnlocked: "Alle Kennzahlen sind freigeschaltet",
      showAll: "Alle anzeigen",
      parts: {
        RECORD: {
          title: "Was du erfassen kannst",
          subtitle: "Je vollständiger diese Angaben, desto mehr Kennzahlen siehst du.",
        },
        CASES: {
          title: "Kommt mit mehr Fällen",
          subtitle: "Hier musst du nichts tun: die Kennzahl erscheint, sobald genug Fälle zusammenkommen.",
        },
      },
      shareProgress: "{0} erfasst · ab {1} sichtbar",
      countProgress: "{0} von {1} nötigen Fällen",
      casesInstruction: "Wird sichtbar, sobald im Zeitraum mindestens {0} Fälle zusammenkommen.",
    },
    periods: {
      rolling12: "Letzte 12 Monate",
      ytd: "Dieses Jahr",
      quarter: "Q{0} {1}",
      groups: {
        rolling: "Zeitraum",
        months: "Monate",
        quarters: "Quartale",
        years: "Jahre",
      },
    },
    baseline: {
      heading: "Vergleichen mit",
      previous: "Vorherige Periode",
      previous12: "Letzte 12 Monate",
      comparedWith: "Verglichen mit: {0} ({1} bis {2})",
      scaledNote: "Summen auf die Länge des Zeitraums umgerechnet",
    },
    sections: {
      businessDevelopment: "Geschäftsentwicklung",
      processFlow: "Prozess",
      hydry: "Trocknung",
      devices: "Geräte",
      insurance: "Versicherungen",
      dataQuality: "Datenqualität",
    },
    format: {
      hours: "{0} Std.",
      percent: "{0} %",
      percentBelow: "< {0} %",
      percentAbove: "> {0} %",
      deltaPoints: "{0} PP",
      others: "Weitere ({0})",
      spread: "P15 {0} · P85 {1}",
      median: "Median {0}",
    },
    allClients: {
      label: "Alle Mandanten",
    },
    periodTooltip: "Zeitraum",
    edition: "{0} · Aus der Werkstatt · {1}",
    comparison: {
      upwardTooltip: "Vergleich nach oben",
      downwardTooltip: "Vergleich nach unten",
      saved: {
        manage: "Vergleiche verwalten …",
        create: "Neuer Vergleich",
        editTitle: "Vergleich bearbeiten",
        reset: "Zurücksetzen",
        kindLabel: "Vergleich von",
        kinds: {
          BRANCHES: "Standorte",
          MEMBERS: "Mandanten",
          INSURERS: "Versicherer",
        },
        max: "Höchstens {0} Vergleiche: lösche einen, um einen neuen anzulegen.",
        nameRequired: "Gib dem Vergleich einen Namen.",
        saved: "Vergleich gesichert",
        deleted: "Vergleich gelöscht",
        saveError: "Der Vergleich konnte nicht gesichert werden.",
        deleteTitle: "Vergleich löschen",
        deleteMessage: "Willst du den Vergleich \"{0}\" wirklich löschen?",
        listTitle: "Vergleiche",
        empty: "Du hast noch keinen Vergleich angelegt. Lege einen an und wähle aus, womit du dich vergleichen willst.",
        hint: {
          BRANCHES: "Klicke die Standorte in der Reihenfolge an, in der ihre Balken stehen sollen, höchstens {0}.",
          MEMBERS: "Klicke die Mandanten in der Reihenfolge an, in der ihre Balken stehen sollen, höchstens {0}.",
          INSURERS: "Klicke die Versicherer in der Reihenfolge an, in der ihre Balken stehen sollen, höchstens {0}.",
        },
        noCandidates: {
          BRANCHES: "Dieser Mandant hat keine Standorte.",
          MEMBERS: "Diese Gruppe hat keine Mandanten.",
          INSURERS: "Für diesen Mandanten gibt es keine Versicherer mit genug Projekten.",
        },
      },
      choice: "Vergleich: {0}",
      cardTitle: "{0} nach Mandant",
      referenceGroup: "Gruppe gesamt",
      markers: "P15 {0} · Median {1} · P85 {2}",
      markersLegend: "Linien: {0}, über die Projekte der ersten Zeile",
      withoutValue: "Ohne Wert: {0}",
      membersSuffix: "über {0} von {1} Betrieben",
      membershipAssumed: "Gruppe in der Zusammensetzung vom {0}: frühere Wechsel sind nicht erfasst.",
      showAll: "Alle anzeigen",
      showLess: "Weniger anzeigen",
      empty: "Kein Mandant der Gruppe hat für diese Kennzahl einen Wert im Zeitraum.",
      cardTitleBranches: "{0} nach Standort",
      cardTitleInsurers: "{0} nach Versicherer",
      emptyInsurers: "Kein Versicherer hat für diese Kennzahl einen Wert im Zeitraum.",
      insurerOther: "Weitere Versicherer",
      cardTitleGroupView: "{0} in der Gruppe",
      emptyBranches: "Kein Standort hat für diese Kennzahl einen Wert im Zeitraum.",
      groupView: {
        withheld: "Zu wenige Betriebe oder Fälle: {0}",
        empty: "Für diese Kennzahl gibt es keinen Gruppenwert.",
      },
      noMetricForBranches: "Für diese Kennzahl gibt es keinen Vergleich nach Standort.",
      noMetricForInsurers: "Für diese Kennzahl gibt es keinen Vergleich nach Versicherer.",
      referenceClient: "Gesamt",
      branchNone: "Ohne Standort",
      branchOther: "Weitere Standorte",
      branchUnknown: "Unbekannter Standort",
      headline: "{0}: {1}",
      modes: {
        NONE: "Kein Vergleich",
        MEMBERS: "Mandanten der Gruppe",
        BRANCHES: "Standorte im Mandanten",
        MARKET: "Markt",
        GROUP: "Gruppe",
        INSURERS: "Versicherer",
      },
    },
    market: {
      cardTitle: "{0} im Markt",
      tileCaption: "Markt {0}",
      tooFewCompanies: "Zu wenige Betriebe mit genug Fällen: {0}",
      empty: "Für diese Kennzahl gibt es keinen Marktwert.",
      entities: {
        projects: "Markt",
      },
    },
    trend: {
      title: "Verlauf: {0}",
      grains: {
        month: "Monat",
        quarter: "Quartal",
        year: "Jahr",
      },
      gapNote: "Lücken: zu wenige Fälle im Zeitraum, um einen Wert zu zeigen.",
      partialNote: "Hohler Punkt: das laufende Jahr, noch nicht vollständig.",
      scrollHint: "Frühere Zeiträume: zur Seite wischen.",
      bandNote: "Band: P15 bis P85, die mittleren 70 % der Fälle.",
      rangeNote: "{0} bis {1}, unabhängig vom gewählten Zeitraum",
      periodNote: "Grau hinterlegt: der gewählte Zeitraum.",
      medianLineNote: "Linie: Mittelwert · dünne Linie: Median",
      partialYear: "{0} (bis heute)",
      tooFew: "zu wenige",
      tooltipBasis: "über {0}",
      tooltipMedian: "Median {0}",
      noData: "Für diese Kennzahl gibt es im gewählten Verlauf keine Daten.",
    },
    units: {
      projects: "{0} Projekte",
      projectsOne: "1 Projekt",
      dryings: "{0} Trocknungen",
      dryingsOne: "1 Trocknung",
      assignments: "{0} Zuordnungen",
      assignmentsOne: "1 Zuordnung",
      assignmentsWithReading: "{0} Zuordnungen mit Zählerstand",
      assignmentsWithReadingOne: "1 Zuordnung mit Zählerstand",
      readings: "{0} Zählerablesungen",
      readingsOne: "1 Zählerablesung",
      offers: "{0} Angebote",
      offersOne: "1 Angebot",
      answers: "{0} Antworten",
      answersOne: "1 Antwort",
      deviceDays: "{0} Gerätetage",
      deviceDaysOne: "1 Gerätetag",
      devices: "{0} Geräte",
      devicesOne: "1 Gerät",
    },
    stacked: {
      tooltipTotal: "Gesamt {0}",
      restNote: "{0} weitere in der Rangliste darunter",
      barFloorNote: "Balken mit weniger als {0} Fällen sind ausgeblendet.",
    },
    levels: {
      best: "Bester",
      worst: "Schlechtester",
      highest: "Höchster",
      lowest: "Niedrigster",
      note: "Je Zeitraum über alle mit einem Wert: die beiden äußeren Werte und die Marken bei 25 %, 50 % und 75 % dazwischen. Die Marken teilen die Vergleichspartner, nicht den Wert; jeder Balken ist der Wert eines Vergleichspartners. Jeder einzelne steht in der Rangliste darunter.",
      namesFor: "In Klammern: wer im Zeitraum {0} an der Stelle steht.",
    },
    caveat: {
      weakestFieldWithGaps: "Der Wert ist das am schwächsten erfasste Feld. Versicherung, Trocknungsfläche und Projektleiter werden hier noch nicht geprüft.",
      routeRecordedSince2025: "Die Erfassungsquelle wird erst seit 2025 gespeichert.",
    },
    dataQuality: {
      title: "Datenqualität",
      noData: "Für deine Firma liegen noch keine Mira-Auswertungen vor.",
      loadError: "Die Mira-Auswertungen konnten nicht geladen werden.",
      noValue: "Keine Daten im Zeitraum",
      periodRange: "{0}: {1} bis {2}",
      generatedAt: "Stand: {0}",
      weakestField: "Am schwächsten erfasst: {0}",
      energyCaption: "von {0} beendeten Zuordnungen von Geräten mit eigenem Zähler",
      insurerCaptureCaption: "über {0} Projekte ohne Direktauftrag",
      fieldsTitle: "Feldabdeckung je Feld",
      fieldsSubtitle: "über {0} Projekte, schwächstes Feld zuerst",
      energyTitle: "Zählerstände",
      energyRingCaption: "mit Zählerständen",
      energySubtitle: "wie die beendeten Zuordnungen von Geräten mit eigenem Zähler erfasst sind",
      status: {
        good: "Gut erfasst",
        warning: "Lückenhaft",
        critical: "Zu wenig erfasst",
      },
      legend: {
        good: "ab 80 %",
        warning: "40 bis 79 %",
        critical: "unter 40 %: davon abhängige Kennzahlen bleiben ausgeblendet",
      },
      fields: {
        branch: "Standort",
        projectTypeId: "Projekttyp",
        damageDay: "Schadentag",
        outcomeState: "Ergebnis der Schadenaufnahme",
        rooms: "Räume im Schadenbild",
        timeline: "Beginn und Ende",
        timeEntries: "Zeiteinträge am Projekt",
      },
      energy: {
        withReading: "Mit Zählerständen",
        unknownReading: "Ohne Zählerstand",
        invalidReading: "Zählerstand ungültig",
        implausibleReading: "Verbrauch unplausibel hoch",
        onImplausibleProject: "{0} davon liegen auf Projekten mit unplausibel hohem Verbrauch; sie sind oben mitgezählt.",
      },
      unlocks: {
        title: "Was weitere Kennzahlen freischaltet",
        description: "Diese Kennzahlen bleiben im gewählten Zeitraum ausgeblendet, bis genug erfasst ist.",
        none: "Im gewählten Zeitraum fehlen für keine Kennzahl erfasste Daten.",
        fallback: "Zu wenig erfasste Daten im Zeitraum.",
      },
    },
    drying: {
      title: "Trocknung",
      families: {
        box: "Box",
        mini: "Mini",
        panel: "Panel",
      },
      units: {
        day: "{0} Tag",
        days: "{0} Tage",
        squareMetres: "{0} m²",
        perWeek: "{0} pro Woche",
        perProject: "{0} pro Projekt",
      },
      captions: {
        dryingTime: "{0} · über {1} Trocknungen ({2})",
        pauseShare: "{0} · über {1} Trocknungen ({2})",
        dryingsWithoutFamily: "{0} · über {1} Trocknungen",
        projectDryingTime: "{0} · über {1} Projekte",
        projectPauseShare: "{0} · über {1} Projekte",
        measurementFrequency: "über {1} Trocknungen, {0} davon ohne Zwischenmessung",
        measurementsPerProject: "über {1} Projekte, {0} davon ohne Zwischenmessung",
        dryingArea: "{0} · über {1} Projekte",
        forecast: "im Mittel über der Prognose · über {1} Trocknungen, {0} davon länger als geplant",
      },
      cards: {
        dryingTime: "HyDry-Trocknungsdauer je Gerätetyp",
        dryingTimeSubtitle: "Programmketten ohne Projekt ab 4 Stunden, Mittelwert und Median",
        pauseShare: "Pausenanteil je Gerätetyp",
        pauseShareSubtitle: "Pausen als Anteil der Trocknungszeit, Trocknungen ohne Projekt",
        measurementFrequency: "Messfrequenz",
        measurementFrequencySubtitle: "Messreihen pro Woche Trocknung, ohne die Messreihen bei Trocknungsaufbau und -abbau",
        measurementsPerProject: "Zwischenmessungen je Projekt",
        measurementsPerProjectSubtitle: "Zwischenmessungen je getrocknetem Projekt mit einer Messung beim Trocknungsaufbau",
        dryingArea: "Trocknungsfläche",
        dryingAreaSubtitle: "mittlere Fläche je getrocknetem Projekt",
        forecast: "Prognose und tatsächliche Trocknungsdauer",
        forecastSubtitle: "wie oft und wie weit Trocknungen die Prognose überschreiten",
      },
      dotPlot: {
        mean: "Mittelwert",
        median: "Median",
        count: "Trocknungen",
      },
      shortChains: "{0} Programmketten unter 4 Stunden sind nicht mitgezählt.",
      shareWithPause: "{0} mit Pause",
      pause: {
        dryingPause: "Trocknungspause",
        powerCut: "Stromausfall",
      },
      measurementGroups: {
        hydry: "Mit HyDry-Geräten ({0})",
        conventional: "Nur konventionelle Geräte ({0})",
        noDevices: "Ohne Gerätezuordnung ({0})",
      },
      area: {
        floor: "Boden",
        wallCeiling: "Wand / Decke",
      },
      forecast: {
        overForecast: "Länger als geplant",
      },
      facts: {
        median: "Median",
        withoutArea: "Projekte ohne Fläche",
        meanOverrun: "Im Mittel über der Prognose",
        fromDefault: "Prognose vom Standardwert übernommen",
        noForecast: "Ohne Prognose",
        noActual: "Ohne tatsächliche Dauer",
      },
      inPreparation: "In Vorbereitung: {0}",
    },
    devices: {
      title: "Geräte",
      controlParts: {
        box: "Box",
        mini: "Mini",
        both: "beide",
        none: "keins",
      },
      fleets: {
        own: "Eigene Geräte",
      },
      units: {
        kWh: "{0} kWh",
        kWhPerDay: "{0} kWh/Tag",
        kWhPerSquareMetre: "{0} kWh/m²",
        MWh: "{0} MWh",
        hours: "{0} h",
      },
      captions: {
        fleet: "{0} · größte Flotte",
        energy: "über {0} Zuordnungen mit Zählerstand",
        energyLeftOut: "über {0} Zuordnungen mit Zählerstand · {1} Projekte nicht gezählt",
        energyPerProject: "{0} · über {1} Projekte",
        energyPerDryingDay: "{0} · über {1} Projekte",
        energyPerArea: "{0} · über {1} Projekte",
        partialReadings: "{0} mit unvollständigen Zählerständen",
        deviceDays: "über {0} Zuordnungen",
        devicesPerProject: "{0} · über {1} Projekte mit Trocknungsgeräten",
        controlDevicesPerProject: "{0} · über {1} Projekte mit Box oder Mini",
        controlProjectShare: "{0} von {1} abgeschlossenen Projekten",
        hydryControlLine: "HyDry Control: {0} je Projekt mit Box oder Mini ({1})",
        operatingHours: "über {0} Zählerablesungen",
        operatingHoursDerivedOnly: "nur aus der Zuordnungsdauer: {0}",
      },
      cards: {
        categoryMix: "Gerätetage je Kategorie",
        categoryMixSubtitle: "Anteil an allen Gerätetagen deiner eigenen Geräte",
        energy: "Stromverbrauch",
        energySubtitle: "Geräte mit eigenem Stromzähler, in kWh",
        operatingHours: "Betriebsstunden",
        operatingHoursSubtitle: "abgelesene Zähler und Stunden aus der Zuordnungsdauer, nie zusammengezählt",
      },
      facts: {
        daysInUse: "{0} von {1} Tagen",
        total: "Gesamt",
        perProject: "Ø je Projekt",
        leftOutOfTotal: "Projekte nicht im Gesamtwert (unplausibler Verbrauch)",
        leftOutOfAverage: "Projekte nicht im Durchschnitt (über 120 kWh pro Tag)",
        counterHours: "Abgelesene Betriebsstunden",
        derivedConfirmed: "Aus der Zuordnungsdauer, bestätigt",
        derivedUnconfirmed: "Aus der Zuordnungsdauer, unbestätigt",
        implausibleReadings: "Unplausible Ablesungen, nicht gezählt",
      },
      unknownCategory: "Unbekannte Kategorie",
    },
    businessDevelopment: {
      title: "Geschäftsentwicklung",
      captions: {
        projects: "abgeschlossen im Zeitraum",
        duration: "{0} · über {1} abgeschlossene Projekte",
        rooms: "{0} · über {1} Projekte",
        reactionTime: "{0} · über {1} Projekte mit Schadentag",
        rejections: "{0} von {1} Projekten mit Entscheidung",
      },
      cards: {
        outcomes: "Abschlussarten",
        outcomesSubtitle: "Ergebnis der Schadenaufnahme je Projekt",
        outcomesRingCaption: "mit Ergebnis",
        branches: "Projekte je Standort",
        branchesSubtitle: "Anteil an allen Projekten mit Standort",
        projectTypes: "Projekttyp-Mix",
        projectTypesSubtitle: "Anteil an allen Projekten mit Projekttyp",
        damageCauses: "Schadenursachen",
        damageCausesSubtitle: "{0} von {1} in IRES Project abgeschlossenen Projekten mit Schadenursache; ein Projekt mit mehreren Ursachen zählt bei jeder",
        damageCausesMarketSubtitle: "Anteil der Projekte mit Schadenursache ({0} bei dir); ein Projekt mit mehreren Ursachen zählt bei jeder, daher zusammen über 100 %",
        damageCausesMore: "Weitere Ursachen: {0}",
      },
      facts: {
        rejections: "Ablehnungen",
        rejectedOf: "{0} von {1} ({2})",
        noRejections: "keine im Zeitraum",
      },
      unknownBranch: "Unbekannter Standort",
      unknownProjectType: "Unbekannter Projekttyp",
      unknownDamageCause: "Unbekannte Ursache",
      services: {
        title: "Leistungen",
        caption: "Ein Projekt zählt in jeder Leistung, die im Zeitraum abgeschlossen wurde.",
        leakDetection: "Leckortung",
        damageAssessment: "Schadenaufnahme",
        drying: "Trocknung",
        repair: "Wiederherstellung",
      },
    },
    insurance: {
      title: "Versicherungen",
      captions: {
        approval: "{0} · über {1} Angebote",
        acceptance: "{0} von {1} Antworten angenommen",
        overrun: "{0} · über {1} Trocknungen mit angenommenem Angebot",
        directOrders: "{0} von {1} Projekten mit Angabe",
      },
      cards: {
        answers: "Antworten der Versicherung",
        answersSubtitle: "auf die Angebote aus IRES Project, nach dem Monat der Antwort",
        approval: "Freigabe und Trocknung",
        approvalSubtitle: "Trocknungen mit angenommenem Angebot, nach dem Monat des Projektendes",
      },
      parts: {
        accepted: "Angenommen",
        rejected: "Abgelehnt",
      },
      bars: {
        overApproved: "Länger getrocknet als freigegeben",
        cut: "Weniger Tage freigegeben als beantragt",
      },
      facts: {
        recordedTogether: "Mit dem Angebot zusammen erfasst (ohne Freigabedauer)",
        implausibleDates: "Unmögliche Datumsangaben",
        meanOverrun: "Ø über der Freigabe",
        medianOverrun: "Median über der Freigabe",
        noApprovedDays: "Ohne freigegebene Trocknungsdauer",
        noActual: "Ohne tatsächliche Trocknungsdauer",
      },
      insurer: {
        card: "Versicherer",
        cardSubtitle: "Anteil der im Zeitraum abgeschlossenen Projekte",
        insurersHeading: "Je Versicherer: Anteil der {0} Projekte mit Versicherung",
        others: "Weitere Versicherer",
        unidentified: "nicht identifiziert",
        cases: {
          insured: "Mit Versicherung",
          noInfo: "Keine Angabe",
          direct: "Direktauftrag",
        },
      },
    },
    processFlow: {
      title: "Prozess",
      captions: {
        transition: "{0} · über {1} Projekte",
      },
      groups: {
        order: "Auftrag und Aufnahme",
        drying: "Freigabe und Trocknung",
        restoration: "Wiederherstellung und Abschluss",
      },
      cards: {
        order: "Reihenfolge der Projektschritte",
        routes: "Erfassungsquelle",
        routesSubtitle: "womit die Projektschritte erfasst wurden",
      },
      routes: {
        viaApp: "IRES Project",
        viaErp: "ERP-System",
        viaPortal: "IRES Office",
      },
      facts: {
        noRoute: "Schritte ohne Quelle",
      },
      stack: {
        title: "Projektablauf",
        caption: "Über {0} Projekte mit allen Schritten · {1} nicht in Reihenfolge, nicht gezählt",
        insuranceHeader: "Mit Versicherungsfreigabe ({0} Projekte)",
        damageToApproval: "Schadenaufnahme bis Freigabe",
        approvalToSetup: "Freigabe bis Trocknungsaufbau",
        stages: {
          toDamageAssessment: "Bis Schadenaufnahme",
          toDryingSetup: "Bis Trocknungsaufbau",
          drying: "Trocknung",
          toProjectEnd: "Bis Projektende",
        },
      },
    },
    metrics: {
      "MIRA-PRJ-003": {
        title: "Abschlussarten-Mix",
        unlock: "Schließe die Schadenaufnahme mit ihrem Ergebnis ab.",
      },
      "MIRA-PRJ-006": {
        title: "Projekte je Standort",
        unlock: "Ordne jedem Projekt einen Standort zu.",
      },
      "MIRA-PRJ-007": {
        title: "Projekttyp-Mix",
        unlock: "Wähle bei jedem Projekt den Projekttyp.",
      },
      "MIRA-PRJ-008": {
        title: "Reaktionszeit (Schaden bis Projektstart)",
        unlock: "Trage bei jedem Projekt den Schadentag ein.",
      },
      "MIRA-PRJ-011": {
        title: "Anzahl Räume (Projektgröße)",
        unlock: "Lege in der Schadenaufnahme die betroffenen Räume an.",
      },
      "MIRA-PRJ-012": {
        title: "Gebäudetyp-Mix",
        unlock: "Gib in der Beschreibung das Objekt / Gebäude an.",
      },
      "MIRA-PRJ-013": {
        title: "Schadenursachen",
        unlock: "Gib in der Schadenaufnahme die Schadenursache an.",
      },
      "MIRA-PRJ-015": {
        title: "Objekt-Merkmale",
        unlock: "Fülle in der Beschreibung die Objekt-Merkmale aus.",
      },
      "MIRA-PRJ-016": {
        title: "Regulierer-Mix",
        unlock: "Gib bei jedem Projekt die Reguliererart an.",
      },
      "MIRA-PHA-001": {
        title: "Phasendauer",
        unlock: "Starte jede Phase im Projektverlauf und schließe sie ab.",
      },
      "MIRA-PHA-002": {
        title: "Wartezeit zwischen Phasen",
        unlock: "Schließe jede Phase ab und starte die nächste im Projektverlauf.",
      },
      "MIRA-PHA-003": {
        title: "Dauer bis zur Schadenaufnahme",
        unlock: "Erfasse bei jedem Projekt die Kontaktaufnahme (K1).",
      },
      "MIRA-PHA-004": {
        title: "Dauer bis zur Gerätezuordnung",
        unlock: "Ordne die aufgestellten Geräte dem Projekt zu.",
      },
      "MIRA-PHA-006": {
        title: "Dauer bis zur Wiederherstellung",
        unlock: "Zu wenige Projekte mit Wiederherstellung im Zeitraum. Die Kennzahl erscheint, sobald genug zusammenkommen.",
      },
      "MIRA-PHA-010": {
        title: "Erfassungsquelle je Phase",
        unlock: "Die Erfassungsquelle wird erst seit 2025 gespeichert, für ältere Zeiträume fehlt sie.",
      },
      "MIRA-PHA-011": {
        title: "Projektablauf",
        unlock: "Schließe bei jedem Projekt Schadenaufnahme, Trocknungsaufbau, Trocknungsende und Projektende der Reihe nach ab.",
      },
      "MIRA-PHA-012": {
        title: "Projektstart bis Auftrag",
        unlock: "Zu wenige abgeschlossene Projekte mit beiden Schritten im Zeitraum. Die Kennzahl erscheint, sobald genug zusammenkommen.",
      },
      "MIRA-PHA-013": {
        title: "Auftrag bis Leckortung / Schadenaufnahme",
        unlock: "Zu wenige abgeschlossene Projekte mit beiden Schritten im Zeitraum. Die Kennzahl erscheint, sobald genug zusammenkommen.",
      },
      "MIRA-PHA-014": {
        title: "Leckortung bis Schadenaufnahme",
        unlock: "Zu wenige abgeschlossene Projekte mit beiden Schritten im Zeitraum. Die Kennzahl erscheint, sobald genug zusammenkommen.",
      },
      "MIRA-PHA-015": {
        title: "Schadenaufnahme bis Trocknungsbeginn",
        unlock: "Zu wenige abgeschlossene Projekte mit beiden Schritten im Zeitraum. Die Kennzahl erscheint, sobald genug zusammenkommen.",
      },
      "MIRA-PHA-016": {
        title: "Schadenaufnahme bis Freigabe",
        unlock: "Zu wenige abgeschlossene Projekte mit beiden Schritten im Zeitraum. Die Kennzahl erscheint, sobald genug zusammenkommen.",
      },
      "MIRA-PHA-017": {
        title: "Freigabe bis Trocknungs- / Wiederherstellungsbeginn",
        unlock: "Zu wenige abgeschlossene Projekte mit beiden Schritten im Zeitraum. Die Kennzahl erscheint, sobald genug zusammenkommen.",
      },
      "MIRA-PHA-018": {
        title: "Trocknungsdauer",
        unlock: "Zu wenige abgeschlossene Projekte mit beiden Schritten im Zeitraum. Die Kennzahl erscheint, sobald genug zusammenkommen.",
      },
      "MIRA-PHA-019": {
        title: "Trocknungsende bis Wiederherstellungsabschluss",
        unlock: "Zu wenige abgeschlossene Projekte mit beiden Schritten im Zeitraum. Die Kennzahl erscheint, sobald genug zusammenkommen.",
      },
      "MIRA-PHA-020": {
        title: "Wiederherstellungsdauer",
        unlock: "Zu wenige abgeschlossene Projekte mit beiden Schritten im Zeitraum. Die Kennzahl erscheint, sobald genug zusammenkommen.",
      },
      "MIRA-PHA-021": {
        title: "Bis Projektabschluss",
        unlock: "Zu wenige abgeschlossene Projekte mit beiden Schritten im Zeitraum. Die Kennzahl erscheint, sobald genug zusammenkommen.",
      },
      "MIRA-PHA-022": {
        title: "Auftrag bis Trocknungsbeginn",
        unlock: "Zu wenige abgeschlossene Projekte mit beiden Schritten im Zeitraum. Die Kennzahl erscheint, sobald genug zusammenkommen.",
      },
      "MIRA-PRJ-017": {
        title: "Leistungen",
        unlock: "Schließe bei jedem Projekt die erbrachten Leistungen ab.",
      },
      "MIRA-DRY-001": {
        title: "Ø Trocknungsdauer ohne Projekt (HyDry)",
        unlock: "Zu wenige HyDry-Trocknungen ohne Projekt mit bekanntem Beginn und Ende im Zeitraum.",
      },
      "MIRA-DRY-002": {
        title: "Pausenanteil ohne Projekt (HyDry)",
        unlock: "Zu wenige HyDry-Trocknungen ohne Projekt mit vollständig bekannten Pausen im Zeitraum.",
      },
      "MIRA-DRY-003": {
        title: "Ø Trocknungsdauer konventionell",
        unlock: "Zu wenige abgeschlossene Projekte, die nur mit eigenen Geräten getrocknet wurden. Ordne die Geräte für die tatsächliche Trocknungsdauer zu.",
      },
      "MIRA-DRY-009": {
        title: "Ø Trocknungsdauer je Projekt (HyDry)",
        unlock: "Zu wenige abgeschlossene Projekte, die mit HyDry-Geräten getrocknet wurden. Ordne die Geräte mit Beginn und Ende dem Projekt zu.",
      },
      "MIRA-DRY-010": {
        title: "Ø Trocknungsdauer je Projekt (konventionell)",
        unlock: "Zu wenige abgeschlossene Projekte, die nur mit konventionellen Geräten getrocknet wurden. Ordne die Geräte mit Beginn und Ende dem Projekt zu.",
      },
      "MIRA-DRY-011": {
        title: "Pausenanteil je Projekt (HyDry)",
        unlock: "Zu wenige abgeschlossene HyDry-Projekte mit vollständig bekannten Pausen im Zeitraum.",
      },
      "MIRA-DRY-005": {
        title: "Messfrequenz",
        unlock: "Erfasse im Messprotokoll die Messung beim Trocknungsaufbau und beim Trocknungsabbau.",
      },
      "MIRA-DRY-012": {
        title: "Zwischenmessungen je Projekt",
        unlock: "Erfasse im Messprotokoll die Messung beim Trocknungsaufbau.",
      },
      "MIRA-DRY-007": {
        title: "Ø Trocknungsfläche",
        unlock: "Erfasse in der Schadenaufnahme die betroffenen Bauteile mit ihrer Fläche.",
      },
      "MIRA-DRY-008": {
        title: "Prognose und tatsächliche Trocknungsdauer",
        unlock: "Trage die Prognose der Trocknungsdauer ein und ordne die Geräte dem Projekt zu.",
      },
      "MIRA-DEV-001": {
        title: "Gerätetage",
        unlock: "Ordne die Geräte mit Beginn und Ende dem Projekt zu.",
      },
      "MIRA-DEV-002": {
        title: "Betriebsstunden",
        unlock: "Erfasse beim Abbau anderer Geräte die Betriebsstunden.",
      },
      "MIRA-DEV-003": {
        title: "Geräte je Projekt",
        unlock: "Ordne die eingesetzten Geräte den Projekten zu.",
      },
      "MIRA-DEV-015": {
        title: "HyDry Control je Projekt",
        unlock: "Zu wenige abgeschlossene Projekte mit einer Box oder einem Mini im Zeitraum.",
      },
      "MIRA-DEV-016": {
        title: "Projekte mit HyDry Control",
        unlock: "Ordne die eingesetzten Geräte den Projekten zu.",
      },
      "MIRA-DEV-017": {
        title: "Geräte je Projekt (Betriebe mit eigenen Geräten)",
      },
      "MIRA-DEV-018": {
        title: "Geräte je Projekt (nur HyDry)",
      },
      "MIRA-DEV-004": {
        title: "Stromverbrauch",
        unlock: "Erfasse beim Auf- und Abbau die Zählerstände der Geräte.",
      },
      "MIRA-DEV-005": {
        title: "Ø Stromverbrauch je Projekt",
        unlock: "Zu wenige Projekte mit vollständigen Zählerständen im Zeitraum.",
      },
      "MIRA-DEV-006": {
        title: "Flottenauslastung",
        unlock: "Zu wenig Daten zu deinem Gerätebestand im Zeitraum.",
      },
      "MIRA-DEV-011": {
        title: "Flottenauslastung Box",
        unlock: "Zu wenig Daten zu deinen Boxen im Zeitraum.",
      },
      "MIRA-DEV-012": {
        title: "Flottenauslastung Mini",
        unlock: "Zu wenig Daten zu deinen Minis im Zeitraum.",
      },
      "MIRA-DEV-013": {
        title: "Flottenauslastung Panel",
        unlock: "Zu wenig Daten zu deinen Panels im Zeitraum.",
      },
      "MIRA-DEV-014": {
        title: "Flottenauslastung eigene Geräte",
        unlock: "Zu wenig Daten zu deinen eigenen Geräten im Zeitraum.",
      },
      "MIRA-DEV-009": {
        title: "Ø Stromverbrauch je Trocknungstag",
        unlock: "Zu wenige Projekte mit vollständigen Zählerständen im Zeitraum.",
      },
      "MIRA-DEV-010": {
        title: "Stromverbrauch je m² Trocknungsfläche",
        unlock: "Zu wenige abgeschlossene Projekte mit Trocknungsfläche und Zählerständen im Zeitraum.",
      },
      "MIRA-DEV-008": {
        title: "Kategorie- / Template-Mix",
        unlock: "Gib deinen Geräten eine gültige Kategorie und ein gültiges Template.",
      },
      "MIRA-INS-001": {
        title: "Projekte je Versicherung",
      },
      "MIRA-INS-002": {
        title: "Ø Projektdauer je Versicherung",
      },
      "MIRA-INS-003": {
        title: "Zuordnungsquote der Versicherungen",
        unlock: "Gib bei jedem Projekt die Versicherung an.",
      },
      "MIRA-INS-004": {
        title: "Freigabedauer",
        unlock: "Zu wenige Angebote mit einer Antwort der Versicherung im Zeitraum.",
      },
      "MIRA-INS-005": {
        title: "Angebotsannahmequote",
        unlock: "Zu wenige Angebote mit einer Antwort der Versicherung im Zeitraum.",
      },
      "MIRA-INS-006": {
        title: "Freigegebene und tatsächliche Trocknungsdauer",
        unlock: "Zu wenige angenommene Angebote mit freigegebener Trocknungsdauer im Zeitraum.",
      },
      "MIRA-INS-008": {
        title: "Direktaufträge",
        unlock: "Erfasse am Projekt den Direktauftrag.",
      },
      "MIRA-DQ-001": {
        title: "Feldabdeckung",
      },
      "MIRA-DQ-002": {
        title: "Messwertabdeckung Strom",
      },
      "MIRA-PRJ-001": {
        title: "Projekte",
      },
      "MIRA-PRJ-002": {
        title: "Ø Projektdauer",
      },
      "MIRA-PRJ-004": {
        title: "Ablehnungsquote",
      },
      "MIRA-PHA-005": {
        title: "Dauer bis Trocknungsabbau",
      },
      "MIRA-PHA-007": {
        title: "Dauer bis Projektabschluss",
      },
      "MIRA-DRY-004": {
        title: "HyDry-Vorteil gegenüber konventioneller Trocknung",
      },
      "MIRA-DRY-006": {
        title: "Trocknungserfolg",
      },
    },
  },
  maps: {
    city: "Ort",
    postalCode: "PLZ",
    street: "Straße",
    houseNumber: "Hausnummer",
    result: "Ergebnis",
    start: "Start",
    destination: "Ziel",
    deleteMarkers: "Marker löschen",
    deleteRoutes: "Routen löschen",
    geocode: "Adresse suchen",
    showRoute: "Route anzeigen",
    noAddress: "Gib bitte mindestens Ort, Straße oder PLZ ein.",
    geocodingFailed: "Adresse konnte nicht gefunden werden.",
    routeMissingAddresses: "Bitte Start und Ziel eingeben.",
    routeFailed: "Route konnte nicht berechnet werden.",
    distance: "Entfernung",
    duration: "Fahrzeit",
  },
  timeTrackingHistory: {
    dayEntries: "Tageseinträge",
    noEntries: "Keine Einträge für diesen Tag.",
    selectDayHint: "Bitte wählen Sie einen Tag im Kalender aus.",
    daySummary: "Tagesübersicht",
    dayClosed: "Tag abgeschlossen",
    dayOpen: "Tag offen",
    today: "Heute",
    projectWork: "Projektarbeit",
    projectTime: "Projektzeit",
    activeProjectEntries: "Aktives Projekt – Einträge",
    lastProjectEntries: "Letztes Projekt – Einträge",
    projectEntries: "Projekt – Einträge",
    backToActiveProject: "Zurück zum aktiven Projekt",
    backToLastProject: "Zurück zum letzten Projekt",
    noProjectEntries: "Keine Projekteinträge vorhanden.",
    loadingProjectEntries: "Lade Projekteinträge…",
    projectArchived: "Archiviert",
    projectDeleted: "Gelöscht",
    mergedEntriesTooltip: "Zusammengefasst aus {count} Einträgen",
    startOfDay: "Tagesbeginn",
    endOfDay: "Tagesende",
    columns: {
      time: "Uhrzeit",
      duration: "Dauer",
      description: "Beschreibung",
      timeRange: "Zeitraum",
      date: "Datum",
      phase: "Phase",
      project: "Projekt",
      user: "Benutzer",
      source: "Quelle",
    },
    phases: {
      damageAssessment: "Schadenaufnahme",
      leakDetection: "Leckortung",
      drying: "Trocknung",
      dryingPreparation: "Trocknungsaufbau",
      repair: "Wiederherstellung",
    },
    tasks: {
      orderEntry: "Kontakt aufnehmen",
      firstContact: "Kontaktaufnahme",
      leakDetection: "Leckortung",
      damageAssessment: "Schadenaufnahme",
      insuranceOffer: "Angebot an Versicherung",
      dryingApproval: "Freigabe Trocknung",
      dryingPreparation: "Trocknungsaufbau",
      intermediateMeasurement: "Messung",
      dryingConclusion: "Trocknungsabbau",
      repair: "Wiederherstellung",
      projectConclusion: "Projekt fertig",
    },
    travel: {
      toOffice: "Fahrt zum Büro",
      toHome: "Fahrt nach Hause",
      toProject: "Fahrt zu Adresse",
      approach: "Anfahrt",
    },
    autoContext: {
      prepareDrying: "Trocknung vorbereiten",
      finalMeasurement: "Endmessung",
      finalResubmission: "Endwiedervorlage",
      finalDrying: "Endtrocknung",
    },
    categories: {
      pause: "Pause",
      travelingTime: "Fahrzeit",
      internal: "Intern",
      other: "Sonstiges",
      general: "Allgemein",
      interruption: "Unterbrechung",
      silentInterruption: "Stille Unterbrechung",
    },
    summary: {
      totalTime: "Erfasste Zeit",
      workingTime: "Berechnete Arbeitszeit",
      travelTime: "Fahrzeit",
      projectTime: "Projektzeit",
      internalWork: "Interne Arbeiten",
      pause: "Pause",
      unexplained: "Nicht erklärt",
    },
    markerReasons: {
      overlapStart: "Startzeit überlappt mit einem anderen Eintrag.",
      overlapEnd: "Endzeit wird von einem anderen Eintrag überlappt.",
      dayClamped: "Wert wurde auf die Grenze des ausgewählten Tages begrenzt.",
      crossDay: "Eintrag erstreckt sich über mehrere Tage.",
      adjustedData: "Zeitstempel wurde aufgrund inkonsistenter Quelldaten angepasst.",
      mergedBoundary: "Die angezeigte Grenze stammt aus zusammengeführten benachbarten Einträgen (innerhalb der konfigurierten Merge-Lücke).",
    },
  },
  staleEntryAutoClose: {
    title: "Zeiteintrag automatisch abgeschlossen",
    subtitle: "Wir haben diese Aufgabe automatisch abgeschlossen, da von dir keine weitere Aktivität erfasst wurde.\nMöchtest du deine Endzeit anpassen?",
    projectEntryLabel: "Projektarbeit: {project}",
    projectEntryLabelFallback: "Projektarbeit",
    otherEntryLabel: "Allgemeiner Eintrag",
    proposedEndLabel: "Vorgeschlagene Endzeit",
    editHint: "Endzeit anpassen",
    accept: "Bestätigen",
    invalidTime: "Ungültige Uhrzeit.",
    successMessage: "Zeiteintrag wurde abgeschlossen.",
  },
};
